/* eslint-disable */
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetchData } from '../services/graphql/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  base64: any;
  date: string;
  float8: number;
  jsonb: any;
  timestamptz: Date;
  uuid: string;
};

/** columns and relationships of "access_token_signing_key" */
export type AccessTokenSigningKey = {
  __typename?: 'AccessTokenSigningKey';
  algorithm: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  key: Scalars['String'];
};

/** aggregated selection of "access_token_signing_key" */
export type AccessTokenSigningKeyAggregate = {
  __typename?: 'AccessTokenSigningKeyAggregate';
  aggregate?: Maybe<AccessTokenSigningKeyAggregateFields>;
  nodes: Array<AccessTokenSigningKey>;
};

/** aggregate fields of "access_token_signing_key" */
export type AccessTokenSigningKeyAggregateFields = {
  __typename?: 'AccessTokenSigningKeyAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccessTokenSigningKeyMaxFields>;
  min?: Maybe<AccessTokenSigningKeyMinFields>;
};


/** aggregate fields of "access_token_signing_key" */
export type AccessTokenSigningKeyAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccessTokenSigningKeySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "access_token_signing_key". All fields are combined with a logical 'AND'. */
export type AccessTokenSigningKeyBoolExp = {
  _and?: InputMaybe<Array<AccessTokenSigningKeyBoolExp>>;
  _not?: InputMaybe<AccessTokenSigningKeyBoolExp>;
  _or?: InputMaybe<Array<AccessTokenSigningKeyBoolExp>>;
  algorithm?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "access_token_signing_key" */
export enum AccessTokenSigningKeyConstraint {
  /** unique or primary key constraint on columns "id" */
  AccessTokenSigningKeyPkey = 'access_token_signing_key_pkey'
}

/** input type for inserting data into table "access_token_signing_key" */
export type AccessTokenSigningKeyInsertInput = {
  algorithm?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AccessTokenSigningKeyMaxFields = {
  __typename?: 'AccessTokenSigningKeyMaxFields';
  algorithm?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AccessTokenSigningKeyMinFields = {
  __typename?: 'AccessTokenSigningKeyMinFields';
  algorithm?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "access_token_signing_key" */
export type AccessTokenSigningKeyMutationResponse = {
  __typename?: 'AccessTokenSigningKeyMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccessTokenSigningKey>;
};

/** on_conflict condition type for table "access_token_signing_key" */
export type AccessTokenSigningKeyOnConflict = {
  constraint: AccessTokenSigningKeyConstraint;
  updateColumns?: Array<AccessTokenSigningKeyUpdateColumn>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};

/** Ordering options when selecting data from "access_token_signing_key". */
export type AccessTokenSigningKeyOrderBy = {
  algorithm?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: access_token_signing_key */
export type AccessTokenSigningKeyPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "access_token_signing_key" */
export enum AccessTokenSigningKeySelectColumn {
  /** column name */
  Algorithm = 'algorithm',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key'
}

/** input type for updating data in table "access_token_signing_key" */
export type AccessTokenSigningKeySetInput = {
  algorithm?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "access_token_signing_key" */
export type AccessTokenSigningKeyStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccessTokenSigningKeyStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessTokenSigningKeyStreamCursorValueInput = {
  algorithm?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
};

/** update columns of table "access_token_signing_key" */
export enum AccessTokenSigningKeyUpdateColumn {
  /** column name */
  Algorithm = 'algorithm',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key'
}

export type AccessTokenSigningKeyUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccessTokenSigningKeySetInput>;
  /** filter the rows which have to be updated */
  where: AccessTokenSigningKeyBoolExp;
};

/** columns and relationships of "account" */
export type Account = {
  __typename?: 'Account';
  id: Scalars['uuid'];
  /** An array relationship */
  otps: Array<Otp>;
  /** An aggregate relationship */
  otpsAggregate: OtpAggregate;
  provider: AuthProviderEnum;
  /** An array relationship */
  sessions: Array<Session>;
  /** An aggregate relationship */
  sessionsAggregate: SessionAggregate;
  /** An object relationship */
  user: User;
  userId: Scalars['uuid'];
};


/** columns and relationships of "account" */
export type AccountOtpsArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


/** columns and relationships of "account" */
export type AccountOtpsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


/** columns and relationships of "account" */
export type AccountSessionsArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};


/** columns and relationships of "account" */
export type AccountSessionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};

/** aggregated selection of "account" */
export type AccountAggregate = {
  __typename?: 'AccountAggregate';
  aggregate?: Maybe<AccountAggregateFields>;
  nodes: Array<Account>;
};

export type AccountAggregateBoolExp = {
  count?: InputMaybe<AccountAggregateBoolExpCount>;
};

/** aggregate fields of "account" */
export type AccountAggregateFields = {
  __typename?: 'AccountAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountMaxFields>;
  min?: Maybe<AccountMinFields>;
};


/** aggregate fields of "account" */
export type AccountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account" */
export type AccountAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountMaxOrderBy>;
  min?: InputMaybe<AccountMinOrderBy>;
};

/** input type for inserting array relation for remote table "account" */
export type AccountArrRelInsertInput = {
  data: Array<AccountInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountOnConflict>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type AccountBoolExp = {
  _and?: InputMaybe<Array<AccountBoolExp>>;
  _not?: InputMaybe<AccountBoolExp>;
  _or?: InputMaybe<Array<AccountBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  otps?: InputMaybe<OtpBoolExp>;
  otpsAggregate?: InputMaybe<OtpAggregateBoolExp>;
  provider?: InputMaybe<AuthProviderEnumComparisonExp>;
  sessions?: InputMaybe<SessionBoolExp>;
  sessionsAggregate?: InputMaybe<SessionAggregateBoolExp>;
  user?: InputMaybe<UserBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "account" */
export enum AccountConstraint {
  /** unique or primary key constraint on columns "id" */
  AccountPkey = 'account_pkey',
  /** unique or primary key constraint on columns "provider", "user_id" */
  AccountProviderUserIdUnique = 'account_provider_user_id_unique'
}

/** input type for inserting data into table "account" */
export type AccountInsertInput = {
  id?: InputMaybe<Scalars['uuid']>;
  otps?: InputMaybe<OtpArrRelInsertInput>;
  provider?: InputMaybe<AuthProviderEnum>;
  sessions?: InputMaybe<SessionArrRelInsertInput>;
  user?: InputMaybe<UserObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AccountMaxFields = {
  __typename?: 'AccountMaxFields';
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "account" */
export type AccountMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountMinFields = {
  __typename?: 'AccountMinFields';
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "account" */
export type AccountMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account" */
export type AccountMutationResponse = {
  __typename?: 'AccountMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** input type for inserting object relation for remote table "account" */
export type AccountObjRelInsertInput = {
  data: AccountInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AccountOnConflict>;
};

/** on_conflict condition type for table "account" */
export type AccountOnConflict = {
  constraint: AccountConstraint;
  updateColumns?: Array<AccountUpdateColumn>;
  where?: InputMaybe<AccountBoolExp>;
};

/** Ordering options when selecting data from "account". */
export type AccountOrderBy = {
  id?: InputMaybe<OrderBy>;
  otpsAggregate?: InputMaybe<OtpAggregateOrderBy>;
  provider?: InputMaybe<OrderBy>;
  sessionsAggregate?: InputMaybe<SessionAggregateOrderBy>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account */
export type AccountPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "account" */
export enum AccountSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "account" */
export type AccountSetInput = {
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<AuthProviderEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "account" */
export type AccountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<AuthProviderEnum>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "account" */
export enum AccountUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Provider = 'provider',
  /** column name */
  UserId = 'userId'
}

export type AccountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountSetInput>;
  /** filter the rows which have to be updated */
  where: AccountBoolExp;
};

/** columns and relationships of "activity" */
export type Activity = {
  __typename?: 'Activity';
  /** An object relationship */
  category: ActivityCategory;
  categoryId: Scalars['Int'];
  id: Scalars['Int'];
  label: Scalars['String'];
  mreAcheelOk: Scalars['Boolean'];
  multiRiskOk: Scalars['Boolean'];
  publicLiabilityEcommOk: Scalars['Boolean'];
  publicLiabilityOk: Scalars['Boolean'];
};

/** aggregated selection of "activity" */
export type ActivityAggregate = {
  __typename?: 'ActivityAggregate';
  aggregate?: Maybe<ActivityAggregateFields>;
  nodes: Array<Activity>;
};

export type ActivityAggregateBoolExp = {
  bool_and?: InputMaybe<ActivityAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ActivityAggregateBoolExpBool_Or>;
  count?: InputMaybe<ActivityAggregateBoolExpCount>;
};

/** aggregate fields of "activity" */
export type ActivityAggregateFields = {
  __typename?: 'ActivityAggregateFields';
  avg?: Maybe<ActivityAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ActivityMaxFields>;
  min?: Maybe<ActivityMinFields>;
  stddev?: Maybe<ActivityStddevFields>;
  stddevPop?: Maybe<ActivityStddevPopFields>;
  stddevSamp?: Maybe<ActivityStddevSampFields>;
  sum?: Maybe<ActivitySumFields>;
  varPop?: Maybe<ActivityVarPopFields>;
  varSamp?: Maybe<ActivityVarSampFields>;
  variance?: Maybe<ActivityVarianceFields>;
};


/** aggregate fields of "activity" */
export type ActivityAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activity" */
export type ActivityAggregateOrderBy = {
  avg?: InputMaybe<ActivityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ActivityMaxOrderBy>;
  min?: InputMaybe<ActivityMinOrderBy>;
  stddev?: InputMaybe<ActivityStddevOrderBy>;
  stddevPop?: InputMaybe<ActivityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ActivityStddevSampOrderBy>;
  sum?: InputMaybe<ActivitySumOrderBy>;
  varPop?: InputMaybe<ActivityVarPopOrderBy>;
  varSamp?: InputMaybe<ActivityVarSampOrderBy>;
  variance?: InputMaybe<ActivityVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "activity" */
export type ActivityArrRelInsertInput = {
  data: Array<ActivityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityOnConflict>;
};

/** aggregate avg on columns */
export type ActivityAvgFields = {
  __typename?: 'ActivityAvgFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "activity" */
export type ActivityAvgOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "activity". All fields are combined with a logical 'AND'. */
export type ActivityBoolExp = {
  _and?: InputMaybe<Array<ActivityBoolExp>>;
  _not?: InputMaybe<ActivityBoolExp>;
  _or?: InputMaybe<Array<ActivityBoolExp>>;
  category?: InputMaybe<ActivityCategoryBoolExp>;
  categoryId?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  mreAcheelOk?: InputMaybe<BooleanComparisonExp>;
  multiRiskOk?: InputMaybe<BooleanComparisonExp>;
  publicLiabilityEcommOk?: InputMaybe<BooleanComparisonExp>;
  publicLiabilityOk?: InputMaybe<BooleanComparisonExp>;
};

/** columns and relationships of "activity_category" */
export type ActivityCategory = {
  __typename?: 'ActivityCategory';
  /** An array relationship */
  activities: Array<Activity>;
  /** An aggregate relationship */
  activitiesAggregate: ActivityAggregate;
  id: Scalars['Int'];
  label: Scalars['String'];
  /** An object relationship */
  sector: ActivitySector;
  sectorId: Scalars['Int'];
};


/** columns and relationships of "activity_category" */
export type ActivityCategoryActivitiesArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};


/** columns and relationships of "activity_category" */
export type ActivityCategoryActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};

/** aggregated selection of "activity_category" */
export type ActivityCategoryAggregate = {
  __typename?: 'ActivityCategoryAggregate';
  aggregate?: Maybe<ActivityCategoryAggregateFields>;
  nodes: Array<ActivityCategory>;
};

export type ActivityCategoryAggregateBoolExp = {
  count?: InputMaybe<ActivityCategoryAggregateBoolExpCount>;
};

/** aggregate fields of "activity_category" */
export type ActivityCategoryAggregateFields = {
  __typename?: 'ActivityCategoryAggregateFields';
  avg?: Maybe<ActivityCategoryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ActivityCategoryMaxFields>;
  min?: Maybe<ActivityCategoryMinFields>;
  stddev?: Maybe<ActivityCategoryStddevFields>;
  stddevPop?: Maybe<ActivityCategoryStddevPopFields>;
  stddevSamp?: Maybe<ActivityCategoryStddevSampFields>;
  sum?: Maybe<ActivityCategorySumFields>;
  varPop?: Maybe<ActivityCategoryVarPopFields>;
  varSamp?: Maybe<ActivityCategoryVarSampFields>;
  variance?: Maybe<ActivityCategoryVarianceFields>;
};


/** aggregate fields of "activity_category" */
export type ActivityCategoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activity_category" */
export type ActivityCategoryAggregateOrderBy = {
  avg?: InputMaybe<ActivityCategoryAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ActivityCategoryMaxOrderBy>;
  min?: InputMaybe<ActivityCategoryMinOrderBy>;
  stddev?: InputMaybe<ActivityCategoryStddevOrderBy>;
  stddevPop?: InputMaybe<ActivityCategoryStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ActivityCategoryStddevSampOrderBy>;
  sum?: InputMaybe<ActivityCategorySumOrderBy>;
  varPop?: InputMaybe<ActivityCategoryVarPopOrderBy>;
  varSamp?: InputMaybe<ActivityCategoryVarSampOrderBy>;
  variance?: InputMaybe<ActivityCategoryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "activity_category" */
export type ActivityCategoryArrRelInsertInput = {
  data: Array<ActivityCategoryInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityCategoryOnConflict>;
};

/** aggregate avg on columns */
export type ActivityCategoryAvgFields = {
  __typename?: 'ActivityCategoryAvgFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "activity_category" */
export type ActivityCategoryAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "activity_category". All fields are combined with a logical 'AND'. */
export type ActivityCategoryBoolExp = {
  _and?: InputMaybe<Array<ActivityCategoryBoolExp>>;
  _not?: InputMaybe<ActivityCategoryBoolExp>;
  _or?: InputMaybe<Array<ActivityCategoryBoolExp>>;
  activities?: InputMaybe<ActivityBoolExp>;
  activitiesAggregate?: InputMaybe<ActivityAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  sector?: InputMaybe<ActivitySectorBoolExp>;
  sectorId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "activity_category" */
export enum ActivityCategoryConstraint {
  /** unique or primary key constraint on columns "label" */
  ActivityCategoryLabelKey = 'activity_category_label_key',
  /** unique or primary key constraint on columns "id" */
  ActivityCategoryPkey = 'activity_category_pkey'
}

/** input type for incrementing numeric columns in table "activity_category" */
export type ActivityCategoryIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  sectorId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity_category" */
export type ActivityCategoryInsertInput = {
  activities?: InputMaybe<ActivityArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<ActivitySectorObjRelInsertInput>;
  sectorId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ActivityCategoryMaxFields = {
  __typename?: 'ActivityCategoryMaxFields';
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  sectorId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "activity_category" */
export type ActivityCategoryMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ActivityCategoryMinFields = {
  __typename?: 'ActivityCategoryMinFields';
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  sectorId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "activity_category" */
export type ActivityCategoryMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "activity_category" */
export type ActivityCategoryMutationResponse = {
  __typename?: 'ActivityCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityCategory>;
};

/** input type for inserting object relation for remote table "activity_category" */
export type ActivityCategoryObjRelInsertInput = {
  data: ActivityCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityCategoryOnConflict>;
};

/** on_conflict condition type for table "activity_category" */
export type ActivityCategoryOnConflict = {
  constraint: ActivityCategoryConstraint;
  updateColumns?: Array<ActivityCategoryUpdateColumn>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};

/** Ordering options when selecting data from "activity_category". */
export type ActivityCategoryOrderBy = {
  activitiesAggregate?: InputMaybe<ActivityAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  sector?: InputMaybe<ActivitySectorOrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: activity_category */
export type ActivityCategoryPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "activity_category" */
export enum ActivityCategorySelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SectorId = 'sectorId'
}

/** input type for updating data in table "activity_category" */
export type ActivityCategorySetInput = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  sectorId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ActivityCategoryStddevFields = {
  __typename?: 'ActivityCategoryStddevFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "activity_category" */
export type ActivityCategoryStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ActivityCategoryStddevPopFields = {
  __typename?: 'ActivityCategoryStddevPopFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "activity_category" */
export type ActivityCategoryStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ActivityCategoryStddevSampFields = {
  __typename?: 'ActivityCategoryStddevSampFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "activity_category" */
export type ActivityCategoryStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "activity_category" */
export type ActivityCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityCategoryStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  sectorId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ActivityCategorySumFields = {
  __typename?: 'ActivityCategorySumFields';
  id?: Maybe<Scalars['Int']>;
  sectorId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "activity_category" */
export type ActivityCategorySumOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** update columns of table "activity_category" */
export enum ActivityCategoryUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SectorId = 'sectorId'
}

export type ActivityCategoryUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityCategoryIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityCategorySetInput>;
  /** filter the rows which have to be updated */
  where: ActivityCategoryBoolExp;
};

/** aggregate varPop on columns */
export type ActivityCategoryVarPopFields = {
  __typename?: 'ActivityCategoryVarPopFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "activity_category" */
export type ActivityCategoryVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ActivityCategoryVarSampFields = {
  __typename?: 'ActivityCategoryVarSampFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "activity_category" */
export type ActivityCategoryVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ActivityCategoryVarianceFields = {
  __typename?: 'ActivityCategoryVarianceFields';
  id?: Maybe<Scalars['Float']>;
  sectorId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "activity_category" */
export type ActivityCategoryVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  sectorId?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "activity" */
export enum ActivityConstraint {
  /** unique or primary key constraint on columns "label" */
  ActivityLabelKey = 'activity_label_key',
  /** unique or primary key constraint on columns "id" */
  ActivityPkey = 'activity_pkey'
}

/** input type for incrementing numeric columns in table "activity" */
export type ActivityIncInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity" */
export type ActivityInsertInput = {
  category?: InputMaybe<ActivityCategoryObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mreAcheelOk?: InputMaybe<Scalars['Boolean']>;
  multiRiskOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityEcommOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityOk?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ActivityMaxFields = {
  __typename?: 'ActivityMaxFields';
  categoryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "activity" */
export type ActivityMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ActivityMinFields = {
  __typename?: 'ActivityMinFields';
  categoryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "activity" */
export type ActivityMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "activity" */
export type ActivityMutationResponse = {
  __typename?: 'ActivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity>;
};

/** on_conflict condition type for table "activity" */
export type ActivityOnConflict = {
  constraint: ActivityConstraint;
  updateColumns?: Array<ActivityUpdateColumn>;
  where?: InputMaybe<ActivityBoolExp>;
};

/** Ordering options when selecting data from "activity". */
export type ActivityOrderBy = {
  category?: InputMaybe<ActivityCategoryOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  mreAcheelOk?: InputMaybe<OrderBy>;
  multiRiskOk?: InputMaybe<OrderBy>;
  publicLiabilityEcommOk?: InputMaybe<OrderBy>;
  publicLiabilityOk?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: activity */
export type ActivityPkColumnsInput = {
  id: Scalars['Int'];
};

export type ActivityResult = {
  __typename?: 'ActivityResult';
  categoryId: Scalars['Int'];
  categoryLabel: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  sectorId: Scalars['Int'];
  sectorLabel: Scalars['String'];
};

/** columns and relationships of "activity_sector" */
export type ActivitySector = {
  __typename?: 'ActivitySector';
  /** An array relationship */
  categories: Array<ActivityCategory>;
  /** An aggregate relationship */
  categoriesAggregate: ActivityCategoryAggregate;
  id: Scalars['Int'];
  label: Scalars['String'];
};


/** columns and relationships of "activity_sector" */
export type ActivitySectorCategoriesArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


/** columns and relationships of "activity_sector" */
export type ActivitySectorCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};

/** aggregated selection of "activity_sector" */
export type ActivitySectorAggregate = {
  __typename?: 'ActivitySectorAggregate';
  aggregate?: Maybe<ActivitySectorAggregateFields>;
  nodes: Array<ActivitySector>;
};

/** aggregate fields of "activity_sector" */
export type ActivitySectorAggregateFields = {
  __typename?: 'ActivitySectorAggregateFields';
  avg?: Maybe<ActivitySectorAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ActivitySectorMaxFields>;
  min?: Maybe<ActivitySectorMinFields>;
  stddev?: Maybe<ActivitySectorStddevFields>;
  stddevPop?: Maybe<ActivitySectorStddevPopFields>;
  stddevSamp?: Maybe<ActivitySectorStddevSampFields>;
  sum?: Maybe<ActivitySectorSumFields>;
  varPop?: Maybe<ActivitySectorVarPopFields>;
  varSamp?: Maybe<ActivitySectorVarSampFields>;
  variance?: Maybe<ActivitySectorVarianceFields>;
};


/** aggregate fields of "activity_sector" */
export type ActivitySectorAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActivitySectorSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ActivitySectorAvgFields = {
  __typename?: 'ActivitySectorAvgFields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "activity_sector". All fields are combined with a logical 'AND'. */
export type ActivitySectorBoolExp = {
  _and?: InputMaybe<Array<ActivitySectorBoolExp>>;
  _not?: InputMaybe<ActivitySectorBoolExp>;
  _or?: InputMaybe<Array<ActivitySectorBoolExp>>;
  categories?: InputMaybe<ActivityCategoryBoolExp>;
  categoriesAggregate?: InputMaybe<ActivityCategoryAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "activity_sector" */
export enum ActivitySectorConstraint {
  /** unique or primary key constraint on columns "label" */
  ActivitySectorLabelKey = 'activity_sector_label_key',
  /** unique or primary key constraint on columns "id" */
  ActivitySectorPkey = 'activity_sector_pkey'
}

/** input type for incrementing numeric columns in table "activity_sector" */
export type ActivitySectorIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity_sector" */
export type ActivitySectorInsertInput = {
  categories?: InputMaybe<ActivityCategoryArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ActivitySectorMaxFields = {
  __typename?: 'ActivitySectorMaxFields';
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ActivitySectorMinFields = {
  __typename?: 'ActivitySectorMinFields';
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "activity_sector" */
export type ActivitySectorMutationResponse = {
  __typename?: 'ActivitySectorMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivitySector>;
};

/** input type for inserting object relation for remote table "activity_sector" */
export type ActivitySectorObjRelInsertInput = {
  data: ActivitySectorInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ActivitySectorOnConflict>;
};

/** on_conflict condition type for table "activity_sector" */
export type ActivitySectorOnConflict = {
  constraint: ActivitySectorConstraint;
  updateColumns?: Array<ActivitySectorUpdateColumn>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};

/** Ordering options when selecting data from "activity_sector". */
export type ActivitySectorOrderBy = {
  categoriesAggregate?: InputMaybe<ActivityCategoryAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: activity_sector */
export type ActivitySectorPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "activity_sector" */
export enum ActivitySectorSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "activity_sector" */
export type ActivitySectorSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ActivitySectorStddevFields = {
  __typename?: 'ActivitySectorStddevFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ActivitySectorStddevPopFields = {
  __typename?: 'ActivitySectorStddevPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ActivitySectorStddevSampFields = {
  __typename?: 'ActivitySectorStddevSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "activity_sector" */
export type ActivitySectorStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivitySectorStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivitySectorStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ActivitySectorSumFields = {
  __typename?: 'ActivitySectorSumFields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "activity_sector" */
export enum ActivitySectorUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

export type ActivitySectorUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivitySectorIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivitySectorSetInput>;
  /** filter the rows which have to be updated */
  where: ActivitySectorBoolExp;
};

/** aggregate varPop on columns */
export type ActivitySectorVarPopFields = {
  __typename?: 'ActivitySectorVarPopFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ActivitySectorVarSampFields = {
  __typename?: 'ActivitySectorVarSampFields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ActivitySectorVarianceFields = {
  __typename?: 'ActivitySectorVarianceFields';
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "activity" */
export enum ActivitySelectColumn {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MreAcheelOk = 'mreAcheelOk',
  /** column name */
  MultiRiskOk = 'multiRiskOk',
  /** column name */
  PublicLiabilityEcommOk = 'publicLiabilityEcommOk',
  /** column name */
  PublicLiabilityOk = 'publicLiabilityOk'
}

/** select "activityAggregateBoolExpBool_andArgumentsColumns" columns of table "activity" */
export enum ActivitySelectColumnActivityAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  MreAcheelOk = 'mreAcheelOk',
  /** column name */
  MultiRiskOk = 'multiRiskOk',
  /** column name */
  PublicLiabilityEcommOk = 'publicLiabilityEcommOk',
  /** column name */
  PublicLiabilityOk = 'publicLiabilityOk'
}

/** select "activityAggregateBoolExpBool_orArgumentsColumns" columns of table "activity" */
export enum ActivitySelectColumnActivityAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  MreAcheelOk = 'mreAcheelOk',
  /** column name */
  MultiRiskOk = 'multiRiskOk',
  /** column name */
  PublicLiabilityEcommOk = 'publicLiabilityEcommOk',
  /** column name */
  PublicLiabilityOk = 'publicLiabilityOk'
}

/** input type for updating data in table "activity" */
export type ActivitySetInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mreAcheelOk?: InputMaybe<Scalars['Boolean']>;
  multiRiskOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityEcommOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityOk?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ActivityStddevFields = {
  __typename?: 'ActivityStddevFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "activity" */
export type ActivityStddevOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ActivityStddevPopFields = {
  __typename?: 'ActivityStddevPopFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "activity" */
export type ActivityStddevPopOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ActivityStddevSampFields = {
  __typename?: 'ActivityStddevSampFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "activity" */
export type ActivityStddevSampOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "activity" */
export type ActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  mreAcheelOk?: InputMaybe<Scalars['Boolean']>;
  multiRiskOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityEcommOk?: InputMaybe<Scalars['Boolean']>;
  publicLiabilityOk?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type ActivitySumFields = {
  __typename?: 'ActivitySumFields';
  categoryId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "activity" */
export type ActivitySumOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "activity" */
export enum ActivityUpdateColumn {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  MreAcheelOk = 'mreAcheelOk',
  /** column name */
  MultiRiskOk = 'multiRiskOk',
  /** column name */
  PublicLiabilityEcommOk = 'publicLiabilityEcommOk',
  /** column name */
  PublicLiabilityOk = 'publicLiabilityOk'
}

export type ActivityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivitySetInput>;
  /** filter the rows which have to be updated */
  where: ActivityBoolExp;
};

/** aggregate varPop on columns */
export type ActivityVarPopFields = {
  __typename?: 'ActivityVarPopFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "activity" */
export type ActivityVarPopOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ActivityVarSampFields = {
  __typename?: 'ActivityVarSampFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "activity" */
export type ActivityVarSampOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ActivityVarianceFields = {
  __typename?: 'ActivityVarianceFields';
  categoryId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "activity" */
export type ActivityVarianceOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: CountryEnum;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export type AddressInput = {
  city: Scalars['String'];
  country: CountryEnum;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export type ApplicationFees = {
  __typename?: 'ApplicationFees';
  instalmentFees: Scalars['Float'];
  total: Scalars['Float'];
};

export type ApplicationFeesInput = {
  instalmentFees: Scalars['Float'];
};

export type ApplicationFeesQuotation = {
  __typename?: 'ApplicationFeesQuotation';
  instalmentFees: Scalars['Float'];
};

export type ApplyQuotationPromoCodeFailure = {
  __typename?: 'ApplyQuotationPromoCodeFailure';
  error: PromoCodeError;
};

export type ApplyQuotationPromoCodeResult = ApplyQuotationPromoCodeFailure | QuotationId;

export type AssistanceDomestiqueContractDetails = {
  __typename?: 'AssistanceDomestiqueContractDetails';
  guaranteeAmount: Scalars['Float'];
  packageOptionAssistance?: Maybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueContractDetailsInput = {
  guaranteeAmount: Scalars['Float'];
  packageOptionAssistance?: InputMaybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueContractPremium = ContractPremium & {
  __typename?: 'AssistanceDomestiqueContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type AssistanceDomestiqueContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export enum AssistanceDomestiquePackage {
  Basic = 'BASIC',
  Premium = 'PREMIUM'
}

export type AssistanceDomestiqueProfessionnelContractDetails = {
  __typename?: 'AssistanceDomestiqueProfessionnelContractDetails';
  guaranteeAmount: Scalars['Float'];
  packageOptionAssistance?: Maybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueProfessionnelContractDetailsInput = {
  guaranteeAmount: Scalars['Float'];
  packageOptionAssistance?: InputMaybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueProfessionnelContractPremium = ContractPremium & {
  __typename?: 'AssistanceDomestiqueProfessionnelContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type AssistanceDomestiqueProfessionnelContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type AssistanceDomestiqueProfessionnelQuotationCovers = {
  __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers';
  chauffage?: Maybe<Scalars['Float']>;
  electricite?: Maybe<Scalars['Float']>;
  plomberie?: Maybe<Scalars['Float']>;
  serrurieVitrerie?: Maybe<Scalars['Float']>;
};

export type AssistanceDomestiqueProfessionnelQuotationDetails = {
  __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails';
  guaranteeAmount?: Maybe<Scalars['Float']>;
  packageOptionAssistance?: Maybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueProfessionnelQuotationDetailsInput = {
  guaranteeAmount?: InputMaybe<Scalars['Float']>;
  packageOptionAssistance?: InputMaybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueProfessionnelQuotationPremium = ProductPricing & {
  __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium';
  applicationFees: ApplicationFeesQuotation;
  base: Scalars['Float'];
  discountedTotal?: Maybe<Scalars['Float']>;
  originalTotal: Scalars['Float'];
};

export type AssistanceDomestiqueQuotationCovers = {
  __typename?: 'AssistanceDomestiqueQuotationCovers';
  chauffage?: Maybe<Scalars['Float']>;
  electricite?: Maybe<Scalars['Float']>;
  plomberie?: Maybe<Scalars['Float']>;
  serrurieVitrerie?: Maybe<Scalars['Float']>;
};

export type AssistanceDomestiqueQuotationDetails = {
  __typename?: 'AssistanceDomestiqueQuotationDetails';
  guaranteeAmount?: Maybe<Scalars['Float']>;
  packageOptionAssistance?: Maybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueQuotationDetailsInput = {
  guaranteeAmount?: InputMaybe<Scalars['Float']>;
  packageOptionAssistance?: InputMaybe<AssistanceDomestiquePackage>;
};

export type AssistanceDomestiqueQuotationPremium = ProductPricing & {
  __typename?: 'AssistanceDomestiqueQuotationPremium';
  applicationFees: ApplicationFeesQuotation;
  base: Scalars['Float'];
  discountedTotal?: Maybe<Scalars['Float']>;
  originalTotal: Scalars['Float'];
};

/** columns and relationships of "auth_provider" */
export type AuthProvider = {
  __typename?: 'AuthProvider';
  provider: Scalars['String'];
};

/** aggregated selection of "auth_provider" */
export type AuthProviderAggregate = {
  __typename?: 'AuthProviderAggregate';
  aggregate?: Maybe<AuthProviderAggregateFields>;
  nodes: Array<AuthProvider>;
};

/** aggregate fields of "auth_provider" */
export type AuthProviderAggregateFields = {
  __typename?: 'AuthProviderAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AuthProviderMaxFields>;
  min?: Maybe<AuthProviderMinFields>;
};


/** aggregate fields of "auth_provider" */
export type AuthProviderAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth_provider". All fields are combined with a logical 'AND'. */
export type AuthProviderBoolExp = {
  _and?: InputMaybe<Array<AuthProviderBoolExp>>;
  _not?: InputMaybe<AuthProviderBoolExp>;
  _or?: InputMaybe<Array<AuthProviderBoolExp>>;
  provider?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "auth_provider" */
export enum AuthProviderConstraint {
  /** unique or primary key constraint on columns "provider" */
  AuthProviderPkey = 'auth_provider_pkey'
}

export enum AuthProviderEnum {
  Passwordless = 'PASSWORDLESS'
}

/** Boolean expression to compare columns of type "AuthProviderEnum". All fields are combined with logical 'AND'. */
export type AuthProviderEnumComparisonExp = {
  _eq?: InputMaybe<AuthProviderEnum>;
  _in?: InputMaybe<Array<AuthProviderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AuthProviderEnum>;
  _nin?: InputMaybe<Array<AuthProviderEnum>>;
};

/** input type for inserting data into table "auth_provider" */
export type AuthProviderInsertInput = {
  provider?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AuthProviderMaxFields = {
  __typename?: 'AuthProviderMaxFields';
  provider?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthProviderMinFields = {
  __typename?: 'AuthProviderMinFields';
  provider?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_provider" */
export type AuthProviderMutationResponse = {
  __typename?: 'AuthProviderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProvider>;
};

/** on_conflict condition type for table "auth_provider" */
export type AuthProviderOnConflict = {
  constraint: AuthProviderConstraint;
  updateColumns?: Array<AuthProviderUpdateColumn>;
  where?: InputMaybe<AuthProviderBoolExp>;
};

/** Ordering options when selecting data from "auth_provider". */
export type AuthProviderOrderBy = {
  provider?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: auth_provider */
export type AuthProviderPkColumnsInput = {
  provider: Scalars['String'];
};

/** select columns of table "auth_provider" */
export enum AuthProviderSelectColumn {
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "auth_provider" */
export type AuthProviderSetInput = {
  provider?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "auth_provider" */
export type AuthProviderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AuthProviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderStreamCursorValueInput = {
  provider?: InputMaybe<Scalars['String']>;
};

/** update columns of table "auth_provider" */
export enum AuthProviderUpdateColumn {
  /** column name */
  Provider = 'provider'
}

export type AuthProviderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderSetInput>;
  /** filter the rows which have to be updated */
  where: AuthProviderBoolExp;
};

export type AutoContractDetails = {
  __typename?: 'AutoContractDetails';
  activityId: Scalars['Int'];
  brand: Scalars['String'];
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  model: Scalars['String'];
  package: Scalars['String'];
  plateNumber: Scalars['String'];
};

export type AutoContractDetailsInput = {
  activityId: Scalars['Int'];
  brand: Scalars['String'];
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  model: Scalars['String'];
  package: Scalars['String'];
  plateNumber: Scalars['String'];
};

export type AutoContractPremium = ContractPremium & {
  __typename?: 'AutoContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type AutoContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type AutoMissionContractPremium = ContractPremium & {
  __typename?: 'AutoMissionContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type AutoMissionContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "broker" */
export type Broker = {
  __typename?: 'Broker';
  /** An array relationship */
  contractPeriods: Array<ContractPeriod>;
  /** An aggregate relationship */
  contractPeriodsAggregate: ContractPeriodAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "broker" */
export type BrokerContractPeriodsArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


/** columns and relationships of "broker" */
export type BrokerContractPeriodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};

/** aggregated selection of "broker" */
export type BrokerAggregate = {
  __typename?: 'BrokerAggregate';
  aggregate?: Maybe<BrokerAggregateFields>;
  nodes: Array<Broker>;
};

/** aggregate fields of "broker" */
export type BrokerAggregateFields = {
  __typename?: 'BrokerAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BrokerMaxFields>;
  min?: Maybe<BrokerMinFields>;
};


/** aggregate fields of "broker" */
export type BrokerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BrokerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "broker". All fields are combined with a logical 'AND'. */
export type BrokerBoolExp = {
  _and?: InputMaybe<Array<BrokerBoolExp>>;
  _not?: InputMaybe<BrokerBoolExp>;
  _or?: InputMaybe<Array<BrokerBoolExp>>;
  contractPeriods?: InputMaybe<ContractPeriodBoolExp>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "broker" */
export enum BrokerConstraint {
  /** unique or primary key constraint on columns "id" */
  BrokerPkey = 'broker_pkey'
}

/** input type for inserting data into table "broker" */
export type BrokerInsertInput = {
  contractPeriods?: InputMaybe<ContractPeriodArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BrokerMaxFields = {
  __typename?: 'BrokerMaxFields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BrokerMinFields = {
  __typename?: 'BrokerMinFields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "broker" */
export type BrokerMutationResponse = {
  __typename?: 'BrokerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Broker>;
};

/** input type for inserting object relation for remote table "broker" */
export type BrokerObjRelInsertInput = {
  data: BrokerInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BrokerOnConflict>;
};

/** on_conflict condition type for table "broker" */
export type BrokerOnConflict = {
  constraint: BrokerConstraint;
  updateColumns?: Array<BrokerUpdateColumn>;
  where?: InputMaybe<BrokerBoolExp>;
};

/** Ordering options when selecting data from "broker". */
export type BrokerOrderBy = {
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: broker */
export type BrokerPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "broker" */
export enum BrokerSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "broker" */
export type BrokerSetInput = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "broker" */
export type BrokerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BrokerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BrokerStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "broker" */
export enum BrokerUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type BrokerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BrokerSetInput>;
  /** filter the rows which have to be updated */
  where: BrokerBoolExp;
};

export type CompanySuggestion = {
  __typename?: 'CompanySuggestion';
  activityCode?: Maybe<Scalars['String']>;
  address?: Maybe<CompanySuggestionAddress>;
  foundedAt?: Maybe<Scalars['date']>;
  legalStatus?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  siret: Scalars['String'];
  turnover?: Maybe<Scalars['Int']>;
};

export type CompanySuggestionAddress = {
  __typename?: 'CompanySuggestionAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<CountryEnum>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export enum CompanyTypeEnum {
  PilliotAssurances = 'PILLIOT_ASSURANCES'
}

/** columns and relationships of "contract" */
export type Contract = {
  __typename?: 'Contract';
  /** An object relationship */
  billingAddress?: Maybe<DbAddress>;
  billingAddressId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  companyAddress?: Maybe<DbAddress>;
  companyAddressId?: Maybe<Scalars['uuid']>;
  companyFoundedAt?: Maybe<Scalars['date']>;
  companyLegalStatus?: Maybe<Scalars['String']>;
  companyNafCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companySiret?: Maybe<Scalars['String']>;
  /** An array relationship */
  contractPeriods: Array<ContractPeriod>;
  /** An aggregate relationship */
  contractPeriodsAggregate: ContractPeriodAggregate;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  idPoliceSesame?: Maybe<Scalars['String']>;
  mode: ContractModeEnum;
  number: Scalars['String'];
  product: ProductEnum;
  /** An object relationship */
  quotation?: Maybe<Quotation>;
  quotationId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  userId: Scalars['uuid'];
};


/** columns and relationships of "contract" */
export type ContractContractPeriodsArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


/** columns and relationships of "contract" */
export type ContractContractPeriodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};

/** aggregated selection of "contract" */
export type ContractAggregate = {
  __typename?: 'ContractAggregate';
  aggregate?: Maybe<ContractAggregateFields>;
  nodes: Array<Contract>;
};

export type ContractAggregateBoolExp = {
  count?: InputMaybe<ContractAggregateBoolExpCount>;
};

/** aggregate fields of "contract" */
export type ContractAggregateFields = {
  __typename?: 'ContractAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractMaxFields>;
  min?: Maybe<ContractMinFields>;
};


/** aggregate fields of "contract" */
export type ContractAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contract" */
export type ContractAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContractMaxOrderBy>;
  min?: InputMaybe<ContractMinOrderBy>;
};

/** input type for inserting array relation for remote table "contract" */
export type ContractArrRelInsertInput = {
  data: Array<ContractInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ContractOnConflict>;
};

/** Boolean expression to filter rows from the table "contract". All fields are combined with a logical 'AND'. */
export type ContractBoolExp = {
  _and?: InputMaybe<Array<ContractBoolExp>>;
  _not?: InputMaybe<ContractBoolExp>;
  _or?: InputMaybe<Array<ContractBoolExp>>;
  billingAddress?: InputMaybe<DbAddressBoolExp>;
  billingAddressId?: InputMaybe<UuidComparisonExp>;
  companyAddress?: InputMaybe<DbAddressBoolExp>;
  companyAddressId?: InputMaybe<UuidComparisonExp>;
  companyFoundedAt?: InputMaybe<DateComparisonExp>;
  companyLegalStatus?: InputMaybe<StringComparisonExp>;
  companyNafCode?: InputMaybe<StringComparisonExp>;
  companyName?: InputMaybe<StringComparisonExp>;
  companySiret?: InputMaybe<StringComparisonExp>;
  contractPeriods?: InputMaybe<ContractPeriodBoolExp>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idPoliceSesame?: InputMaybe<StringComparisonExp>;
  mode?: InputMaybe<ContractModeEnumComparisonExp>;
  number?: InputMaybe<StringComparisonExp>;
  product?: InputMaybe<ProductEnumComparisonExp>;
  quotation?: InputMaybe<QuotationBoolExp>;
  quotationId?: InputMaybe<UuidComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedSesameAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "contract" */
export enum ContractConstraint {
  /** unique or primary key constraint on columns "number" */
  ContractNumberKey = 'contract_number_key',
  /** unique or primary key constraint on columns "id" */
  ContractPkey = 'contract_pkey'
}

export type ContractDetails = AssistanceDomestiqueContractDetails | AssistanceDomestiqueProfessionnelContractDetails | AutoContractDetails | CyberSecurityContractDetails | MreAcheelContractDetails | MultiRiskContractDetails | PublicLiabilityContractDetails | PublicLiabilityEcommContractDetails;

export enum ContractDocument {
  Certificate = 'CERTIFICATE'
}

/** input type for inserting data into table "contract" */
export type ContractInsertInput = {
  billingAddress?: InputMaybe<DbAddressObjRelInsertInput>;
  billingAddressId?: InputMaybe<Scalars['uuid']>;
  companyAddress?: InputMaybe<DbAddressObjRelInsertInput>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyFoundedAt?: InputMaybe<Scalars['date']>;
  companyLegalStatus?: InputMaybe<Scalars['String']>;
  companyNafCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companySiret?: InputMaybe<Scalars['String']>;
  contractPeriods?: InputMaybe<ContractPeriodArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPoliceSesame?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<ContractModeEnum>;
  number?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductEnum>;
  quotation?: InputMaybe<QuotationObjRelInsertInput>;
  quotationId?: InputMaybe<Scalars['uuid']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ContractMaxFields = {
  __typename?: 'ContractMaxFields';
  billingAddressId?: Maybe<Scalars['uuid']>;
  companyAddressId?: Maybe<Scalars['uuid']>;
  companyFoundedAt?: Maybe<Scalars['date']>;
  companyLegalStatus?: Maybe<Scalars['String']>;
  companyNafCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companySiret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idPoliceSesame?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contract" */
export type ContractMaxOrderBy = {
  billingAddressId?: InputMaybe<OrderBy>;
  companyAddressId?: InputMaybe<OrderBy>;
  companyFoundedAt?: InputMaybe<OrderBy>;
  companyLegalStatus?: InputMaybe<OrderBy>;
  companyNafCode?: InputMaybe<OrderBy>;
  companyName?: InputMaybe<OrderBy>;
  companySiret?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPoliceSesame?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  quotationId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedSesameAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContractMinFields = {
  __typename?: 'ContractMinFields';
  billingAddressId?: Maybe<Scalars['uuid']>;
  companyAddressId?: Maybe<Scalars['uuid']>;
  companyFoundedAt?: Maybe<Scalars['date']>;
  companyLegalStatus?: Maybe<Scalars['String']>;
  companyNafCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companySiret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idPoliceSesame?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  quotationId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contract" */
export type ContractMinOrderBy = {
  billingAddressId?: InputMaybe<OrderBy>;
  companyAddressId?: InputMaybe<OrderBy>;
  companyFoundedAt?: InputMaybe<OrderBy>;
  companyLegalStatus?: InputMaybe<OrderBy>;
  companyNafCode?: InputMaybe<OrderBy>;
  companyName?: InputMaybe<OrderBy>;
  companySiret?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPoliceSesame?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  quotationId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedSesameAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "contract_mode" */
export type ContractMode = {
  __typename?: 'ContractMode';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "contract_mode" */
export type ContractModeAggregate = {
  __typename?: 'ContractModeAggregate';
  aggregate?: Maybe<ContractModeAggregateFields>;
  nodes: Array<ContractMode>;
};

/** aggregate fields of "contract_mode" */
export type ContractModeAggregateFields = {
  __typename?: 'ContractModeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractModeMaxFields>;
  min?: Maybe<ContractModeMinFields>;
};


/** aggregate fields of "contract_mode" */
export type ContractModeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractModeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contract_mode". All fields are combined with a logical 'AND'. */
export type ContractModeBoolExp = {
  _and?: InputMaybe<Array<ContractModeBoolExp>>;
  _not?: InputMaybe<ContractModeBoolExp>;
  _or?: InputMaybe<Array<ContractModeBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "contract_mode" */
export enum ContractModeConstraint {
  /** unique or primary key constraint on columns "value" */
  ContractModePkey = 'contract_mode_pkey'
}

export enum ContractModeEnum {
  /** Automatic contracts are taken via the website, with no input from an account manager */
  Auto = 'AUTO',
  /** Manual contracts are created by an account manager */
  Manual = 'MANUAL'
}

/** Boolean expression to compare columns of type "ContractModeEnum". All fields are combined with logical 'AND'. */
export type ContractModeEnumComparisonExp = {
  _eq?: InputMaybe<ContractModeEnum>;
  _in?: InputMaybe<Array<ContractModeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ContractModeEnum>;
  _nin?: InputMaybe<Array<ContractModeEnum>>;
};

/** input type for inserting data into table "contract_mode" */
export type ContractModeInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractModeMaxFields = {
  __typename?: 'ContractModeMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ContractModeMinFields = {
  __typename?: 'ContractModeMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contract_mode" */
export type ContractModeMutationResponse = {
  __typename?: 'ContractModeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractMode>;
};

/** on_conflict condition type for table "contract_mode" */
export type ContractModeOnConflict = {
  constraint: ContractModeConstraint;
  updateColumns?: Array<ContractModeUpdateColumn>;
  where?: InputMaybe<ContractModeBoolExp>;
};

/** Ordering options when selecting data from "contract_mode". */
export type ContractModeOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_mode */
export type ContractModePkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "contract_mode" */
export enum ContractModeSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "contract_mode" */
export type ContractModeSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contract_mode" */
export type ContractModeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractModeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractModeStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "contract_mode" */
export enum ContractModeUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ContractModeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractModeSetInput>;
  /** filter the rows which have to be updated */
  where: ContractModeBoolExp;
};

/** response of any mutation on the table "contract" */
export type ContractMutationResponse = {
  __typename?: 'ContractMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contract>;
};

/** input type for inserting object relation for remote table "contract" */
export type ContractObjRelInsertInput = {
  data: ContractInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ContractOnConflict>;
};

/** on_conflict condition type for table "contract" */
export type ContractOnConflict = {
  constraint: ContractConstraint;
  updateColumns?: Array<ContractUpdateColumn>;
  where?: InputMaybe<ContractBoolExp>;
};

/** Ordering options when selecting data from "contract". */
export type ContractOrderBy = {
  billingAddress?: InputMaybe<DbAddressOrderBy>;
  billingAddressId?: InputMaybe<OrderBy>;
  companyAddress?: InputMaybe<DbAddressOrderBy>;
  companyAddressId?: InputMaybe<OrderBy>;
  companyFoundedAt?: InputMaybe<OrderBy>;
  companyLegalStatus?: InputMaybe<OrderBy>;
  companyNafCode?: InputMaybe<OrderBy>;
  companyName?: InputMaybe<OrderBy>;
  companySiret?: InputMaybe<OrderBy>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPoliceSesame?: InputMaybe<OrderBy>;
  mode?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrderBy>;
  quotation?: InputMaybe<QuotationOrderBy>;
  quotationId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedSesameAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "contract_period" */
export type ContractPeriod = {
  __typename?: 'ContractPeriod';
  /** An object relationship */
  broker?: Maybe<Broker>;
  brokerId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contract: Contract;
  contractId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  dbDetails: Scalars['jsonb'];
  dbPremium: Scalars['jsonb'];
  details?: Maybe<ContractDetails>;
  /** An array relationship */
  documents: Array<ContractPeriodDocument>;
  /** An aggregate relationship */
  documentsAggregate: ContractPeriodDocumentAggregate;
  endDate?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  insurer: Insurer;
  insurerId: Scalars['uuid'];
  premium: ContractPremium;
  /** An object relationship */
  promoCode?: Maybe<PromoCode>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  renewalDate?: Maybe<Scalars['date']>;
  startDate: Scalars['date'];
  status: ContractPeriodStatusEnum;
  stripeSubscriptionScheduleId?: Maybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: Maybe<Scalars['date']>;
  /** Wether the contract should be renewed at the end of the period or not */
  terminateAtPeriodEnd: Scalars['Boolean'];
  turnover?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "contract_period" */
export type ContractPeriodDbDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contract_period" */
export type ContractPeriodDbPremiumArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contract_period" */
export type ContractPeriodDocumentsArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


/** columns and relationships of "contract_period" */
export type ContractPeriodDocumentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};

/** aggregated selection of "contract_period" */
export type ContractPeriodAggregate = {
  __typename?: 'ContractPeriodAggregate';
  aggregate?: Maybe<ContractPeriodAggregateFields>;
  nodes: Array<ContractPeriod>;
};

export type ContractPeriodAggregateBoolExp = {
  bool_and?: InputMaybe<ContractPeriodAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ContractPeriodAggregateBoolExpBool_Or>;
  count?: InputMaybe<ContractPeriodAggregateBoolExpCount>;
};

/** aggregate fields of "contract_period" */
export type ContractPeriodAggregateFields = {
  __typename?: 'ContractPeriodAggregateFields';
  avg?: Maybe<ContractPeriodAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContractPeriodMaxFields>;
  min?: Maybe<ContractPeriodMinFields>;
  stddev?: Maybe<ContractPeriodStddevFields>;
  stddevPop?: Maybe<ContractPeriodStddevPopFields>;
  stddevSamp?: Maybe<ContractPeriodStddevSampFields>;
  sum?: Maybe<ContractPeriodSumFields>;
  varPop?: Maybe<ContractPeriodVarPopFields>;
  varSamp?: Maybe<ContractPeriodVarSampFields>;
  variance?: Maybe<ContractPeriodVarianceFields>;
};


/** aggregate fields of "contract_period" */
export type ContractPeriodAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contract_period" */
export type ContractPeriodAggregateOrderBy = {
  avg?: InputMaybe<ContractPeriodAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContractPeriodMaxOrderBy>;
  min?: InputMaybe<ContractPeriodMinOrderBy>;
  stddev?: InputMaybe<ContractPeriodStddevOrderBy>;
  stddevPop?: InputMaybe<ContractPeriodStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ContractPeriodStddevSampOrderBy>;
  sum?: InputMaybe<ContractPeriodSumOrderBy>;
  varPop?: InputMaybe<ContractPeriodVarPopOrderBy>;
  varSamp?: InputMaybe<ContractPeriodVarSampOrderBy>;
  variance?: InputMaybe<ContractPeriodVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContractPeriodAppendInput = {
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  dbPremium?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "contract_period" */
export type ContractPeriodArrRelInsertInput = {
  data: Array<ContractPeriodInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ContractPeriodOnConflict>;
};

/** aggregate avg on columns */
export type ContractPeriodAvgFields = {
  __typename?: 'ContractPeriodAvgFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "contract_period" */
export type ContractPeriodAvgOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "contract_period". All fields are combined with a logical 'AND'. */
export type ContractPeriodBoolExp = {
  _and?: InputMaybe<Array<ContractPeriodBoolExp>>;
  _not?: InputMaybe<ContractPeriodBoolExp>;
  _or?: InputMaybe<Array<ContractPeriodBoolExp>>;
  broker?: InputMaybe<BrokerBoolExp>;
  brokerId?: InputMaybe<UuidComparisonExp>;
  contract?: InputMaybe<ContractBoolExp>;
  contractId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dbDetails?: InputMaybe<JsonbComparisonExp>;
  dbPremium?: InputMaybe<JsonbComparisonExp>;
  documents?: InputMaybe<ContractPeriodDocumentBoolExp>;
  documentsAggregate?: InputMaybe<ContractPeriodDocumentAggregateBoolExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  insurer?: InputMaybe<InsurerBoolExp>;
  insurerId?: InputMaybe<UuidComparisonExp>;
  promoCode?: InputMaybe<PromoCodeBoolExp>;
  promoCodeId?: InputMaybe<UuidComparisonExp>;
  renewalDate?: InputMaybe<DateComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  status?: InputMaybe<ContractPeriodStatusEnumComparisonExp>;
  stripeSubscriptionScheduleId?: InputMaybe<StringComparisonExp>;
  terminateAskedAt?: InputMaybe<DateComparisonExp>;
  terminateAtPeriodEnd?: InputMaybe<BooleanComparisonExp>;
  turnover?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "contract_period" */
export enum ContractPeriodConstraint {
  /** unique or primary key constraint on columns "id" */
  ContractPeriodPkey = 'contract_period_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContractPeriodDeleteAtPathInput = {
  dbDetails?: InputMaybe<Array<Scalars['String']>>;
  dbPremium?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContractPeriodDeleteElemInput = {
  dbDetails?: InputMaybe<Scalars['Int']>;
  dbPremium?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContractPeriodDeleteKeyInput = {
  dbDetails?: InputMaybe<Scalars['String']>;
  dbPremium?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "contract_period_document" */
export type ContractPeriodDocument = {
  __typename?: 'ContractPeriodDocument';
  /** An object relationship */
  contractPeriod: ContractPeriod;
  contractPeriodId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file: File;
  fileId: Scalars['uuid'];
  signatureLink?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  /** Signature status of the document. If null, then the document doesn't need to be signed */
  status?: Maybe<ContractPeriodDocumentStatusEnum>;
  type: ContractPeriodDocumentTypeEnum;
  updatedAt: Scalars['timestamptz'];
  yousignSignatureRequestId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "contract_period_document" */
export type ContractPeriodDocumentAggregate = {
  __typename?: 'ContractPeriodDocumentAggregate';
  aggregate?: Maybe<ContractPeriodDocumentAggregateFields>;
  nodes: Array<ContractPeriodDocument>;
};

export type ContractPeriodDocumentAggregateBoolExp = {
  count?: InputMaybe<ContractPeriodDocumentAggregateBoolExpCount>;
};

/** aggregate fields of "contract_period_document" */
export type ContractPeriodDocumentAggregateFields = {
  __typename?: 'ContractPeriodDocumentAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractPeriodDocumentMaxFields>;
  min?: Maybe<ContractPeriodDocumentMinFields>;
};


/** aggregate fields of "contract_period_document" */
export type ContractPeriodDocumentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contract_period_document" */
export type ContractPeriodDocumentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContractPeriodDocumentMaxOrderBy>;
  min?: InputMaybe<ContractPeriodDocumentMinOrderBy>;
};

/** input type for inserting array relation for remote table "contract_period_document" */
export type ContractPeriodDocumentArrRelInsertInput = {
  data: Array<ContractPeriodDocumentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ContractPeriodDocumentOnConflict>;
};

/** Boolean expression to filter rows from the table "contract_period_document". All fields are combined with a logical 'AND'. */
export type ContractPeriodDocumentBoolExp = {
  _and?: InputMaybe<Array<ContractPeriodDocumentBoolExp>>;
  _not?: InputMaybe<ContractPeriodDocumentBoolExp>;
  _or?: InputMaybe<Array<ContractPeriodDocumentBoolExp>>;
  contractPeriod?: InputMaybe<ContractPeriodBoolExp>;
  contractPeriodId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  file?: InputMaybe<FileBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  signedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<ContractPeriodDocumentStatusEnumComparisonExp>;
  type?: InputMaybe<ContractPeriodDocumentTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  yousignSignatureRequestId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "contract_period_document" */
export enum ContractPeriodDocumentConstraint {
  /** unique or primary key constraint on columns "file_id", "contract_period_id" */
  ContractPeriodDocumentPkey = 'contract_period_document_pkey',
  /** unique or primary key constraint on columns "yousign_signature_request_id" */
  ContractPeriodDocumentYousignSignatureRequestIdKey = 'contract_period_document_yousign_signature_request_id_key'
}

export type ContractPeriodDocumentId = {
  __typename?: 'ContractPeriodDocumentId';
  contractPeriodId: Scalars['String'];
  fileId: Scalars['String'];
};

export type ContractPeriodDocumentInput = {
  contractPeriodId: Scalars['uuid'];
  data: Scalars['base64'];
  filename: Scalars['String'];
  toSign?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/** input type for inserting data into table "contract_period_document" */
export type ContractPeriodDocumentInsertInput = {
  contractPeriod?: InputMaybe<ContractPeriodObjRelInsertInput>;
  contractPeriodId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<FileObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Signature status of the document. If null, then the document doesn't need to be signed */
  status?: InputMaybe<ContractPeriodDocumentStatusEnum>;
  type?: InputMaybe<ContractPeriodDocumentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  yousignSignatureRequestId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractPeriodDocumentMaxFields = {
  __typename?: 'ContractPeriodDocumentMaxFields';
  contractPeriodId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  yousignSignatureRequestId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "contract_period_document" */
export type ContractPeriodDocumentMaxOrderBy = {
  contractPeriodId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  yousignSignatureRequestId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContractPeriodDocumentMinFields = {
  __typename?: 'ContractPeriodDocumentMinFields';
  contractPeriodId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileId?: Maybe<Scalars['uuid']>;
  signedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  yousignSignatureRequestId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "contract_period_document" */
export type ContractPeriodDocumentMinOrderBy = {
  contractPeriodId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  yousignSignatureRequestId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "contract_period_document" */
export type ContractPeriodDocumentMutationResponse = {
  __typename?: 'ContractPeriodDocumentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractPeriodDocument>;
};

/** input type for inserting object relation for remote table "contract_period_document" */
export type ContractPeriodDocumentObjRelInsertInput = {
  data: ContractPeriodDocumentInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ContractPeriodDocumentOnConflict>;
};

/** on_conflict condition type for table "contract_period_document" */
export type ContractPeriodDocumentOnConflict = {
  constraint: ContractPeriodDocumentConstraint;
  updateColumns?: Array<ContractPeriodDocumentUpdateColumn>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};

/** Ordering options when selecting data from "contract_period_document". */
export type ContractPeriodDocumentOrderBy = {
  contractPeriod?: InputMaybe<ContractPeriodOrderBy>;
  contractPeriodId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<OrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  yousignSignatureRequestId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_period_document */
export type ContractPeriodDocumentPkColumnsInput = {
  contractPeriodId: Scalars['uuid'];
  fileId: Scalars['uuid'];
};

/** select columns of table "contract_period_document" */
export enum ContractPeriodDocumentSelectColumn {
  /** column name */
  ContractPeriodId = 'contractPeriodId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  YousignSignatureRequestId = 'yousignSignatureRequestId'
}

/** input type for updating data in table "contract_period_document" */
export type ContractPeriodDocumentSetInput = {
  contractPeriodId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Signature status of the document. If null, then the document doesn't need to be signed */
  status?: InputMaybe<ContractPeriodDocumentStatusEnum>;
  type?: InputMaybe<ContractPeriodDocumentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  yousignSignatureRequestId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "contract_period_document_status" */
export type ContractPeriodDocumentStatus = {
  __typename?: 'ContractPeriodDocumentStatus';
  value: Scalars['String'];
};

/** aggregated selection of "contract_period_document_status" */
export type ContractPeriodDocumentStatusAggregate = {
  __typename?: 'ContractPeriodDocumentStatusAggregate';
  aggregate?: Maybe<ContractPeriodDocumentStatusAggregateFields>;
  nodes: Array<ContractPeriodDocumentStatus>;
};

/** aggregate fields of "contract_period_document_status" */
export type ContractPeriodDocumentStatusAggregateFields = {
  __typename?: 'ContractPeriodDocumentStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractPeriodDocumentStatusMaxFields>;
  min?: Maybe<ContractPeriodDocumentStatusMinFields>;
};


/** aggregate fields of "contract_period_document_status" */
export type ContractPeriodDocumentStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractPeriodDocumentStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contract_period_document_status". All fields are combined with a logical 'AND'. */
export type ContractPeriodDocumentStatusBoolExp = {
  _and?: InputMaybe<Array<ContractPeriodDocumentStatusBoolExp>>;
  _not?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
  _or?: InputMaybe<Array<ContractPeriodDocumentStatusBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "contract_period_document_status" */
export enum ContractPeriodDocumentStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  ContractPeriodDocumentStatusPkey = 'contract_period_document_status_pkey'
}

export enum ContractPeriodDocumentStatusEnum {
  Signed = 'SIGNED',
  Unsigned = 'UNSIGNED'
}

/** Boolean expression to compare columns of type "ContractPeriodDocumentStatusEnum". All fields are combined with logical 'AND'. */
export type ContractPeriodDocumentStatusEnumComparisonExp = {
  _eq?: InputMaybe<ContractPeriodDocumentStatusEnum>;
  _in?: InputMaybe<Array<ContractPeriodDocumentStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ContractPeriodDocumentStatusEnum>;
  _nin?: InputMaybe<Array<ContractPeriodDocumentStatusEnum>>;
};

/** input type for inserting data into table "contract_period_document_status" */
export type ContractPeriodDocumentStatusInsertInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractPeriodDocumentStatusMaxFields = {
  __typename?: 'ContractPeriodDocumentStatusMaxFields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ContractPeriodDocumentStatusMinFields = {
  __typename?: 'ContractPeriodDocumentStatusMinFields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contract_period_document_status" */
export type ContractPeriodDocumentStatusMutationResponse = {
  __typename?: 'ContractPeriodDocumentStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractPeriodDocumentStatus>;
};

/** on_conflict condition type for table "contract_period_document_status" */
export type ContractPeriodDocumentStatusOnConflict = {
  constraint: ContractPeriodDocumentStatusConstraint;
  updateColumns?: Array<ContractPeriodDocumentStatusUpdateColumn>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};

/** Ordering options when selecting data from "contract_period_document_status". */
export type ContractPeriodDocumentStatusOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_period_document_status */
export type ContractPeriodDocumentStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "contract_period_document_status" */
export enum ContractPeriodDocumentStatusSelectColumn {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "contract_period_document_status" */
export type ContractPeriodDocumentStatusSetInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contract_period_document_status" */
export type ContractPeriodDocumentStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractPeriodDocumentStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractPeriodDocumentStatusStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "contract_period_document_status" */
export enum ContractPeriodDocumentStatusUpdateColumn {
  /** column name */
  Value = 'value'
}

export type ContractPeriodDocumentStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractPeriodDocumentStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ContractPeriodDocumentStatusBoolExp;
};

/** Streaming cursor of the table "contract_period_document" */
export type ContractPeriodDocumentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractPeriodDocumentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractPeriodDocumentStreamCursorValueInput = {
  contractPeriodId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileId?: InputMaybe<Scalars['uuid']>;
  signedAt?: InputMaybe<Scalars['timestamptz']>;
  /** Signature status of the document. If null, then the document doesn't need to be signed */
  status?: InputMaybe<ContractPeriodDocumentStatusEnum>;
  type?: InputMaybe<ContractPeriodDocumentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  yousignSignatureRequestId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "contract_period_document_type" */
export type ContractPeriodDocumentType = {
  __typename?: 'ContractPeriodDocumentType';
  comment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "contract_period_document_type" */
export type ContractPeriodDocumentTypeAggregate = {
  __typename?: 'ContractPeriodDocumentTypeAggregate';
  aggregate?: Maybe<ContractPeriodDocumentTypeAggregateFields>;
  nodes: Array<ContractPeriodDocumentType>;
};

/** aggregate fields of "contract_period_document_type" */
export type ContractPeriodDocumentTypeAggregateFields = {
  __typename?: 'ContractPeriodDocumentTypeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractPeriodDocumentTypeMaxFields>;
  min?: Maybe<ContractPeriodDocumentTypeMinFields>;
};


/** aggregate fields of "contract_period_document_type" */
export type ContractPeriodDocumentTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractPeriodDocumentTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contract_period_document_type". All fields are combined with a logical 'AND'. */
export type ContractPeriodDocumentTypeBoolExp = {
  _and?: InputMaybe<Array<ContractPeriodDocumentTypeBoolExp>>;
  _not?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
  _or?: InputMaybe<Array<ContractPeriodDocumentTypeBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "contract_period_document_type" */
export enum ContractPeriodDocumentTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  ContractPeriodDocumentTypePkey = 'contract_period_document_type_pkey'
}

export enum ContractPeriodDocumentTypeEnum {
  Certificates = 'CERTIFICATES',
  GeneralConditions = 'GENERAL_CONDITIONS',
  Invoice = 'INVOICE',
  /** Any type of document that does not fit the rest of the list. */
  Other = 'OTHER',
  SpecificConditions = 'SPECIFIC_CONDITIONS'
}

/** Boolean expression to compare columns of type "ContractPeriodDocumentTypeEnum". All fields are combined with logical 'AND'. */
export type ContractPeriodDocumentTypeEnumComparisonExp = {
  _eq?: InputMaybe<ContractPeriodDocumentTypeEnum>;
  _in?: InputMaybe<Array<ContractPeriodDocumentTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ContractPeriodDocumentTypeEnum>;
  _nin?: InputMaybe<Array<ContractPeriodDocumentTypeEnum>>;
};

/** input type for inserting data into table "contract_period_document_type" */
export type ContractPeriodDocumentTypeInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractPeriodDocumentTypeMaxFields = {
  __typename?: 'ContractPeriodDocumentTypeMaxFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ContractPeriodDocumentTypeMinFields = {
  __typename?: 'ContractPeriodDocumentTypeMinFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contract_period_document_type" */
export type ContractPeriodDocumentTypeMutationResponse = {
  __typename?: 'ContractPeriodDocumentTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractPeriodDocumentType>;
};

/** on_conflict condition type for table "contract_period_document_type" */
export type ContractPeriodDocumentTypeOnConflict = {
  constraint: ContractPeriodDocumentTypeConstraint;
  updateColumns?: Array<ContractPeriodDocumentTypeUpdateColumn>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};

/** Ordering options when selecting data from "contract_period_document_type". */
export type ContractPeriodDocumentTypeOrderBy = {
  comment?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_period_document_type */
export type ContractPeriodDocumentTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "contract_period_document_type" */
export enum ContractPeriodDocumentTypeSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "contract_period_document_type" */
export type ContractPeriodDocumentTypeSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contract_period_document_type" */
export type ContractPeriodDocumentTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractPeriodDocumentTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractPeriodDocumentTypeStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "contract_period_document_type" */
export enum ContractPeriodDocumentTypeUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

export type ContractPeriodDocumentTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractPeriodDocumentTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ContractPeriodDocumentTypeBoolExp;
};

/** update columns of table "contract_period_document" */
export enum ContractPeriodDocumentUpdateColumn {
  /** column name */
  ContractPeriodId = 'contractPeriodId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  SignedAt = 'signedAt',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  YousignSignatureRequestId = 'yousignSignatureRequestId'
}

export type ContractPeriodDocumentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractPeriodDocumentSetInput>;
  /** filter the rows which have to be updated */
  where: ContractPeriodDocumentBoolExp;
};

export type ContractPeriodId = {
  __typename?: 'ContractPeriodId';
  contractPeriod?: Maybe<ContractPeriod>;
  id: Scalars['ID'];
};

/** input type for incrementing numeric columns in table "contract_period" */
export type ContractPeriodIncInput = {
  turnover?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "contract_period" */
export type ContractPeriodInsertInput = {
  broker?: InputMaybe<BrokerObjRelInsertInput>;
  brokerId?: InputMaybe<Scalars['uuid']>;
  contract?: InputMaybe<ContractObjRelInsertInput>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  dbPremium?: InputMaybe<Scalars['jsonb']>;
  documents?: InputMaybe<ContractPeriodDocumentArrRelInsertInput>;
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurer?: InputMaybe<InsurerObjRelInsertInput>;
  insurerId?: InputMaybe<Scalars['uuid']>;
  promoCode?: InputMaybe<PromoCodeObjRelInsertInput>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  renewalDate?: InputMaybe<Scalars['date']>;
  startDate?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<ContractPeriodStatusEnum>;
  stripeSubscriptionScheduleId?: InputMaybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: InputMaybe<Scalars['date']>;
  /** Wether the contract should be renewed at the end of the period or not */
  terminateAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  turnover?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContractPeriodMaxFields = {
  __typename?: 'ContractPeriodMaxFields';
  brokerId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  insurerId?: Maybe<Scalars['uuid']>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  renewalDate?: Maybe<Scalars['date']>;
  startDate?: Maybe<Scalars['date']>;
  stripeSubscriptionScheduleId?: Maybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: Maybe<Scalars['date']>;
  turnover?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "contract_period" */
export type ContractPeriodMaxOrderBy = {
  brokerId?: InputMaybe<OrderBy>;
  contractId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  insurerId?: InputMaybe<OrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  stripeSubscriptionScheduleId?: InputMaybe<OrderBy>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: InputMaybe<OrderBy>;
  turnover?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContractPeriodMinFields = {
  __typename?: 'ContractPeriodMinFields';
  brokerId?: Maybe<Scalars['uuid']>;
  contractId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  insurerId?: Maybe<Scalars['uuid']>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  renewalDate?: Maybe<Scalars['date']>;
  startDate?: Maybe<Scalars['date']>;
  stripeSubscriptionScheduleId?: Maybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: Maybe<Scalars['date']>;
  turnover?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "contract_period" */
export type ContractPeriodMinOrderBy = {
  brokerId?: InputMaybe<OrderBy>;
  contractId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  insurerId?: InputMaybe<OrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  stripeSubscriptionScheduleId?: InputMaybe<OrderBy>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: InputMaybe<OrderBy>;
  turnover?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "contract_period" */
export type ContractPeriodMutationResponse = {
  __typename?: 'ContractPeriodMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractPeriod>;
};

/** input type for inserting object relation for remote table "contract_period" */
export type ContractPeriodObjRelInsertInput = {
  data: ContractPeriodInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ContractPeriodOnConflict>;
};

/** on_conflict condition type for table "contract_period" */
export type ContractPeriodOnConflict = {
  constraint: ContractPeriodConstraint;
  updateColumns?: Array<ContractPeriodUpdateColumn>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};

/** Ordering options when selecting data from "contract_period". */
export type ContractPeriodOrderBy = {
  broker?: InputMaybe<BrokerOrderBy>;
  brokerId?: InputMaybe<OrderBy>;
  contract?: InputMaybe<ContractOrderBy>;
  contractId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbDetails?: InputMaybe<OrderBy>;
  dbPremium?: InputMaybe<OrderBy>;
  documentsAggregate?: InputMaybe<ContractPeriodDocumentAggregateOrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  insurer?: InputMaybe<InsurerOrderBy>;
  insurerId?: InputMaybe<OrderBy>;
  promoCode?: InputMaybe<PromoCodeOrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeSubscriptionScheduleId?: InputMaybe<OrderBy>;
  terminateAskedAt?: InputMaybe<OrderBy>;
  terminateAtPeriodEnd?: InputMaybe<OrderBy>;
  turnover?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_period */
export type ContractPeriodPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContractPeriodPrependInput = {
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  dbPremium?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "contract_period" */
export enum ContractPeriodSelectColumn {
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbDetails = 'dbDetails',
  /** column name */
  DbPremium = 'dbPremium',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  InsurerId = 'insurerId',
  /** column name */
  PromoCodeId = 'promoCodeId',
  /** column name */
  RenewalDate = 'renewalDate',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionScheduleId = 'stripeSubscriptionScheduleId',
  /** column name */
  TerminateAskedAt = 'terminateAskedAt',
  /** column name */
  TerminateAtPeriodEnd = 'terminateAtPeriodEnd',
  /** column name */
  Turnover = 'turnover',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "contractPeriodAggregateBoolExpBool_andArgumentsColumns" columns of table "contract_period" */
export enum ContractPeriodSelectColumnContractPeriodAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  TerminateAtPeriodEnd = 'terminateAtPeriodEnd'
}

/** select "contractPeriodAggregateBoolExpBool_orArgumentsColumns" columns of table "contract_period" */
export enum ContractPeriodSelectColumnContractPeriodAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  TerminateAtPeriodEnd = 'terminateAtPeriodEnd'
}

/** input type for updating data in table "contract_period" */
export type ContractPeriodSetInput = {
  brokerId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  dbPremium?: InputMaybe<Scalars['jsonb']>;
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurerId?: InputMaybe<Scalars['uuid']>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  renewalDate?: InputMaybe<Scalars['date']>;
  startDate?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<ContractPeriodStatusEnum>;
  stripeSubscriptionScheduleId?: InputMaybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: InputMaybe<Scalars['date']>;
  /** Wether the contract should be renewed at the end of the period or not */
  terminateAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  turnover?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "contract_period_status" */
export type ContractPeriodStatus = {
  __typename?: 'ContractPeriodStatus';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "contract_period_status" */
export type ContractPeriodStatusAggregate = {
  __typename?: 'ContractPeriodStatusAggregate';
  aggregate?: Maybe<ContractPeriodStatusAggregateFields>;
  nodes: Array<ContractPeriodStatus>;
};

/** aggregate fields of "contract_period_status" */
export type ContractPeriodStatusAggregateFields = {
  __typename?: 'ContractPeriodStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContractPeriodStatusMaxFields>;
  min?: Maybe<ContractPeriodStatusMinFields>;
};


/** aggregate fields of "contract_period_status" */
export type ContractPeriodStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContractPeriodStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contract_period_status". All fields are combined with a logical 'AND'. */
export type ContractPeriodStatusBoolExp = {
  _and?: InputMaybe<Array<ContractPeriodStatusBoolExp>>;
  _not?: InputMaybe<ContractPeriodStatusBoolExp>;
  _or?: InputMaybe<Array<ContractPeriodStatusBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "contract_period_status" */
export enum ContractPeriodStatusConstraint {
  /** unique or primary key constraint on columns "value" */
  ContractPeriodStatusPkey = 'contract_period_status_pkey'
}

export enum ContractPeriodStatusEnum {
  /** Contract period is paid, no action is required from the user or Olino */
  Active = 'ACTIVE',
  /** The delay for the user to sign the contract has expired */
  Expired = 'EXPIRED',
  /** Contract perioid has ended, no action is required from the user or Olino */
  Finished = 'FINISHED',
  /** A payment is due for this contract period */
  PaymentDue = 'PAYMENT_DUE',
  /** The contract is signed by the user and the start of the contract is pending */
  StartPending = 'START_PENDING',
  /** The user gave their payment informations and the contract is ready to be signed by the user */
  Unsigned = 'UNSIGNED'
}

/** Boolean expression to compare columns of type "ContractPeriodStatusEnum". All fields are combined with logical 'AND'. */
export type ContractPeriodStatusEnumComparisonExp = {
  _eq?: InputMaybe<ContractPeriodStatusEnum>;
  _in?: InputMaybe<Array<ContractPeriodStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ContractPeriodStatusEnum>;
  _nin?: InputMaybe<Array<ContractPeriodStatusEnum>>;
};

/** input type for inserting data into table "contract_period_status" */
export type ContractPeriodStatusInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContractPeriodStatusMaxFields = {
  __typename?: 'ContractPeriodStatusMaxFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ContractPeriodStatusMinFields = {
  __typename?: 'ContractPeriodStatusMinFields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contract_period_status" */
export type ContractPeriodStatusMutationResponse = {
  __typename?: 'ContractPeriodStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContractPeriodStatus>;
};

/** on_conflict condition type for table "contract_period_status" */
export type ContractPeriodStatusOnConflict = {
  constraint: ContractPeriodStatusConstraint;
  updateColumns?: Array<ContractPeriodStatusUpdateColumn>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};

/** Ordering options when selecting data from "contract_period_status". */
export type ContractPeriodStatusOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract_period_status */
export type ContractPeriodStatusPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "contract_period_status" */
export enum ContractPeriodStatusSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "contract_period_status" */
export type ContractPeriodStatusSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contract_period_status" */
export type ContractPeriodStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractPeriodStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractPeriodStatusStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "contract_period_status" */
export enum ContractPeriodStatusUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type ContractPeriodStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractPeriodStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ContractPeriodStatusBoolExp;
};

/** aggregate stddev on columns */
export type ContractPeriodStddevFields = {
  __typename?: 'ContractPeriodStddevFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "contract_period" */
export type ContractPeriodStddevOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ContractPeriodStddevPopFields = {
  __typename?: 'ContractPeriodStddevPopFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "contract_period" */
export type ContractPeriodStddevPopOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ContractPeriodStddevSampFields = {
  __typename?: 'ContractPeriodStddevSampFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "contract_period" */
export type ContractPeriodStddevSampOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "contract_period" */
export type ContractPeriodStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractPeriodStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractPeriodStreamCursorValueInput = {
  brokerId?: InputMaybe<Scalars['uuid']>;
  contractId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  dbPremium?: InputMaybe<Scalars['jsonb']>;
  endDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurerId?: InputMaybe<Scalars['uuid']>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  renewalDate?: InputMaybe<Scalars['date']>;
  startDate?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<ContractPeriodStatusEnum>;
  stripeSubscriptionScheduleId?: InputMaybe<Scalars['String']>;
  /** Date at which the company asked for the contract to be terminated */
  terminateAskedAt?: InputMaybe<Scalars['date']>;
  /** Wether the contract should be renewed at the end of the period or not */
  terminateAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  turnover?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ContractPeriodSumFields = {
  __typename?: 'ContractPeriodSumFields';
  turnover?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "contract_period" */
export type ContractPeriodSumOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** update columns of table "contract_period" */
export enum ContractPeriodUpdateColumn {
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbDetails = 'dbDetails',
  /** column name */
  DbPremium = 'dbPremium',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  InsurerId = 'insurerId',
  /** column name */
  PromoCodeId = 'promoCodeId',
  /** column name */
  RenewalDate = 'renewalDate',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionScheduleId = 'stripeSubscriptionScheduleId',
  /** column name */
  TerminateAskedAt = 'terminateAskedAt',
  /** column name */
  TerminateAtPeriodEnd = 'terminateAtPeriodEnd',
  /** column name */
  Turnover = 'turnover',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ContractPeriodUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContractPeriodAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ContractPeriodDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ContractPeriodDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ContractPeriodDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContractPeriodIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContractPeriodPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractPeriodSetInput>;
  /** filter the rows which have to be updated */
  where: ContractPeriodBoolExp;
};

/** aggregate varPop on columns */
export type ContractPeriodVarPopFields = {
  __typename?: 'ContractPeriodVarPopFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "contract_period" */
export type ContractPeriodVarPopOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ContractPeriodVarSampFields = {
  __typename?: 'ContractPeriodVarSampFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "contract_period" */
export type ContractPeriodVarSampOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContractPeriodVarianceFields = {
  __typename?: 'ContractPeriodVarianceFields';
  turnover?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "contract_period" */
export type ContractPeriodVarianceOrderBy = {
  turnover?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contract */
export type ContractPkColumnsInput = {
  id: Scalars['uuid'];
};

export type ContractPremium = {
  /** Application fees that are added to the total premium */
  applicationFees: ApplicationFees;
  /** Base premium, before applying options */
  base?: Maybe<MoneyBag>;
  /** Commission value, without taxes */
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  /** Total premium, including options */
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

/** select columns of table "contract" */
export enum ContractSelectColumn {
  /** column name */
  BillingAddressId = 'billingAddressId',
  /** column name */
  CompanyAddressId = 'companyAddressId',
  /** column name */
  CompanyFoundedAt = 'companyFoundedAt',
  /** column name */
  CompanyLegalStatus = 'companyLegalStatus',
  /** column name */
  CompanyNafCode = 'companyNafCode',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CompanySiret = 'companySiret',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdPoliceSesame = 'idPoliceSesame',
  /** column name */
  Mode = 'mode',
  /** column name */
  Number = 'number',
  /** column name */
  Product = 'product',
  /** column name */
  QuotationId = 'quotationId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedSesameAt = 'updatedSesameAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "contract" */
export type ContractSetInput = {
  billingAddressId?: InputMaybe<Scalars['uuid']>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyFoundedAt?: InputMaybe<Scalars['date']>;
  companyLegalStatus?: InputMaybe<Scalars['String']>;
  companyNafCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companySiret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPoliceSesame?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<ContractModeEnum>;
  number?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductEnum>;
  quotationId?: InputMaybe<Scalars['uuid']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "contract" */
export type ContractStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContractStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContractStreamCursorValueInput = {
  billingAddressId?: InputMaybe<Scalars['uuid']>;
  companyAddressId?: InputMaybe<Scalars['uuid']>;
  companyFoundedAt?: InputMaybe<Scalars['date']>;
  companyLegalStatus?: InputMaybe<Scalars['String']>;
  companyNafCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companySiret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPoliceSesame?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<ContractModeEnum>;
  number?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductEnum>;
  quotationId?: InputMaybe<Scalars['uuid']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "contract" */
export enum ContractUpdateColumn {
  /** column name */
  BillingAddressId = 'billingAddressId',
  /** column name */
  CompanyAddressId = 'companyAddressId',
  /** column name */
  CompanyFoundedAt = 'companyFoundedAt',
  /** column name */
  CompanyLegalStatus = 'companyLegalStatus',
  /** column name */
  CompanyNafCode = 'companyNafCode',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  CompanySiret = 'companySiret',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdPoliceSesame = 'idPoliceSesame',
  /** column name */
  Mode = 'mode',
  /** column name */
  Number = 'number',
  /** column name */
  Product = 'product',
  /** column name */
  QuotationId = 'quotationId',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedSesameAt = 'updatedSesameAt',
  /** column name */
  UserId = 'userId'
}

export type ContractUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContractSetInput>;
  /** filter the rows which have to be updated */
  where: ContractBoolExp;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "country" */
export type CountryAggregate = {
  __typename?: 'CountryAggregate';
  aggregate?: Maybe<CountryAggregateFields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type CountryAggregateFields = {
  __typename?: 'CountryAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CountryMaxFields>;
  min?: Maybe<CountryMinFields>;
};


/** aggregate fields of "country" */
export type CountryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountrySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type CountryBoolExp = {
  _and?: InputMaybe<Array<CountryBoolExp>>;
  _not?: InputMaybe<CountryBoolExp>;
  _or?: InputMaybe<Array<CountryBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "country" */
export enum CountryConstraint {
  /** unique or primary key constraint on columns "code" */
  CountryCodeKey = 'country_code_key',
  /** unique or primary key constraint on columns "name" */
  CountryPkey = 'country_pkey'
}

export enum CountryEnum {
  /** FR */
  France = 'FRANCE'
}

/** Boolean expression to compare columns of type "CountryEnum". All fields are combined with logical 'AND'. */
export type CountryEnumComparisonExp = {
  _eq?: InputMaybe<CountryEnum>;
  _in?: InputMaybe<Array<CountryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CountryEnum>;
  _nin?: InputMaybe<Array<CountryEnum>>;
};

/** input type for inserting data into table "country" */
export type CountryInsertInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CountryMaxFields = {
  __typename?: 'CountryMaxFields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CountryMinFields = {
  __typename?: 'CountryMinFields';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "country" */
export type CountryMutationResponse = {
  __typename?: 'CountryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** on_conflict condition type for table "country" */
export type CountryOnConflict = {
  constraint: CountryConstraint;
  updateColumns?: Array<CountryUpdateColumn>;
  where?: InputMaybe<CountryBoolExp>;
};

/** Ordering options when selecting data from "country". */
export type CountryOrderBy = {
  code?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country */
export type CountryPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "country" */
export enum CountrySelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "country" */
export type CountrySetInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "country" */
export type CountryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountryStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "country" */
export enum CountryUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  Name = 'name'
}

export type CountryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountrySetInput>;
  /** filter the rows which have to be updated */
  where: CountryBoolExp;
};

export type CreateContractPeriod = {
  assistanceDomestiqueDetails?: InputMaybe<AssistanceDomestiqueContractDetailsInput>;
  assistanceDomestiquePremium?: InputMaybe<AssistanceDomestiqueContractPremiumInput>;
  assistanceDomestiqueProfessionnelDetails?: InputMaybe<AssistanceDomestiqueProfessionnelContractDetailsInput>;
  assistanceDomestiqueProfessionnelPremium?: InputMaybe<AssistanceDomestiqueProfessionnelContractPremiumInput>;
  autoDetails?: InputMaybe<AutoContractDetailsInput>;
  autoMissionPremium?: InputMaybe<AutoMissionContractPremiumInput>;
  autoPremium?: InputMaybe<AutoContractPremiumInput>;
  brokerId?: InputMaybe<Scalars['uuid']>;
  contractId: Scalars['uuid'];
  cybersecurityDetails?: InputMaybe<CyberSecurityContractDetailsInput>;
  cybersecurityPremium?: InputMaybe<CyberSecurityContractPremiumInput>;
  dAndOPremium?: InputMaybe<DAndOContractPremiumInput>;
  decennialPremium?: InputMaybe<DecennialContractPremiumInput>;
  healthPremium?: InputMaybe<HealthContractPremiumInput>;
  insurerId: Scalars['uuid'];
  keyPersonPremium?: InputMaybe<KeyPersonContractPremiumInput>;
  legalPremium?: InputMaybe<LegalContractPremiumInput>;
  lifePremium?: InputMaybe<LifeContractPremiumInput>;
  mreAcheelDetails?: InputMaybe<MreAcheelContractDetailsInput>;
  mreAcheelPremium?: InputMaybe<MreAcheelContractPremiumInput>;
  multiRiskDetails?: InputMaybe<MultiRiskContractDetailsInput>;
  multiRiskPremium?: InputMaybe<MultiRiskContractPremiumInput>;
  otherPremium?: InputMaybe<OtherContractPremiumInput>;
  publicLiabilityDetails?: InputMaybe<PublicLiabilityContractDetailsInput>;
  publicLiabilityEcommDetails?: InputMaybe<PublicLiabilityEcommContractDetailsInput>;
  publicLiabilityEcommPremium?: InputMaybe<PublicLiabilityEcommContractPremiumInput>;
  publicLiabilityPremium?: InputMaybe<PublicLiabilityContractPremiumInput>;
  startDate: Scalars['date'];
  status: ContractPeriodStatusEnum;
  terminateAskedAt?: InputMaybe<Scalars['date']>;
  terminateAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  turnover?: InputMaybe<Scalars['Int']>;
};

export enum Currency {
  Euro = 'EURO'
}

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type CyberSecurityContractDetails = {
  __typename?: 'CyberSecurityContractDetails';
  activityId: Scalars['Int'];
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
};

export type CyberSecurityContractDetailsInput = {
  activityId: Scalars['Int'];
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
};

export type CyberSecurityContractPremium = ContractPremium & {
  __typename?: 'CyberSecurityContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type CyberSecurityContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type DAndOContractPremium = ContractPremium & {
  __typename?: 'DAndOContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type DAndOContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "db_address" */
export type DbAddress = {
  __typename?: 'DbAddress';
  /** An array relationship */
  billingAddressContracts: Array<Contract>;
  /** An aggregate relationship */
  billingAddressContractsAggregate: ContractAggregate;
  city: Scalars['String'];
  /** An array relationship */
  companyAddressContracts: Array<Contract>;
  /** An aggregate relationship */
  companyAddressContractsAggregate: ContractAggregate;
  country: CountryEnum;
  id: Scalars['uuid'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
};


/** columns and relationships of "db_address" */
export type DbAddressBillingAddressContractsArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


/** columns and relationships of "db_address" */
export type DbAddressBillingAddressContractsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


/** columns and relationships of "db_address" */
export type DbAddressCompanyAddressContractsArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


/** columns and relationships of "db_address" */
export type DbAddressCompanyAddressContractsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};

/** aggregated selection of "db_address" */
export type DbAddressAggregate = {
  __typename?: 'DbAddressAggregate';
  aggregate?: Maybe<DbAddressAggregateFields>;
  nodes: Array<DbAddress>;
};

/** aggregate fields of "db_address" */
export type DbAddressAggregateFields = {
  __typename?: 'DbAddressAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<DbAddressMaxFields>;
  min?: Maybe<DbAddressMinFields>;
};


/** aggregate fields of "db_address" */
export type DbAddressAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DbAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "db_address". All fields are combined with a logical 'AND'. */
export type DbAddressBoolExp = {
  _and?: InputMaybe<Array<DbAddressBoolExp>>;
  _not?: InputMaybe<DbAddressBoolExp>;
  _or?: InputMaybe<Array<DbAddressBoolExp>>;
  billingAddressContracts?: InputMaybe<ContractBoolExp>;
  billingAddressContractsAggregate?: InputMaybe<ContractAggregateBoolExp>;
  city?: InputMaybe<StringComparisonExp>;
  companyAddressContracts?: InputMaybe<ContractBoolExp>;
  companyAddressContractsAggregate?: InputMaybe<ContractAggregateBoolExp>;
  country?: InputMaybe<CountryEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  line1?: InputMaybe<StringComparisonExp>;
  line2?: InputMaybe<StringComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "db_address" */
export enum DbAddressConstraint {
  /** unique or primary key constraint on columns "id" */
  DbAddressPkey = 'db_address_pkey'
}

/** input type for inserting data into table "db_address" */
export type DbAddressInsertInput = {
  billingAddressContracts?: InputMaybe<ContractArrRelInsertInput>;
  city?: InputMaybe<Scalars['String']>;
  companyAddressContracts?: InputMaybe<ContractArrRelInsertInput>;
  country?: InputMaybe<CountryEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DbAddressMaxFields = {
  __typename?: 'DbAddressMaxFields';
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DbAddressMinFields = {
  __typename?: 'DbAddressMinFields';
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "db_address" */
export type DbAddressMutationResponse = {
  __typename?: 'DbAddressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DbAddress>;
};

/** input type for inserting object relation for remote table "db_address" */
export type DbAddressObjRelInsertInput = {
  data: DbAddressInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DbAddressOnConflict>;
};

/** on_conflict condition type for table "db_address" */
export type DbAddressOnConflict = {
  constraint: DbAddressConstraint;
  updateColumns?: Array<DbAddressUpdateColumn>;
  where?: InputMaybe<DbAddressBoolExp>;
};

/** Ordering options when selecting data from "db_address". */
export type DbAddressOrderBy = {
  billingAddressContractsAggregate?: InputMaybe<ContractAggregateOrderBy>;
  city?: InputMaybe<OrderBy>;
  companyAddressContractsAggregate?: InputMaybe<ContractAggregateOrderBy>;
  country?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  line1?: InputMaybe<OrderBy>;
  line2?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: db_address */
export type DbAddressPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "db_address" */
export enum DbAddressSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  PostalCode = 'postalCode'
}

/** input type for updating data in table "db_address" */
export type DbAddressSetInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "db_address" */
export type DbAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DbAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbAddressStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryEnum>;
  id?: InputMaybe<Scalars['uuid']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "db_address" */
export enum DbAddressUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Id = 'id',
  /** column name */
  Line1 = 'line1',
  /** column name */
  Line2 = 'line2',
  /** column name */
  PostalCode = 'postalCode'
}

export type DbAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DbAddressSetInput>;
  /** filter the rows which have to be updated */
  where: DbAddressBoolExp;
};

export type DealCreate = {
  __typename?: 'DealCreate';
  activeCampaignDealId: Scalars['Int'];
  activeCampaignId: Scalars['Int'];
  number: Scalars['String'];
};

export type DealCreateInput = {
  quotation: QuotationInput;
};

export type DecennialContractPremium = ContractPremium & {
  __typename?: 'DecennialContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type DecennialContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

/** columns and relationships of "file" */
export type File = {
  __typename?: 'File';
  bucket: Scalars['String'];
  /** An object relationship */
  contractPeriodDocument?: Maybe<ContractPeriodDocument>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** A computed field, executes function "file_filename" */
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  partnerIban?: Maybe<Partner>;
  /** An object relationship */
  partnerLogo?: Maybe<Partner>;
  path: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "file" */
export type FileAggregate = {
  __typename?: 'FileAggregate';
  aggregate?: Maybe<FileAggregateFields>;
  nodes: Array<File>;
};

/** aggregate fields of "file" */
export type FileAggregateFields = {
  __typename?: 'FileAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FileMaxFields>;
  min?: Maybe<FileMinFields>;
};


/** aggregate fields of "file" */
export type FileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type FileBoolExp = {
  _and?: InputMaybe<Array<FileBoolExp>>;
  _not?: InputMaybe<FileBoolExp>;
  _or?: InputMaybe<Array<FileBoolExp>>;
  bucket?: InputMaybe<StringComparisonExp>;
  contractPeriodDocument?: InputMaybe<ContractPeriodDocumentBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  partnerIban?: InputMaybe<PartnerBoolExp>;
  partnerLogo?: InputMaybe<PartnerBoolExp>;
  path?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "file" */
export enum FileConstraint {
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey'
}

/** input type for inserting data into table "file" */
export type FileInsertInput = {
  bucket?: InputMaybe<Scalars['String']>;
  contractPeriodDocument?: InputMaybe<ContractPeriodDocumentObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  partnerIban?: InputMaybe<PartnerObjRelInsertInput>;
  partnerLogo?: InputMaybe<PartnerObjRelInsertInput>;
  path?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FileMaxFields = {
  __typename?: 'FileMaxFields';
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "file_filename" */
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FileMinFields = {
  __typename?: 'FileMinFields';
  bucket?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "file_filename" */
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "file" */
export type FileMutationResponse = {
  __typename?: 'FileMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "file" */
export type FileObjRelInsertInput = {
  data: FileInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<FileOnConflict>;
};

/** on_conflict condition type for table "file" */
export type FileOnConflict = {
  constraint: FileConstraint;
  updateColumns?: Array<FileUpdateColumn>;
  where?: InputMaybe<FileBoolExp>;
};

/** Ordering options when selecting data from "file". */
export type FileOrderBy = {
  bucket?: InputMaybe<OrderBy>;
  contractPeriodDocument?: InputMaybe<ContractPeriodDocumentOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  partnerIban?: InputMaybe<PartnerOrderBy>;
  partnerLogo?: InputMaybe<PartnerOrderBy>;
  path?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: file */
export type FilePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "file" */
export enum FileSelectColumn {
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "file" */
export type FileSetInput = {
  bucket?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "file" */
export type FileStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileStreamCursorValueInput = {
  bucket?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  path?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "file" */
export enum FileUpdateColumn {
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type FileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileSetInput>;
  /** filter the rows which have to be updated */
  where: FileBoolExp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type HealthContractPremium = ContractPremium & {
  __typename?: 'HealthContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type HealthContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

/** columns and relationships of "insurer" */
export type Insurer = {
  __typename?: 'Insurer';
  /** An array relationship */
  contractPeriods: Array<ContractPeriod>;
  /** An aggregate relationship */
  contractPeriodsAggregate: ContractPeriodAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "insurer" */
export type InsurerContractPeriodsArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


/** columns and relationships of "insurer" */
export type InsurerContractPeriodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};

/** aggregated selection of "insurer" */
export type InsurerAggregate = {
  __typename?: 'InsurerAggregate';
  aggregate?: Maybe<InsurerAggregateFields>;
  nodes: Array<Insurer>;
};

/** aggregate fields of "insurer" */
export type InsurerAggregateFields = {
  __typename?: 'InsurerAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InsurerMaxFields>;
  min?: Maybe<InsurerMinFields>;
};


/** aggregate fields of "insurer" */
export type InsurerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InsurerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "insurer". All fields are combined with a logical 'AND'. */
export type InsurerBoolExp = {
  _and?: InputMaybe<Array<InsurerBoolExp>>;
  _not?: InputMaybe<InsurerBoolExp>;
  _or?: InputMaybe<Array<InsurerBoolExp>>;
  contractPeriods?: InputMaybe<ContractPeriodBoolExp>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "insurer" */
export enum InsurerConstraint {
  /** unique or primary key constraint on columns "id" */
  InsurerPkey = 'insurer_pkey'
}

/** input type for inserting data into table "insurer" */
export type InsurerInsertInput = {
  contractPeriods?: InputMaybe<ContractPeriodArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type InsurerMaxFields = {
  __typename?: 'InsurerMaxFields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type InsurerMinFields = {
  __typename?: 'InsurerMinFields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "insurer" */
export type InsurerMutationResponse = {
  __typename?: 'InsurerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Insurer>;
};

/** input type for inserting object relation for remote table "insurer" */
export type InsurerObjRelInsertInput = {
  data: InsurerInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InsurerOnConflict>;
};

/** on_conflict condition type for table "insurer" */
export type InsurerOnConflict = {
  constraint: InsurerConstraint;
  updateColumns?: Array<InsurerUpdateColumn>;
  where?: InputMaybe<InsurerBoolExp>;
};

/** Ordering options when selecting data from "insurer". */
export type InsurerOrderBy = {
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: insurer */
export type InsurerPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "insurer" */
export enum InsurerSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "insurer" */
export type InsurerSetInput = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "insurer" */
export type InsurerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InsurerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InsurerStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "insurer" */
export enum InsurerUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type InsurerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InsurerSetInput>;
  /** filter the rows which have to be updated */
  where: InsurerBoolExp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

export type KeyPersonContractPremium = ContractPremium & {
  __typename?: 'KeyPersonContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type KeyPersonContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type LegalContractPremium = ContractPremium & {
  __typename?: 'LegalContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type LegalContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type LifeContractPremium = ContractPremium & {
  __typename?: 'LifeContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type LifeContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type MoneyBag = {
  __typename?: 'MoneyBag';
  currency: Currency;
  taxExcluded: Scalars['Float'];
  taxIncluded: Scalars['Float'];
};

export type MoneyBagInput = {
  currency: Currency;
  taxExcluded: Scalars['Float'];
  taxIncluded: Scalars['Float'];
};

export type MreAcheelContractDetails = {
  __typename?: 'MreAcheelContractDetails';
  activityId: Scalars['Int'];
  addressMAcheel: Address;
  deductibleAmount: Scalars['Float'];
  extincteursLocaux?: Maybe<Scalars['Boolean']>;
  historicalMonument?: Maybe<Scalars['Boolean']>;
  installElectriqueVerif?: Maybe<Scalars['Boolean']>;
  nbSinistres?: Maybe<Scalars['Int']>;
  packageOptionMAcheel?: Maybe<MreAcheelPackage>;
  procedureCollective?: Maybe<Scalars['Boolean']>;
  resilieNonPaiement?: Maybe<Scalars['Boolean']>;
  surfaceArea: Scalars['Float'];
};

export type MreAcheelContractDetailsInput = {
  activityId: Scalars['Int'];
  addressMAcheel: AddressInput;
  deductibleAmount: Scalars['Float'];
  extincteursLocaux?: InputMaybe<Scalars['Boolean']>;
  historicalMonument?: InputMaybe<Scalars['Boolean']>;
  installElectriqueVerif?: InputMaybe<Scalars['Boolean']>;
  nbSinistres?: InputMaybe<Scalars['Int']>;
  packageOption?: InputMaybe<MreAcheelPackage>;
  procedureCollective?: InputMaybe<Scalars['Boolean']>;
  resilieNonPaiement?: InputMaybe<Scalars['Boolean']>;
  surfaceArea: Scalars['Float'];
};

export type MreAcheelContractPremium = ContractPremium & {
  __typename?: 'MreAcheelContractPremium';
  applicationFees: ApplicationFees;
  applicationFeesTotal?: Maybe<Scalars['Float']>;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  terrorismTax?: Maybe<Scalars['Float']>;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type MreAcheelContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  applicationFeesTotal?: InputMaybe<Scalars['Float']>;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  terrorismTax?: InputMaybe<Scalars['Float']>;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export enum MreAcheelPackage {
  Basic = 'BASIC',
  Comfort = 'COMFORT',
  Premium = 'PREMIUM'
}

export type MreAcheelQuotationCovers = {
  __typename?: 'MreAcheelQuotationCovers';
  Lci?: Maybe<Scalars['String']>;
  allComputerRisks?: Maybe<Scalars['String']>;
  chambreFroide?: Maybe<Scalars['Boolean']>;
  chocVehiculesTer?: Maybe<Scalars['Boolean']>;
  fire?: Maybe<Scalars['String']>;
  fraisExploitation?: Maybe<Scalars['String']>;
  glassBreakage?: Maybe<Scalars['String']>;
  machineryBreakdown?: Maybe<Scalars['String']>;
  marchandises?: Maybe<Scalars['String']>;
  naturalDisasters?: Maybe<Scalars['String']>;
  rcApLivraison?: Maybe<Scalars['String']>;
  rcAvLivraison?: Maybe<Scalars['String']>;
  theftProperty?: Maybe<Scalars['String']>;
  vandalismExcludingBuildings?: Maybe<Scalars['String']>;
  waterDamage?: Maybe<Scalars['String']>;
};

export type MreAcheelQuotationDetails = {
  __typename?: 'MreAcheelQuotationDetails';
  activityId?: Maybe<Scalars['Int']>;
  addressMAcheel?: Maybe<QuotationAddress>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  extincteursLocaux?: Maybe<Scalars['Boolean']>;
  /** Whether or not the property is an historic monument */
  historicalMonument?: Maybe<Scalars['Boolean']>;
  installElectriqueVerif?: Maybe<Scalars['Boolean']>;
  nbSinistres?: Maybe<Scalars['Int']>;
  packageOptionMAcheel?: Maybe<MreAcheelPackage>;
  procedureCollective?: Maybe<Scalars['Boolean']>;
  resilieNonPaiement?: Maybe<Scalars['Boolean']>;
  surfaceArea?: Maybe<Scalars['Float']>;
};

export type MreAcheelQuotationDetailsInput = {
  activityId?: InputMaybe<Scalars['Int']>;
  addressMAcheel?: InputMaybe<QuotationAddressInput>;
  deductibleAmount?: InputMaybe<Scalars['Float']>;
  extincteursLocaux?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not the property is an historic monument */
  historicalMonument?: InputMaybe<Scalars['Boolean']>;
  installElectriqueVerif?: InputMaybe<Scalars['Boolean']>;
  nbSinistres?: InputMaybe<Scalars['Int']>;
  packageOptionMAcheel?: InputMaybe<MreAcheelPackage>;
  procedureCollective?: InputMaybe<Scalars['Boolean']>;
  resilieNonPaiement?: InputMaybe<Scalars['Boolean']>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
};

export type MreAcheelQuotationPremium = ProductPricing & {
  __typename?: 'MreAcheelQuotationPremium';
  applicationFees: ApplicationFeesQuotation;
  base: Scalars['Float'];
  discountedTotal?: Maybe<Scalars['Float']>;
  nbSinistre?: Maybe<Scalars['Int']>;
  originalTotal: Scalars['Float'];
};

export type MultiRiskContractDetails = {
  __typename?: 'MultiRiskContractDetails';
  activityId: Scalars['Int'];
  address: Address;
  assistanceOption?: Maybe<Scalars['Boolean']>;
  contentValue: Scalars['Int'];
  deductibleAmount: Scalars['Float'];
  financialLossAdvantageOption?: Maybe<Scalars['Boolean']>;
  financialLossCompensationPeriod?: Maybe<Scalars['Int']>;
  financialLossDeductibleAmount?: Maybe<Scalars['Float']>;
  financialLossStandardOption?: Maybe<Scalars['Boolean']>;
  historicalMonument?: Maybe<Scalars['Boolean']>;
  legalProtectionOption?: Maybe<Scalars['Boolean']>;
  occupancyType: OccupancyType;
  operatingLiabilityOption?: Maybe<Scalars['Boolean']>;
  packageOption?: Maybe<MultiRiskPackage>;
  surfaceArea: Scalars['Float'];
};

export type MultiRiskContractDetailsInput = {
  activityId: Scalars['Int'];
  address: AddressInput;
  assistanceOption?: InputMaybe<Scalars['Boolean']>;
  contentValue: Scalars['Int'];
  deductibleAmount: Scalars['Float'];
  financialLossAdvantageOption?: InputMaybe<Scalars['Boolean']>;
  financialLossCompensationPeriod?: InputMaybe<Scalars['Int']>;
  financialLossDeductibleAmount?: InputMaybe<Scalars['Float']>;
  financialLossStandardOption?: InputMaybe<Scalars['Boolean']>;
  historicalMonument?: InputMaybe<Scalars['Boolean']>;
  legalProtectionOption?: InputMaybe<Scalars['Boolean']>;
  occupancyType: OccupancyType;
  operatingLiabilityOption?: InputMaybe<Scalars['Boolean']>;
  packageOption?: InputMaybe<MultiRiskPackage>;
  surfaceArea: Scalars['Float'];
};

export type MultiRiskContractPremium = ContractPremium & {
  __typename?: 'MultiRiskContractPremium';
  applicationFees: ApplicationFees;
  assistanceOption?: Maybe<MoneyBag>;
  base?: Maybe<MoneyBag>;
  building?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  content?: Maybe<MoneyBag>;
  financialLossAdvantageOption?: Maybe<MoneyBag>;
  financialLossStandardOption?: Maybe<MoneyBag>;
  guarantyAndAssistance?: Maybe<MoneyBag>;
  legalProtectionOption?: Maybe<MoneyBag>;
  liabilityAfterCompletionOfWork?: Maybe<MoneyBag>;
  naturalDisaster?: Maybe<MoneyBag>;
  neighborsAndThirdPartyClaims?: Maybe<MoneyBag>;
  operatingLiabilityOption?: Maybe<MoneyBag>;
  paymentFrequency: PaymentFrequency;
  publicLiabilityOccupant?: Maybe<MoneyBag>;
  publicLiabilityOwner?: Maybe<MoneyBag>;
  terrorismTax?: Maybe<Scalars['Float']>;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type MultiRiskContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  assistanceOption?: InputMaybe<MoneyBagInput>;
  base?: InputMaybe<MoneyBagInput>;
  building?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  content?: InputMaybe<MoneyBagInput>;
  financialLossAdvantageOption?: InputMaybe<MoneyBagInput>;
  financialLossCompensationPeriod?: InputMaybe<Scalars['Int']>;
  financialLossDeductibleAmount?: InputMaybe<Scalars['Float']>;
  financialLossStandardOption?: InputMaybe<MoneyBagInput>;
  legalProtectionOption?: InputMaybe<MoneyBagInput>;
  liabilityAfterCompletionOfWork?: InputMaybe<MoneyBagInput>;
  naturalDisaster?: InputMaybe<MoneyBagInput>;
  neighborsAndThirdPartyClaims?: InputMaybe<MoneyBagInput>;
  operatingLiability?: InputMaybe<MoneyBagInput>;
  operatingLiabilityOption?: InputMaybe<MoneyBagInput>;
  paymentFrequency: PaymentFrequency;
  publicLiabilityOccupant?: InputMaybe<MoneyBagInput>;
  publicLiabilityOwner?: InputMaybe<MoneyBagInput>;
  terrorismTax?: InputMaybe<Scalars['Float']>;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export enum MultiRiskPackage {
  Basic = 'BASIC',
  Comfort = 'COMFORT',
  Premium = 'PREMIUM'
}

export type MultiRiskQuotationCovers = {
  __typename?: 'MultiRiskQuotationCovers';
  allComputerRisks?: Maybe<Scalars['Float']>;
  fire?: Maybe<Scalars['Float']>;
  glassBreakage?: Maybe<Scalars['Float']>;
  machineryBreakdown?: Maybe<Scalars['Float']>;
  naturalDisasters?: Maybe<Scalars['Float']>;
  ownerLiability?: Maybe<Scalars['Float']>;
  recourseFromNeighborsAndThirdParties?: Maybe<Scalars['Float']>;
  rentalLiability?: Maybe<Scalars['Float']>;
  theftProperty?: Maybe<Scalars['Float']>;
  vandalismExcludingBuildings?: Maybe<Scalars['Float']>;
  waterDamage?: Maybe<Scalars['Float']>;
};

export type MultiRiskQuotationDetails = {
  __typename?: 'MultiRiskQuotationDetails';
  activityId?: Maybe<Scalars['Int']>;
  address?: Maybe<QuotationAddress>;
  assistanceOption?: Maybe<Scalars['Boolean']>;
  contentValue?: Maybe<Scalars['Int']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  financialLossAdvantageOption?: Maybe<Scalars['Boolean']>;
  financialLossCompensationPeriod?: Maybe<Scalars['Int']>;
  financialLossDeductibleAmount?: Maybe<Scalars['Float']>;
  financialLossStandardOption?: Maybe<Scalars['Boolean']>;
  /** Whether or not the property is an historic monument */
  historicalMonument?: Maybe<Scalars['Boolean']>;
  legalProtectionOption?: Maybe<Scalars['Boolean']>;
  occupancyType?: Maybe<OccupancyType>;
  operatingLiabilityOption?: Maybe<Scalars['Boolean']>;
  packageOption?: Maybe<MultiRiskPackage>;
  surfaceArea?: Maybe<Scalars['Float']>;
};

export type MultiRiskQuotationDetailsInput = {
  activityId?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<QuotationAddressInput>;
  assistanceOption?: InputMaybe<Scalars['Boolean']>;
  contentValue?: InputMaybe<Scalars['Int']>;
  deductibleAmount?: InputMaybe<Scalars['Float']>;
  financialLossAdvantageOption?: InputMaybe<Scalars['Boolean']>;
  financialLossCompensationPeriod?: InputMaybe<Scalars['Int']>;
  financialLossDeductibleAmount?: InputMaybe<Scalars['Float']>;
  financialLossStandardOption?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not the property is an historic monument */
  historicalMonument?: InputMaybe<Scalars['Boolean']>;
  legalProtectionOption?: InputMaybe<Scalars['Boolean']>;
  occupancyType?: InputMaybe<OccupancyType>;
  operatingLiabilityOption?: InputMaybe<Scalars['Boolean']>;
  packageOption?: InputMaybe<MultiRiskPackage>;
  surfaceArea?: InputMaybe<Scalars['Float']>;
};

export type MultiRiskQuotationPremium = ProductPricing & {
  __typename?: 'MultiRiskQuotationPremium';
  applicationFees: ApplicationFeesQuotation;
  assistanceOption?: Maybe<Scalars['Float']>;
  base: Scalars['Float'];
  discountedTotal?: Maybe<Scalars['Float']>;
  financialLossAdvantageOption?: Maybe<Scalars['Float']>;
  financialLossStandardOption?: Maybe<Scalars['Float']>;
  legalProtectionOption?: Maybe<Scalars['Float']>;
  operatingLiabilityOption?: Maybe<Scalars['Float']>;
  originalTotal: Scalars['Float'];
};

export enum OccupancyType {
  FreeOccupant = 'FREE_OCCUPANT',
  Owner = 'OWNER',
  SubTenant = 'SUB_TENANT',
  Tenant = 'TENANT',
  TenantOnBehalfOfOwner = 'TENANT_ON_BEHALF_OF_OWNER'
}

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast = 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc = 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst = 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type OtherContractPremium = ContractPremium & {
  __typename?: 'OtherContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type OtherContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

/** columns and relationships of "otp" */
export type Otp = {
  __typename?: 'Otp';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  codeHash: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deviceId: Scalars['String'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  numberOfUse: Scalars['Int'];
};

/** aggregated selection of "otp" */
export type OtpAggregate = {
  __typename?: 'OtpAggregate';
  aggregate?: Maybe<OtpAggregateFields>;
  nodes: Array<Otp>;
};

export type OtpAggregateBoolExp = {
  count?: InputMaybe<OtpAggregateBoolExpCount>;
};

/** aggregate fields of "otp" */
export type OtpAggregateFields = {
  __typename?: 'OtpAggregateFields';
  avg?: Maybe<OtpAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OtpMaxFields>;
  min?: Maybe<OtpMinFields>;
  stddev?: Maybe<OtpStddevFields>;
  stddevPop?: Maybe<OtpStddevPopFields>;
  stddevSamp?: Maybe<OtpStddevSampFields>;
  sum?: Maybe<OtpSumFields>;
  varPop?: Maybe<OtpVarPopFields>;
  varSamp?: Maybe<OtpVarSampFields>;
  variance?: Maybe<OtpVarianceFields>;
};


/** aggregate fields of "otp" */
export type OtpAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OtpSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "otp" */
export type OtpAggregateOrderBy = {
  avg?: InputMaybe<OtpAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OtpMaxOrderBy>;
  min?: InputMaybe<OtpMinOrderBy>;
  stddev?: InputMaybe<OtpStddevOrderBy>;
  stddevPop?: InputMaybe<OtpStddevPopOrderBy>;
  stddevSamp?: InputMaybe<OtpStddevSampOrderBy>;
  sum?: InputMaybe<OtpSumOrderBy>;
  varPop?: InputMaybe<OtpVarPopOrderBy>;
  varSamp?: InputMaybe<OtpVarSampOrderBy>;
  variance?: InputMaybe<OtpVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "otp" */
export type OtpArrRelInsertInput = {
  data: Array<OtpInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OtpOnConflict>;
};

/** aggregate avg on columns */
export type OtpAvgFields = {
  __typename?: 'OtpAvgFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "otp" */
export type OtpAvgOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "otp". All fields are combined with a logical 'AND'. */
export type OtpBoolExp = {
  _and?: InputMaybe<Array<OtpBoolExp>>;
  _not?: InputMaybe<OtpBoolExp>;
  _or?: InputMaybe<Array<OtpBoolExp>>;
  account?: InputMaybe<AccountBoolExp>;
  accountId?: InputMaybe<UuidComparisonExp>;
  codeHash?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deviceId?: InputMaybe<StringComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  numberOfUse?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "otp" */
export enum OtpConstraint {
  /** unique or primary key constraint on columns "account_id" */
  OtpAccountIdUnique = 'otp_account_id_unique',
  /** unique or primary key constraint on columns "id" */
  OtpPkey = 'otp_pkey'
}

/** input type for incrementing numeric columns in table "otp" */
export type OtpIncInput = {
  numberOfUse?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "otp" */
export type OtpInsertInput = {
  account?: InputMaybe<AccountObjRelInsertInput>;
  accountId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deviceId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfUse?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type OtpMaxFields = {
  __typename?: 'OtpMaxFields';
  accountId?: Maybe<Scalars['uuid']>;
  codeHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deviceId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfUse?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "otp" */
export type OtpMaxOrderBy = {
  accountId?: InputMaybe<OrderBy>;
  codeHash?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberOfUse?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OtpMinFields = {
  __typename?: 'OtpMinFields';
  accountId?: Maybe<Scalars['uuid']>;
  codeHash?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deviceId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfUse?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "otp" */
export type OtpMinOrderBy = {
  accountId?: InputMaybe<OrderBy>;
  codeHash?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberOfUse?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "otp" */
export type OtpMutationResponse = {
  __typename?: 'OtpMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Otp>;
};

/** on_conflict condition type for table "otp" */
export type OtpOnConflict = {
  constraint: OtpConstraint;
  updateColumns?: Array<OtpUpdateColumn>;
  where?: InputMaybe<OtpBoolExp>;
};

/** Ordering options when selecting data from "otp". */
export type OtpOrderBy = {
  account?: InputMaybe<AccountOrderBy>;
  accountId?: InputMaybe<OrderBy>;
  codeHash?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberOfUse?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: otp */
export type OtpPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "otp" */
export enum OtpSelectColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfUse = 'numberOfUse'
}

/** input type for updating data in table "otp" */
export type OtpSetInput = {
  accountId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deviceId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfUse?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type OtpStddevFields = {
  __typename?: 'OtpStddevFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "otp" */
export type OtpStddevOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type OtpStddevPopFields = {
  __typename?: 'OtpStddevPopFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "otp" */
export type OtpStddevPopOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type OtpStddevSampFields = {
  __typename?: 'OtpStddevSampFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "otp" */
export type OtpStddevSampOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "otp" */
export type OtpStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OtpStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OtpStreamCursorValueInput = {
  accountId?: InputMaybe<Scalars['uuid']>;
  codeHash?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deviceId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfUse?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type OtpSumFields = {
  __typename?: 'OtpSumFields';
  numberOfUse?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "otp" */
export type OtpSumOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** update columns of table "otp" */
export enum OtpUpdateColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfUse = 'numberOfUse'
}

export type OtpUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OtpIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OtpSetInput>;
  /** filter the rows which have to be updated */
  where: OtpBoolExp;
};

/** aggregate varPop on columns */
export type OtpVarPopFields = {
  __typename?: 'OtpVarPopFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "otp" */
export type OtpVarPopOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type OtpVarSampFields = {
  __typename?: 'OtpVarSampFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "otp" */
export type OtpVarSampOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OtpVarianceFields = {
  __typename?: 'OtpVarianceFields';
  numberOfUse?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "otp" */
export type OtpVarianceOrderBy = {
  numberOfUse?: InputMaybe<OrderBy>;
};

/** columns and relationships of "partner" */
export type Partner = {
  __typename?: 'Partner';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<CountryEnum>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  advantages?: Maybe<Array<Scalars['String']>>;
  affiliateUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  corporateName?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  displayCockpit: Scalars['Boolean'];
  displayLogo: Scalars['Boolean'];
  /** An array relationship */
  files: Array<PartnerFile>;
  /** An aggregate relationship */
  filesAggregate: PartnerFileAggregate;
  iban?: Maybe<Scalars['String']>;
  /** An object relationship */
  ibanFile?: Maybe<File>;
  ibanFileId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  idPartnerIntranet?: Maybe<Scalars['String']>;
  /** An object relationship */
  logo?: Maybe<File>;
  logoFileId?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An object relationship */
  partnerCategory?: Maybe<PartnerCategory>;
  /** An array relationship */
  products: Array<PartnerProduct>;
  /** An aggregate relationship */
  productsAggregate: PartnerProductAggregate;
  /** An array relationship */
  promoCodes: Array<PromoCode>;
  /** An aggregate relationship */
  promoCodesAggregate: PromoCodeAggregate;
  retrocession: Scalars['Boolean'];
  retrocessionType?: Maybe<RetrocessionTypeEnum>;
  siret?: Maybe<Scalars['String']>;
  updatedIntranetAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "partner" */
export type PartnerFilesArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


/** columns and relationships of "partner" */
export type PartnerFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


/** columns and relationships of "partner" */
export type PartnerProductsArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


/** columns and relationships of "partner" */
export type PartnerProductsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


/** columns and relationships of "partner" */
export type PartnerPromoCodesArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


/** columns and relationships of "partner" */
export type PartnerPromoCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};

/** aggregated selection of "partner" */
export type PartnerAggregate = {
  __typename?: 'PartnerAggregate';
  aggregate?: Maybe<PartnerAggregateFields>;
  nodes: Array<Partner>;
};

export type PartnerAggregateBoolExp = {
  bool_and?: InputMaybe<PartnerAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PartnerAggregateBoolExpBool_Or>;
  count?: InputMaybe<PartnerAggregateBoolExpCount>;
};

/** aggregate fields of "partner" */
export type PartnerAggregateFields = {
  __typename?: 'PartnerAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerMaxFields>;
  min?: Maybe<PartnerMinFields>;
};


/** aggregate fields of "partner" */
export type PartnerAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partner" */
export type PartnerAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PartnerMaxOrderBy>;
  min?: InputMaybe<PartnerMinOrderBy>;
};

/** input type for inserting array relation for remote table "partner" */
export type PartnerArrRelInsertInput = {
  data: Array<PartnerInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerOnConflict>;
};

/** Boolean expression to filter rows from the table "partner". All fields are combined with a logical 'AND'. */
export type PartnerBoolExp = {
  _and?: InputMaybe<Array<PartnerBoolExp>>;
  _not?: InputMaybe<PartnerBoolExp>;
  _or?: InputMaybe<Array<PartnerBoolExp>>;
  addressCity?: InputMaybe<StringComparisonExp>;
  addressCountry?: InputMaybe<CountryEnumComparisonExp>;
  addressLine1?: InputMaybe<StringComparisonExp>;
  addressLine2?: InputMaybe<StringComparisonExp>;
  addressPostalCode?: InputMaybe<StringComparisonExp>;
  advantages?: InputMaybe<StringArrayComparisonExp>;
  affiliateUrl?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  corporateName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayCockpit?: InputMaybe<BooleanComparisonExp>;
  displayLogo?: InputMaybe<BooleanComparisonExp>;
  files?: InputMaybe<PartnerFileBoolExp>;
  filesAggregate?: InputMaybe<PartnerFileAggregateBoolExp>;
  iban?: InputMaybe<StringComparisonExp>;
  ibanFile?: InputMaybe<FileBoolExp>;
  ibanFileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idPartnerIntranet?: InputMaybe<StringComparisonExp>;
  logo?: InputMaybe<FileBoolExp>;
  logoFileId?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  partnerCategory?: InputMaybe<PartnerCategoryBoolExp>;
  products?: InputMaybe<PartnerProductBoolExp>;
  productsAggregate?: InputMaybe<PartnerProductAggregateBoolExp>;
  promoCodes?: InputMaybe<PromoCodeBoolExp>;
  promoCodesAggregate?: InputMaybe<PromoCodeAggregateBoolExp>;
  retrocession?: InputMaybe<BooleanComparisonExp>;
  retrocessionType?: InputMaybe<RetrocessionTypeEnumComparisonExp>;
  siret?: InputMaybe<StringComparisonExp>;
  updatedIntranetAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** columns and relationships of "partner_category" */
export type PartnerCategory = {
  __typename?: 'PartnerCategory';
  label: Scalars['String'];
  /** An array relationship */
  partners: Array<Partner>;
  /** An aggregate relationship */
  partnersAggregate: PartnerAggregate;
};


/** columns and relationships of "partner_category" */
export type PartnerCategoryPartnersArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};


/** columns and relationships of "partner_category" */
export type PartnerCategoryPartnersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};

/** aggregated selection of "partner_category" */
export type PartnerCategoryAggregate = {
  __typename?: 'PartnerCategoryAggregate';
  aggregate?: Maybe<PartnerCategoryAggregateFields>;
  nodes: Array<PartnerCategory>;
};

/** aggregate fields of "partner_category" */
export type PartnerCategoryAggregateFields = {
  __typename?: 'PartnerCategoryAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerCategoryMaxFields>;
  min?: Maybe<PartnerCategoryMinFields>;
};


/** aggregate fields of "partner_category" */
export type PartnerCategoryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_category". All fields are combined with a logical 'AND'. */
export type PartnerCategoryBoolExp = {
  _and?: InputMaybe<Array<PartnerCategoryBoolExp>>;
  _not?: InputMaybe<PartnerCategoryBoolExp>;
  _or?: InputMaybe<Array<PartnerCategoryBoolExp>>;
  label?: InputMaybe<StringComparisonExp>;
  partners?: InputMaybe<PartnerBoolExp>;
  partnersAggregate?: InputMaybe<PartnerAggregateBoolExp>;
};

/** unique or primary key constraints on table "partner_category" */
export enum PartnerCategoryConstraint {
  /** unique or primary key constraint on columns "label" */
  PartnerCategoryPkey = 'partner_category_pkey'
}

/** input type for inserting data into table "partner_category" */
export type PartnerCategoryInsertInput = {
  label?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerArrRelInsertInput>;
};

/** aggregate max on columns */
export type PartnerCategoryMaxFields = {
  __typename?: 'PartnerCategoryMaxFields';
  label?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerCategoryMinFields = {
  __typename?: 'PartnerCategoryMinFields';
  label?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_category" */
export type PartnerCategoryMutationResponse = {
  __typename?: 'PartnerCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerCategory>;
};

/** input type for inserting object relation for remote table "partner_category" */
export type PartnerCategoryObjRelInsertInput = {
  data: PartnerCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerCategoryOnConflict>;
};

/** on_conflict condition type for table "partner_category" */
export type PartnerCategoryOnConflict = {
  constraint: PartnerCategoryConstraint;
  updateColumns?: Array<PartnerCategoryUpdateColumn>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};

/** Ordering options when selecting data from "partner_category". */
export type PartnerCategoryOrderBy = {
  label?: InputMaybe<OrderBy>;
  partnersAggregate?: InputMaybe<PartnerAggregateOrderBy>;
};

/** primary key columns input for table: partner_category */
export type PartnerCategoryPkColumnsInput = {
  label: Scalars['String'];
};

/** select columns of table "partner_category" */
export enum PartnerCategorySelectColumn {
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "partner_category" */
export type PartnerCategorySetInput = {
  label?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_category" */
export type PartnerCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerCategoryStreamCursorValueInput = {
  label?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_category" */
export enum PartnerCategoryUpdateColumn {
  /** column name */
  Label = 'label'
}

export type PartnerCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerCategorySetInput>;
  /** filter the rows which have to be updated */
  where: PartnerCategoryBoolExp;
};

/** unique or primary key constraints on table "partner" */
export enum PartnerConstraint {
  /** unique or primary key constraint on columns "iban" */
  PartnerIbanKey = 'partner_iban_key',
  /** unique or primary key constraint on columns "id" */
  PartnerPkey = 'partner_pkey',
  /** unique or primary key constraint on columns "siret" */
  PartnerSiretKey = 'partner_siret_key'
}

/** columns and relationships of "partner_file" */
export type PartnerFile = {
  __typename?: 'PartnerFile';
  /** An object relationship */
  file: File;
  fileId: Scalars['uuid'];
  /** An object relationship */
  partner: Partner;
  partnerId: Scalars['uuid'];
  /** An object relationship */
  partner_file_type: PartnerFileType;
  type: PartnerFileTypeEnum;
};

/** aggregated selection of "partner_file" */
export type PartnerFileAggregate = {
  __typename?: 'PartnerFileAggregate';
  aggregate?: Maybe<PartnerFileAggregateFields>;
  nodes: Array<PartnerFile>;
};

export type PartnerFileAggregateBoolExp = {
  count?: InputMaybe<PartnerFileAggregateBoolExpCount>;
};

/** aggregate fields of "partner_file" */
export type PartnerFileAggregateFields = {
  __typename?: 'PartnerFileAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerFileMaxFields>;
  min?: Maybe<PartnerFileMinFields>;
};


/** aggregate fields of "partner_file" */
export type PartnerFileAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partner_file" */
export type PartnerFileAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PartnerFileMaxOrderBy>;
  min?: InputMaybe<PartnerFileMinOrderBy>;
};

/** input type for inserting array relation for remote table "partner_file" */
export type PartnerFileArrRelInsertInput = {
  data: Array<PartnerFileInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerFileOnConflict>;
};

/** Boolean expression to filter rows from the table "partner_file". All fields are combined with a logical 'AND'. */
export type PartnerFileBoolExp = {
  _and?: InputMaybe<Array<PartnerFileBoolExp>>;
  _not?: InputMaybe<PartnerFileBoolExp>;
  _or?: InputMaybe<Array<PartnerFileBoolExp>>;
  file?: InputMaybe<FileBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  partner?: InputMaybe<PartnerBoolExp>;
  partnerId?: InputMaybe<UuidComparisonExp>;
  partner_file_type?: InputMaybe<PartnerFileTypeBoolExp>;
  type?: InputMaybe<PartnerFileTypeEnumComparisonExp>;
};

/** unique or primary key constraints on table "partner_file" */
export enum PartnerFileConstraint {
  /** unique or primary key constraint on columns "file_id", "partner_id" */
  PartnerFilePkey = 'partner_file_pkey'
}

export type PartnerFileId = {
  __typename?: 'PartnerFileId';
  fileId: Scalars['String'];
  partnerId: Scalars['String'];
};

export type PartnerFileInput = {
  data: Scalars['base64'];
  filename: Scalars['String'];
  partnerId: Scalars['uuid'];
  type: Scalars['String'];
};

/** input type for inserting data into table "partner_file" */
export type PartnerFileInsertInput = {
  file?: InputMaybe<FileObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']>;
  partner?: InputMaybe<PartnerObjRelInsertInput>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  partner_file_type?: InputMaybe<PartnerFileTypeObjRelInsertInput>;
  type?: InputMaybe<PartnerFileTypeEnum>;
};

/** aggregate max on columns */
export type PartnerFileMaxFields = {
  __typename?: 'PartnerFileMaxFields';
  fileId?: Maybe<Scalars['uuid']>;
  partnerId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "partner_file" */
export type PartnerFileMaxOrderBy = {
  fileId?: InputMaybe<OrderBy>;
  partnerId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PartnerFileMinFields = {
  __typename?: 'PartnerFileMinFields';
  fileId?: Maybe<Scalars['uuid']>;
  partnerId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "partner_file" */
export type PartnerFileMinOrderBy = {
  fileId?: InputMaybe<OrderBy>;
  partnerId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "partner_file" */
export type PartnerFileMutationResponse = {
  __typename?: 'PartnerFileMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerFile>;
};

/** on_conflict condition type for table "partner_file" */
export type PartnerFileOnConflict = {
  constraint: PartnerFileConstraint;
  updateColumns?: Array<PartnerFileUpdateColumn>;
  where?: InputMaybe<PartnerFileBoolExp>;
};

/** Ordering options when selecting data from "partner_file". */
export type PartnerFileOrderBy = {
  file?: InputMaybe<FileOrderBy>;
  fileId?: InputMaybe<OrderBy>;
  partner?: InputMaybe<PartnerOrderBy>;
  partnerId?: InputMaybe<OrderBy>;
  partner_file_type?: InputMaybe<PartnerFileTypeOrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_file */
export type PartnerFilePkColumnsInput = {
  fileId: Scalars['uuid'];
  partnerId: Scalars['uuid'];
};

/** select columns of table "partner_file" */
export enum PartnerFileSelectColumn {
  /** column name */
  FileId = 'fileId',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "partner_file" */
export type PartnerFileSetInput = {
  fileId?: InputMaybe<Scalars['uuid']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<PartnerFileTypeEnum>;
};

/** Streaming cursor of the table "partner_file" */
export type PartnerFileStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerFileStreamCursorValueInput = {
  fileId?: InputMaybe<Scalars['uuid']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<PartnerFileTypeEnum>;
};

/** columns and relationships of "partner_file_type" */
export type PartnerFileType = {
  __typename?: 'PartnerFileType';
  comment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "partner_file_type" */
export type PartnerFileTypeAggregate = {
  __typename?: 'PartnerFileTypeAggregate';
  aggregate?: Maybe<PartnerFileTypeAggregateFields>;
  nodes: Array<PartnerFileType>;
};

/** aggregate fields of "partner_file_type" */
export type PartnerFileTypeAggregateFields = {
  __typename?: 'PartnerFileTypeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PartnerFileTypeMaxFields>;
  min?: Maybe<PartnerFileTypeMinFields>;
};


/** aggregate fields of "partner_file_type" */
export type PartnerFileTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerFileTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "partner_file_type". All fields are combined with a logical 'AND'. */
export type PartnerFileTypeBoolExp = {
  _and?: InputMaybe<Array<PartnerFileTypeBoolExp>>;
  _not?: InputMaybe<PartnerFileTypeBoolExp>;
  _or?: InputMaybe<Array<PartnerFileTypeBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "partner_file_type" */
export enum PartnerFileTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  PartnerFileTypePkey = 'partner_file_type_pkey'
}

export enum PartnerFileTypeEnum {
  Agreement = 'AGREEMENT',
  Other = 'OTHER'
}

/** Boolean expression to compare columns of type "PartnerFileTypeEnum". All fields are combined with logical 'AND'. */
export type PartnerFileTypeEnumComparisonExp = {
  _eq?: InputMaybe<PartnerFileTypeEnum>;
  _in?: InputMaybe<Array<PartnerFileTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PartnerFileTypeEnum>;
  _nin?: InputMaybe<Array<PartnerFileTypeEnum>>;
};

/** input type for inserting data into table "partner_file_type" */
export type PartnerFileTypeInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PartnerFileTypeMaxFields = {
  __typename?: 'PartnerFileTypeMaxFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PartnerFileTypeMinFields = {
  __typename?: 'PartnerFileTypeMinFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "partner_file_type" */
export type PartnerFileTypeMutationResponse = {
  __typename?: 'PartnerFileTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerFileType>;
};

/** input type for inserting object relation for remote table "partner_file_type" */
export type PartnerFileTypeObjRelInsertInput = {
  data: PartnerFileTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerFileTypeOnConflict>;
};

/** on_conflict condition type for table "partner_file_type" */
export type PartnerFileTypeOnConflict = {
  constraint: PartnerFileTypeConstraint;
  updateColumns?: Array<PartnerFileTypeUpdateColumn>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};

/** Ordering options when selecting data from "partner_file_type". */
export type PartnerFileTypeOrderBy = {
  comment?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_file_type */
export type PartnerFileTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "partner_file_type" */
export enum PartnerFileTypeSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "partner_file_type" */
export type PartnerFileTypeSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "partner_file_type" */
export type PartnerFileTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerFileTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerFileTypeStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "partner_file_type" */
export enum PartnerFileTypeUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

export type PartnerFileTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerFileTypeSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerFileTypeBoolExp;
};

/** update columns of table "partner_file" */
export enum PartnerFileUpdateColumn {
  /** column name */
  FileId = 'fileId',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Type = 'type'
}

export type PartnerFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerFileSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerFileBoolExp;
};

export type PartnerId = {
  __typename?: 'PartnerID';
  id: Scalars['uuid'];
};

export type PartnerInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<CountryEnum>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  advantages: Array<Scalars['String']>;
  affiliateUrl?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  corporateName: Scalars['String'];
  description: Scalars['String'];
  displayCockpit: Scalars['Boolean'];
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  iban?: InputMaybe<Scalars['String']>;
  ibanFile?: InputMaybe<Scalars['base64']>;
  logo: Scalars['base64'];
  name: Scalars['String'];
  retrocession?: InputMaybe<Scalars['Boolean']>;
  retrocessionList?: InputMaybe<Array<RetrocessionInput>>;
  retrocessionType?: InputMaybe<Scalars['String']>;
  siret: Scalars['String'];
};

export type PartnerInputUpdate = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<CountryEnum>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  advantages?: InputMaybe<Array<Scalars['String']>>;
  affiliateUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  corporateName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayCockpit?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  iban?: InputMaybe<Scalars['String']>;
  ibanFile?: InputMaybe<Scalars['base64']>;
  logo?: InputMaybe<Scalars['base64']>;
  name?: InputMaybe<Scalars['String']>;
  retrocession?: InputMaybe<Scalars['Boolean']>;
  retrocessionList?: InputMaybe<Array<RetrocessionInput>>;
  retrocessionType?: InputMaybe<Scalars['String']>;
  siret?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "partner" */
export type PartnerInsertInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<CountryEnum>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  advantages?: InputMaybe<Array<Scalars['String']>>;
  affiliateUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  corporateName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayCockpit?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<PartnerFileArrRelInsertInput>;
  iban?: InputMaybe<Scalars['String']>;
  ibanFile?: InputMaybe<FileObjRelInsertInput>;
  ibanFileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPartnerIntranet?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<FileObjRelInsertInput>;
  logoFileId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  partnerCategory?: InputMaybe<PartnerCategoryObjRelInsertInput>;
  products?: InputMaybe<PartnerProductArrRelInsertInput>;
  promoCodes?: InputMaybe<PromoCodeArrRelInsertInput>;
  retrocession?: InputMaybe<Scalars['Boolean']>;
  retrocessionType?: InputMaybe<RetrocessionTypeEnum>;
  siret?: InputMaybe<Scalars['String']>;
  updatedIntranetAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PartnerMaxFields = {
  __typename?: 'PartnerMaxFields';
  addressCity?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  advantages?: Maybe<Array<Scalars['String']>>;
  affiliateUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  corporateName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ibanFileId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  idPartnerIntranet?: Maybe<Scalars['String']>;
  logoFileId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  updatedIntranetAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "partner" */
export type PartnerMaxOrderBy = {
  addressCity?: InputMaybe<OrderBy>;
  addressLine1?: InputMaybe<OrderBy>;
  addressLine2?: InputMaybe<OrderBy>;
  addressPostalCode?: InputMaybe<OrderBy>;
  advantages?: InputMaybe<OrderBy>;
  affiliateUrl?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  corporateName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  ibanFileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPartnerIntranet?: InputMaybe<OrderBy>;
  logoFileId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  siret?: InputMaybe<OrderBy>;
  updatedIntranetAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PartnerMinFields = {
  __typename?: 'PartnerMinFields';
  addressCity?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  advantages?: Maybe<Array<Scalars['String']>>;
  affiliateUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  corporateName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  ibanFileId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  idPartnerIntranet?: Maybe<Scalars['String']>;
  logoFileId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  updatedIntranetAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "partner" */
export type PartnerMinOrderBy = {
  addressCity?: InputMaybe<OrderBy>;
  addressLine1?: InputMaybe<OrderBy>;
  addressLine2?: InputMaybe<OrderBy>;
  addressPostalCode?: InputMaybe<OrderBy>;
  advantages?: InputMaybe<OrderBy>;
  affiliateUrl?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  corporateName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  ibanFileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPartnerIntranet?: InputMaybe<OrderBy>;
  logoFileId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  siret?: InputMaybe<OrderBy>;
  updatedIntranetAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "partner" */
export type PartnerMutationResponse = {
  __typename?: 'PartnerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner>;
};

/** input type for inserting object relation for remote table "partner" */
export type PartnerObjRelInsertInput = {
  data: PartnerInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerOnConflict>;
};

/** on_conflict condition type for table "partner" */
export type PartnerOnConflict = {
  constraint: PartnerConstraint;
  updateColumns?: Array<PartnerUpdateColumn>;
  where?: InputMaybe<PartnerBoolExp>;
};

/** Ordering options when selecting data from "partner". */
export type PartnerOrderBy = {
  addressCity?: InputMaybe<OrderBy>;
  addressCountry?: InputMaybe<OrderBy>;
  addressLine1?: InputMaybe<OrderBy>;
  addressLine2?: InputMaybe<OrderBy>;
  addressPostalCode?: InputMaybe<OrderBy>;
  advantages?: InputMaybe<OrderBy>;
  affiliateUrl?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  corporateName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayCockpit?: InputMaybe<OrderBy>;
  displayLogo?: InputMaybe<OrderBy>;
  filesAggregate?: InputMaybe<PartnerFileAggregateOrderBy>;
  iban?: InputMaybe<OrderBy>;
  ibanFile?: InputMaybe<FileOrderBy>;
  ibanFileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idPartnerIntranet?: InputMaybe<OrderBy>;
  logo?: InputMaybe<FileOrderBy>;
  logoFileId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  partnerCategory?: InputMaybe<PartnerCategoryOrderBy>;
  productsAggregate?: InputMaybe<PartnerProductAggregateOrderBy>;
  promoCodesAggregate?: InputMaybe<PromoCodeAggregateOrderBy>;
  retrocession?: InputMaybe<OrderBy>;
  retrocessionType?: InputMaybe<OrderBy>;
  siret?: InputMaybe<OrderBy>;
  updatedIntranetAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner */
export type PartnerPkColumnsInput = {
  id: Scalars['uuid'];
};

/** columns and relationships of "partner_product" */
export type PartnerProduct = {
  __typename?: 'PartnerProduct';
  displayDuringQuotation: Scalars['Boolean'];
  partnerId: Scalars['uuid'];
  product: ProductEnum;
  value: Scalars['float8'];
};

/** aggregated selection of "partner_product" */
export type PartnerProductAggregate = {
  __typename?: 'PartnerProductAggregate';
  aggregate?: Maybe<PartnerProductAggregateFields>;
  nodes: Array<PartnerProduct>;
};

export type PartnerProductAggregateBoolExp = {
  avg?: InputMaybe<PartnerProductAggregateBoolExpAvg>;
  bool_and?: InputMaybe<PartnerProductAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PartnerProductAggregateBoolExpBool_Or>;
  corr?: InputMaybe<PartnerProductAggregateBoolExpCorr>;
  count?: InputMaybe<PartnerProductAggregateBoolExpCount>;
  covar_samp?: InputMaybe<PartnerProductAggregateBoolExpCovar_Samp>;
  max?: InputMaybe<PartnerProductAggregateBoolExpMax>;
  min?: InputMaybe<PartnerProductAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<PartnerProductAggregateBoolExpStddev_Samp>;
  sum?: InputMaybe<PartnerProductAggregateBoolExpSum>;
  var_samp?: InputMaybe<PartnerProductAggregateBoolExpVar_Samp>;
};

/** aggregate fields of "partner_product" */
export type PartnerProductAggregateFields = {
  __typename?: 'PartnerProductAggregateFields';
  avg?: Maybe<PartnerProductAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PartnerProductMaxFields>;
  min?: Maybe<PartnerProductMinFields>;
  stddev?: Maybe<PartnerProductStddevFields>;
  stddevPop?: Maybe<PartnerProductStddevPopFields>;
  stddevSamp?: Maybe<PartnerProductStddevSampFields>;
  sum?: Maybe<PartnerProductSumFields>;
  varPop?: Maybe<PartnerProductVarPopFields>;
  varSamp?: Maybe<PartnerProductVarSampFields>;
  variance?: Maybe<PartnerProductVarianceFields>;
};


/** aggregate fields of "partner_product" */
export type PartnerProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "partner_product" */
export type PartnerProductAggregateOrderBy = {
  avg?: InputMaybe<PartnerProductAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PartnerProductMaxOrderBy>;
  min?: InputMaybe<PartnerProductMinOrderBy>;
  stddev?: InputMaybe<PartnerProductStddevOrderBy>;
  stddevPop?: InputMaybe<PartnerProductStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PartnerProductStddevSampOrderBy>;
  sum?: InputMaybe<PartnerProductSumOrderBy>;
  varPop?: InputMaybe<PartnerProductVarPopOrderBy>;
  varSamp?: InputMaybe<PartnerProductVarSampOrderBy>;
  variance?: InputMaybe<PartnerProductVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "partner_product" */
export type PartnerProductArrRelInsertInput = {
  data: Array<PartnerProductInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PartnerProductOnConflict>;
};

/** aggregate avg on columns */
export type PartnerProductAvgFields = {
  __typename?: 'PartnerProductAvgFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "partner_product" */
export type PartnerProductAvgOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "partner_product". All fields are combined with a logical 'AND'. */
export type PartnerProductBoolExp = {
  _and?: InputMaybe<Array<PartnerProductBoolExp>>;
  _not?: InputMaybe<PartnerProductBoolExp>;
  _or?: InputMaybe<Array<PartnerProductBoolExp>>;
  displayDuringQuotation?: InputMaybe<BooleanComparisonExp>;
  partnerId?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<ProductEnumComparisonExp>;
  value?: InputMaybe<Float8ComparisonExp>;
};

/** unique or primary key constraints on table "partner_product" */
export enum PartnerProductConstraint {
  /** unique or primary key constraint on columns "product", "partner_id" */
  PartnerProductPkey = 'partner_product_pkey'
}

/** input type for incrementing numeric columns in table "partner_product" */
export type PartnerProductIncInput = {
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "partner_product" */
export type PartnerProductInsertInput = {
  displayDuringQuotation?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<ProductEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type PartnerProductMaxFields = {
  __typename?: 'PartnerProductMaxFields';
  partnerId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "partner_product" */
export type PartnerProductMaxOrderBy = {
  partnerId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PartnerProductMinFields = {
  __typename?: 'PartnerProductMinFields';
  partnerId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "partner_product" */
export type PartnerProductMinOrderBy = {
  partnerId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "partner_product" */
export type PartnerProductMutationResponse = {
  __typename?: 'PartnerProductMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerProduct>;
};

/** on_conflict condition type for table "partner_product" */
export type PartnerProductOnConflict = {
  constraint: PartnerProductConstraint;
  updateColumns?: Array<PartnerProductUpdateColumn>;
  where?: InputMaybe<PartnerProductBoolExp>;
};

/** Ordering options when selecting data from "partner_product". */
export type PartnerProductOrderBy = {
  displayDuringQuotation?: InputMaybe<OrderBy>;
  partnerId?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: partner_product */
export type PartnerProductPkColumnsInput = {
  partnerId: Scalars['uuid'];
  product: ProductEnum;
};

/** select columns of table "partner_product" */
export enum PartnerProductSelectColumn {
  /** column name */
  DisplayDuringQuotation = 'displayDuringQuotation',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Product = 'product',
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpAvgArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpBool_andArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  DisplayDuringQuotation = 'displayDuringQuotation'
}

/** select "partnerProductAggregateBoolExpBool_orArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  DisplayDuringQuotation = 'displayDuringQuotation'
}

/** select "partnerProductAggregateBoolExpCorrArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpCovar_sampArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpCovar_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpMaxArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpMinArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpStddev_sampArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpStddev_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpSumArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "partnerProductAggregateBoolExpVar_sampArgumentsColumns" columns of table "partner_product" */
export enum PartnerProductSelectColumnPartnerProductAggregateBoolExpVar_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "partner_product" */
export type PartnerProductSetInput = {
  displayDuringQuotation?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<ProductEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type PartnerProductStddevFields = {
  __typename?: 'PartnerProductStddevFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "partner_product" */
export type PartnerProductStddevOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PartnerProductStddevPopFields = {
  __typename?: 'PartnerProductStddevPopFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "partner_product" */
export type PartnerProductStddevPopOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PartnerProductStddevSampFields = {
  __typename?: 'PartnerProductStddevSampFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "partner_product" */
export type PartnerProductStddevSampOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "partner_product" */
export type PartnerProductStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerProductStreamCursorValueInput = {
  displayDuringQuotation?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<ProductEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type PartnerProductSumFields = {
  __typename?: 'PartnerProductSumFields';
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "partner_product" */
export type PartnerProductSumOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** update columns of table "partner_product" */
export enum PartnerProductUpdateColumn {
  /** column name */
  DisplayDuringQuotation = 'displayDuringQuotation',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Product = 'product',
  /** column name */
  Value = 'value'
}

export type PartnerProductUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PartnerProductIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerProductSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerProductBoolExp;
};

/** aggregate varPop on columns */
export type PartnerProductVarPopFields = {
  __typename?: 'PartnerProductVarPopFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "partner_product" */
export type PartnerProductVarPopOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PartnerProductVarSampFields = {
  __typename?: 'PartnerProductVarSampFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "partner_product" */
export type PartnerProductVarSampOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PartnerProductVarianceFields = {
  __typename?: 'PartnerProductVarianceFields';
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "partner_product" */
export type PartnerProductVarianceOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "partner" */
export enum PartnerSelectColumn {
  /** column name */
  AddressCity = 'addressCity',
  /** column name */
  AddressCountry = 'addressCountry',
  /** column name */
  AddressLine1 = 'addressLine1',
  /** column name */
  AddressLine2 = 'addressLine2',
  /** column name */
  AddressPostalCode = 'addressPostalCode',
  /** column name */
  Advantages = 'advantages',
  /** column name */
  AffiliateUrl = 'affiliateUrl',
  /** column name */
  Category = 'category',
  /** column name */
  CorporateName = 'corporateName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayCockpit = 'displayCockpit',
  /** column name */
  DisplayLogo = 'displayLogo',
  /** column name */
  Iban = 'iban',
  /** column name */
  IbanFileId = 'ibanFileId',
  /** column name */
  Id = 'id',
  /** column name */
  IdPartnerIntranet = 'idPartnerIntranet',
  /** column name */
  LogoFileId = 'logoFileId',
  /** column name */
  Name = 'name',
  /** column name */
  Retrocession = 'retrocession',
  /** column name */
  RetrocessionType = 'retrocessionType',
  /** column name */
  Siret = 'siret',
  /** column name */
  UpdatedIntranetAt = 'updatedIntranetAt'
}

/** select "partnerAggregateBoolExpBool_andArgumentsColumns" columns of table "partner" */
export enum PartnerSelectColumnPartnerAggregateBoolExpBool_AndArgumentsColumns {
  /** column name */
  DisplayCockpit = 'displayCockpit',
  /** column name */
  DisplayLogo = 'displayLogo',
  /** column name */
  Retrocession = 'retrocession'
}

/** select "partnerAggregateBoolExpBool_orArgumentsColumns" columns of table "partner" */
export enum PartnerSelectColumnPartnerAggregateBoolExpBool_OrArgumentsColumns {
  /** column name */
  DisplayCockpit = 'displayCockpit',
  /** column name */
  DisplayLogo = 'displayLogo',
  /** column name */
  Retrocession = 'retrocession'
}

/** input type for updating data in table "partner" */
export type PartnerSetInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<CountryEnum>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  advantages?: InputMaybe<Array<Scalars['String']>>;
  affiliateUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  corporateName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayCockpit?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  iban?: InputMaybe<Scalars['String']>;
  ibanFileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPartnerIntranet?: InputMaybe<Scalars['String']>;
  logoFileId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  retrocession?: InputMaybe<Scalars['Boolean']>;
  retrocessionType?: InputMaybe<RetrocessionTypeEnum>;
  siret?: InputMaybe<Scalars['String']>;
  updatedIntranetAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "partner" */
export type PartnerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PartnerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PartnerStreamCursorValueInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<CountryEnum>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  advantages?: InputMaybe<Array<Scalars['String']>>;
  affiliateUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  corporateName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  displayCockpit?: InputMaybe<Scalars['Boolean']>;
  displayLogo?: InputMaybe<Scalars['Boolean']>;
  iban?: InputMaybe<Scalars['String']>;
  ibanFileId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  idPartnerIntranet?: InputMaybe<Scalars['String']>;
  logoFileId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  retrocession?: InputMaybe<Scalars['Boolean']>;
  retrocessionType?: InputMaybe<RetrocessionTypeEnum>;
  siret?: InputMaybe<Scalars['String']>;
  updatedIntranetAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "partner" */
export enum PartnerUpdateColumn {
  /** column name */
  AddressCity = 'addressCity',
  /** column name */
  AddressCountry = 'addressCountry',
  /** column name */
  AddressLine1 = 'addressLine1',
  /** column name */
  AddressLine2 = 'addressLine2',
  /** column name */
  AddressPostalCode = 'addressPostalCode',
  /** column name */
  Advantages = 'advantages',
  /** column name */
  AffiliateUrl = 'affiliateUrl',
  /** column name */
  Category = 'category',
  /** column name */
  CorporateName = 'corporateName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayCockpit = 'displayCockpit',
  /** column name */
  DisplayLogo = 'displayLogo',
  /** column name */
  Iban = 'iban',
  /** column name */
  IbanFileId = 'ibanFileId',
  /** column name */
  Id = 'id',
  /** column name */
  IdPartnerIntranet = 'idPartnerIntranet',
  /** column name */
  LogoFileId = 'logoFileId',
  /** column name */
  Name = 'name',
  /** column name */
  Retrocession = 'retrocession',
  /** column name */
  RetrocessionType = 'retrocessionType',
  /** column name */
  Siret = 'siret',
  /** column name */
  UpdatedIntranetAt = 'updatedIntranetAt'
}

export type PartnerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PartnerSetInput>;
  /** filter the rows which have to be updated */
  where: PartnerBoolExp;
};

export enum PaymentFrequency {
  Annually = 'ANNUALLY',
  Bimestriel = 'BIMESTRIEL',
  Monthly = 'MONTHLY',
  Ponctuel = 'PONCTUEL',
  Semestriel = 'SEMESTRIEL',
  Trimestriel = 'TRIMESTRIEL'
}

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'Product';
  name: Scalars['String'];
};

/** aggregated selection of "product" */
export type ProductAggregate = {
  __typename?: 'ProductAggregate';
  aggregate?: Maybe<ProductAggregateFields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type ProductAggregateFields = {
  __typename?: 'ProductAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ProductMaxFields>;
  min?: Maybe<ProductMinFields>;
};


/** aggregate fields of "product" */
export type ProductAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type ProductBoolExp = {
  _and?: InputMaybe<Array<ProductBoolExp>>;
  _not?: InputMaybe<ProductBoolExp>;
  _or?: InputMaybe<Array<ProductBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "product" */
export enum ProductConstraint {
  /** unique or primary key constraint on columns "name" */
  ProductPkey = 'product_pkey'
}

export enum ProductEnum {
  AssistanceDomestique = 'ASSISTANCE_DOMESTIQUE',
  AssistanceDomestiqueProfessionnel = 'ASSISTANCE_DOMESTIQUE_PROFESSIONNEL',
  Auto = 'AUTO',
  AutoMission = 'AUTO_MISSION',
  Cyber = 'CYBER',
  Decennial = 'DECENNIAL',
  DAndO = 'D_AND_O',
  Health = 'HEALTH',
  KeyPerson = 'KEY_PERSON',
  Legal = 'LEGAL',
  Life = 'LIFE',
  MreAcheel = 'MRE_ACHEEL',
  MultiRisk = 'MULTI_RISK',
  Other = 'OTHER',
  PublicLiability = 'PUBLIC_LIABILITY',
  PublicLiabilityEcomm = 'PUBLIC_LIABILITY_ECOMM'
}

/** Boolean expression to compare columns of type "ProductEnum". All fields are combined with logical 'AND'. */
export type ProductEnumComparisonExp = {
  _eq?: InputMaybe<ProductEnum>;
  _in?: InputMaybe<Array<ProductEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ProductEnum>;
  _nin?: InputMaybe<Array<ProductEnum>>;
};

/** input type for inserting data into table "product" */
export type ProductInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ProductMaxFields = {
  __typename?: 'ProductMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ProductMinFields = {
  __typename?: 'ProductMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product" */
export type ProductMutationResponse = {
  __typename?: 'ProductMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** on_conflict condition type for table "product" */
export type ProductOnConflict = {
  constraint: ProductConstraint;
  updateColumns?: Array<ProductUpdateColumn>;
  where?: InputMaybe<ProductBoolExp>;
};

/** Ordering options when selecting data from "product". */
export type ProductOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: product */
export type ProductPkColumnsInput = {
  name: Scalars['String'];
};

export type ProductPricing = {
  applicationFees: ApplicationFeesQuotation;
  /** The base price of the product, excluding options, without discounts applied */
  base: Scalars['Float'];
  /** The total price of the product, including options, without discounts applied. Will be null if no promo code is applied */
  discountedTotal?: Maybe<Scalars['Float']>;
  /** The total price of the product, including options, without discounts applied */
  originalTotal: Scalars['Float'];
};

/** select columns of table "product" */
export enum ProductSelectColumn {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "product" */
export type ProductSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "product" */
export type ProductStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "product" */
export enum ProductUpdateColumn {
  /** column name */
  Name = 'name'
}

export type ProductUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductSetInput>;
  /** filter the rows which have to be updated */
  where: ProductBoolExp;
};

/** columns and relationships of "promo_code" */
export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String'];
  /** An array relationship */
  contractPeriods: Array<ContractPeriod>;
  /** An aggregate relationship */
  contractPeriodsAggregate: ContractPeriodAggregate;
  endDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  maxUse?: Maybe<Scalars['Int']>;
  /** An object relationship */
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['uuid']>;
  startDate: Scalars['timestamptz'];
  type: PromoCodeTypeEnum;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value: Scalars['float8'];
};


/** columns and relationships of "promo_code" */
export type PromoCodeContractPeriodsArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


/** columns and relationships of "promo_code" */
export type PromoCodeContractPeriodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};

/** aggregated selection of "promo_code" */
export type PromoCodeAggregate = {
  __typename?: 'PromoCodeAggregate';
  aggregate?: Maybe<PromoCodeAggregateFields>;
  nodes: Array<PromoCode>;
};

export type PromoCodeAggregateBoolExp = {
  avg?: InputMaybe<PromoCodeAggregateBoolExpAvg>;
  corr?: InputMaybe<PromoCodeAggregateBoolExpCorr>;
  count?: InputMaybe<PromoCodeAggregateBoolExpCount>;
  covar_samp?: InputMaybe<PromoCodeAggregateBoolExpCovar_Samp>;
  max?: InputMaybe<PromoCodeAggregateBoolExpMax>;
  min?: InputMaybe<PromoCodeAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<PromoCodeAggregateBoolExpStddev_Samp>;
  sum?: InputMaybe<PromoCodeAggregateBoolExpSum>;
  var_samp?: InputMaybe<PromoCodeAggregateBoolExpVar_Samp>;
};

/** aggregate fields of "promo_code" */
export type PromoCodeAggregateFields = {
  __typename?: 'PromoCodeAggregateFields';
  avg?: Maybe<PromoCodeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PromoCodeMaxFields>;
  min?: Maybe<PromoCodeMinFields>;
  stddev?: Maybe<PromoCodeStddevFields>;
  stddevPop?: Maybe<PromoCodeStddevPopFields>;
  stddevSamp?: Maybe<PromoCodeStddevSampFields>;
  sum?: Maybe<PromoCodeSumFields>;
  varPop?: Maybe<PromoCodeVarPopFields>;
  varSamp?: Maybe<PromoCodeVarSampFields>;
  variance?: Maybe<PromoCodeVarianceFields>;
};


/** aggregate fields of "promo_code" */
export type PromoCodeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PromoCodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "promo_code" */
export type PromoCodeAggregateOrderBy = {
  avg?: InputMaybe<PromoCodeAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PromoCodeMaxOrderBy>;
  min?: InputMaybe<PromoCodeMinOrderBy>;
  stddev?: InputMaybe<PromoCodeStddevOrderBy>;
  stddevPop?: InputMaybe<PromoCodeStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PromoCodeStddevSampOrderBy>;
  sum?: InputMaybe<PromoCodeSumOrderBy>;
  varPop?: InputMaybe<PromoCodeVarPopOrderBy>;
  varSamp?: InputMaybe<PromoCodeVarSampOrderBy>;
  variance?: InputMaybe<PromoCodeVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "promo_code" */
export type PromoCodeArrRelInsertInput = {
  data: Array<PromoCodeInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PromoCodeOnConflict>;
};

/** aggregate avg on columns */
export type PromoCodeAvgFields = {
  __typename?: 'PromoCodeAvgFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "promo_code" */
export type PromoCodeAvgOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "promo_code". All fields are combined with a logical 'AND'. */
export type PromoCodeBoolExp = {
  _and?: InputMaybe<Array<PromoCodeBoolExp>>;
  _not?: InputMaybe<PromoCodeBoolExp>;
  _or?: InputMaybe<Array<PromoCodeBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  contractPeriods?: InputMaybe<ContractPeriodBoolExp>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateBoolExp>;
  endDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  maxUse?: InputMaybe<IntComparisonExp>;
  partner?: InputMaybe<PartnerBoolExp>;
  partnerId?: InputMaybe<UuidComparisonExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<PromoCodeTypeEnumComparisonExp>;
  used?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<Float8ComparisonExp>;
};

/** unique or primary key constraints on table "promo_code" */
export enum PromoCodeConstraint {
  /** unique or primary key constraint on columns "code" */
  PromoCodeCodeKey = 'promo_code_code_key',
  /** unique or primary key constraint on columns "id" */
  PromoCodePkey = 'promo_code_pkey'
}

export enum PromoCodeError {
  ConditionsNotFulfilled = 'CONDITIONS_NOT_FULFILLED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  NotValid = 'NOT_VALID'
}

/** input type for incrementing numeric columns in table "promo_code" */
export type PromoCodeIncInput = {
  maxUse?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "promo_code" */
export type PromoCodeInsertInput = {
  code?: InputMaybe<Scalars['String']>;
  contractPeriods?: InputMaybe<ContractPeriodArrRelInsertInput>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maxUse?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<PartnerObjRelInsertInput>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<PromoCodeTypeEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type PromoCodeMaxFields = {
  __typename?: 'PromoCodeMaxFields';
  code?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maxUse?: Maybe<Scalars['Int']>;
  partnerId?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "promo_code" */
export type PromoCodeMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxUse?: InputMaybe<OrderBy>;
  partnerId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PromoCodeMinFields = {
  __typename?: 'PromoCodeMinFields';
  code?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  maxUse?: Maybe<Scalars['Int']>;
  partnerId?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "promo_code" */
export type PromoCodeMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxUse?: InputMaybe<OrderBy>;
  partnerId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "promo_code" */
export type PromoCodeMutationResponse = {
  __typename?: 'PromoCodeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PromoCode>;
};

/** input type for inserting object relation for remote table "promo_code" */
export type PromoCodeObjRelInsertInput = {
  data: PromoCodeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PromoCodeOnConflict>;
};

/** on_conflict condition type for table "promo_code" */
export type PromoCodeOnConflict = {
  constraint: PromoCodeConstraint;
  updateColumns?: Array<PromoCodeUpdateColumn>;
  where?: InputMaybe<PromoCodeBoolExp>;
};

/** Ordering options when selecting data from "promo_code". */
export type PromoCodeOrderBy = {
  code?: InputMaybe<OrderBy>;
  contractPeriodsAggregate?: InputMaybe<ContractPeriodAggregateOrderBy>;
  endDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  maxUse?: InputMaybe<OrderBy>;
  partner?: InputMaybe<PartnerOrderBy>;
  partnerId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  used?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: promo_code */
export type PromoCodePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "promo_code" */
export enum PromoCodeSelectColumn {
  /** column name */
  Code = 'code',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUse = 'maxUse',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpAvgArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpCorrArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpCovar_sampArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpCovar_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpMaxArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpMinArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpStddev_sampArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpStddev_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpSumArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** select "promoCodeAggregateBoolExpVar_sampArgumentsColumns" columns of table "promo_code" */
export enum PromoCodeSelectColumnPromoCodeAggregateBoolExpVar_SampArgumentsColumns {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "promo_code" */
export type PromoCodeSetInput = {
  code?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maxUse?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<PromoCodeTypeEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type PromoCodeStddevFields = {
  __typename?: 'PromoCodeStddevFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "promo_code" */
export type PromoCodeStddevOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PromoCodeStddevPopFields = {
  __typename?: 'PromoCodeStddevPopFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "promo_code" */
export type PromoCodeStddevPopOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PromoCodeStddevSampFields = {
  __typename?: 'PromoCodeStddevSampFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "promo_code" */
export type PromoCodeStddevSampOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "promo_code" */
export type PromoCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PromoCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PromoCodeStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  maxUse?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<PromoCodeTypeEnum>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type PromoCodeSumFields = {
  __typename?: 'PromoCodeSumFields';
  maxUse?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "promo_code" */
export type PromoCodeSumOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** columns and relationships of "promo_code_type" */
export type PromoCodeType = {
  __typename?: 'PromoCodeType';
  comment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "promo_code_type" */
export type PromoCodeTypeAggregate = {
  __typename?: 'PromoCodeTypeAggregate';
  aggregate?: Maybe<PromoCodeTypeAggregateFields>;
  nodes: Array<PromoCodeType>;
};

/** aggregate fields of "promo_code_type" */
export type PromoCodeTypeAggregateFields = {
  __typename?: 'PromoCodeTypeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PromoCodeTypeMaxFields>;
  min?: Maybe<PromoCodeTypeMinFields>;
};


/** aggregate fields of "promo_code_type" */
export type PromoCodeTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PromoCodeTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "promo_code_type". All fields are combined with a logical 'AND'. */
export type PromoCodeTypeBoolExp = {
  _and?: InputMaybe<Array<PromoCodeTypeBoolExp>>;
  _not?: InputMaybe<PromoCodeTypeBoolExp>;
  _or?: InputMaybe<Array<PromoCodeTypeBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "promo_code_type" */
export enum PromoCodeTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  PromoCodeTypePkey = 'promo_code_type_pkey'
}

export enum PromoCodeTypeEnum {
  Credit = 'CREDIT',
  Percentage = 'PERCENTAGE'
}

/** Boolean expression to compare columns of type "PromoCodeTypeEnum". All fields are combined with logical 'AND'. */
export type PromoCodeTypeEnumComparisonExp = {
  _eq?: InputMaybe<PromoCodeTypeEnum>;
  _in?: InputMaybe<Array<PromoCodeTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PromoCodeTypeEnum>;
  _nin?: InputMaybe<Array<PromoCodeTypeEnum>>;
};

/** input type for inserting data into table "promo_code_type" */
export type PromoCodeTypeInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PromoCodeTypeMaxFields = {
  __typename?: 'PromoCodeTypeMaxFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PromoCodeTypeMinFields = {
  __typename?: 'PromoCodeTypeMinFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "promo_code_type" */
export type PromoCodeTypeMutationResponse = {
  __typename?: 'PromoCodeTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PromoCodeType>;
};

/** on_conflict condition type for table "promo_code_type" */
export type PromoCodeTypeOnConflict = {
  constraint: PromoCodeTypeConstraint;
  updateColumns?: Array<PromoCodeTypeUpdateColumn>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};

/** Ordering options when selecting data from "promo_code_type". */
export type PromoCodeTypeOrderBy = {
  comment?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: promo_code_type */
export type PromoCodeTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "promo_code_type" */
export enum PromoCodeTypeSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "promo_code_type" */
export type PromoCodeTypeSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "promo_code_type" */
export type PromoCodeTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PromoCodeTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PromoCodeTypeStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "promo_code_type" */
export enum PromoCodeTypeUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

export type PromoCodeTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PromoCodeTypeSetInput>;
  /** filter the rows which have to be updated */
  where: PromoCodeTypeBoolExp;
};

/** update columns of table "promo_code" */
export enum PromoCodeUpdateColumn {
  /** column name */
  Code = 'code',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUse = 'maxUse',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

export type PromoCodeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PromoCodeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PromoCodeSetInput>;
  /** filter the rows which have to be updated */
  where: PromoCodeBoolExp;
};

/** aggregate varPop on columns */
export type PromoCodeVarPopFields = {
  __typename?: 'PromoCodeVarPopFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "promo_code" */
export type PromoCodeVarPopOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PromoCodeVarSampFields = {
  __typename?: 'PromoCodeVarSampFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "promo_code" */
export type PromoCodeVarSampOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PromoCodeVarianceFields = {
  __typename?: 'PromoCodeVarianceFields';
  maxUse?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "count_promo_code_used" */
  used?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "promo_code" */
export type PromoCodeVarianceOrderBy = {
  maxUse?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

export type PublicLiabilityContractDetails = {
  __typename?: 'PublicLiabilityContractDetails';
  activityIds: Array<Scalars['Int']>;
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  legalProtectionOption?: Maybe<Scalars['Boolean']>;
  operatingLiabilityOption?: Maybe<Scalars['Boolean']>;
  worldWideOption?: Maybe<Scalars['Boolean']>;
};

export type PublicLiabilityContractDetailsInput = {
  activityIds: Array<Scalars['Int']>;
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  legalProtectionOption?: InputMaybe<Scalars['Boolean']>;
  operatingLiabilityOption?: InputMaybe<Scalars['Boolean']>;
  worldWideOption?: InputMaybe<Scalars['Boolean']>;
};

export type PublicLiabilityContractPremium = ContractPremium & {
  __typename?: 'PublicLiabilityContractPremium';
  applicationFees: ApplicationFees;
  base?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  legalProtectionOption?: Maybe<MoneyBag>;
  operatingLiabilityOption?: Maybe<MoneyBag>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
  worldWideOption?: Maybe<MoneyBag>;
};

export type PublicLiabilityContractPremiumInput = {
  applicationFees: ApplicationFeesInput;
  base?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  legalProtectionOption?: InputMaybe<MoneyBagInput>;
  operatingLiabilityOption?: InputMaybe<MoneyBagInput>;
  paymentFrequency: PaymentFrequency;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
  worldWideOption?: InputMaybe<MoneyBagInput>;
};

export type PublicLiabilityEcommContractDetails = {
  __typename?: 'PublicLiabilityEcommContractDetails';
  activityId: Scalars['Int'];
  allComputerMaterialDamageGuaranteeAmount?: Maybe<Scalars['Float']>;
  allComputerMaterialDamageOption?: Maybe<Scalars['Boolean']>;
  assistanceAndCyberExtortionOption?: Maybe<Scalars['Boolean']>;
  businessInterruptionOption?: Maybe<Scalars['Boolean']>;
  cyberAndTelephoneFraudOption?: Maybe<Scalars['Boolean']>;
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  suppliersDeficiencyOption?: Maybe<Scalars['Boolean']>;
  thirdPartyDamageCoverageOption?: Maybe<Scalars['Boolean']>;
};

export type PublicLiabilityEcommContractDetailsInput = {
  activityId: Scalars['Int'];
  allComputerMaterialDamageGuaranteeAmount?: InputMaybe<Scalars['Float']>;
  allComputerMaterialDamageOption?: InputMaybe<Scalars['Boolean']>;
  assistanceAndCyberExtortionOption?: InputMaybe<Scalars['Boolean']>;
  businessInterruptionOption?: InputMaybe<Scalars['Boolean']>;
  cyberAndTelephoneFraudOption?: InputMaybe<Scalars['Boolean']>;
  deductibleAmount: Scalars['Float'];
  guaranteeAmount: Scalars['Float'];
  suppliersDeficiencyOption?: InputMaybe<Scalars['Boolean']>;
  thirdPartyDamageCoverageOption?: InputMaybe<Scalars['Boolean']>;
};

export type PublicLiabilityEcommContractPremium = ContractPremium & {
  __typename?: 'PublicLiabilityEcommContractPremium';
  allComputerMaterialDamageOption?: Maybe<MoneyBag>;
  applicationFees: ApplicationFees;
  assistanceAndCyberExtortionOption?: Maybe<MoneyBag>;
  base?: Maybe<MoneyBag>;
  businessInterruptionOption?: Maybe<MoneyBag>;
  commission?: Maybe<Scalars['Float']>;
  cyberAndTelephoneFraudOption?: Maybe<MoneyBag>;
  guarantyAndAssistance?: Maybe<MoneyBag>;
  legalProtection?: Maybe<MoneyBag>;
  materialPremium?: Maybe<MoneyBag>;
  naturalDisaster?: Maybe<MoneyBag>;
  operatingLiability?: Maybe<MoneyBag>;
  paymentFrequency: PaymentFrequency;
  publicLiability?: Maybe<MoneyBag>;
  suppliersDeficiencyOption?: Maybe<MoneyBag>;
  terrorismTax?: Maybe<Scalars['Float']>;
  thirdPartyDamageCoverageOption?: Maybe<MoneyBag>;
  total: MoneyBag;
  totalAfterDiscount?: Maybe<Scalars['Float']>;
};

export type PublicLiabilityEcommContractPremiumInput = {
  allComputerMaterialDamageOption?: InputMaybe<MoneyBagInput>;
  applicationFees: ApplicationFeesInput;
  assistanceAndCyberExtortionOption?: InputMaybe<MoneyBagInput>;
  base?: InputMaybe<MoneyBagInput>;
  businessInterruptionOption?: InputMaybe<MoneyBagInput>;
  commission?: InputMaybe<Scalars['Float']>;
  cyberAndTelephoneFraudOption?: InputMaybe<MoneyBagInput>;
  guarantyAndAssistance?: InputMaybe<MoneyBagInput>;
  legalProtection?: InputMaybe<MoneyBagInput>;
  materialPremium?: InputMaybe<MoneyBagInput>;
  naturalDisaster?: InputMaybe<MoneyBagInput>;
  operatingLiability?: InputMaybe<MoneyBagInput>;
  paymentFrequency: PaymentFrequency;
  publicLiability?: InputMaybe<MoneyBagInput>;
  suppliersDeficiencyOption?: InputMaybe<MoneyBagInput>;
  terrorismTax?: InputMaybe<Scalars['Float']>;
  thirdPartyDamageCoverageOption?: InputMaybe<MoneyBagInput>;
  total: MoneyBagInput;
  totalAfterDiscount?: InputMaybe<Scalars['Float']>;
};

export type PublicLiabilityEcommQuotationCovers = {
  __typename?: 'PublicLiabilityEcommQuotationCovers';
  allComputerMaterialDamage?: Maybe<Scalars['Float']>;
  assistanceAndCyberExtortion?: Maybe<Scalars['Float']>;
  businessInterruption?: Maybe<Scalars['Float']>;
  cyberAndTelephoneFraud?: Maybe<Scalars['Float']>;
  damageToReputationAndBrandImage?: Maybe<Scalars['Float']>;
  deductible?: Maybe<Scalars['Float']>;
  legalProtection?: Maybe<Scalars['Float']>;
  lossOfAkeyPerson?: Maybe<Scalars['Float']>;
  operatingLiabilityFoodPoisoning?: Maybe<Scalars['Float']>;
  operatingLiabilityNonConsecutiveImmaterialDamages?: Maybe<Scalars['Float']>;
  operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: Maybe<Scalars['Float']>;
  operatingLiabilityTheftByEmployees?: Maybe<Scalars['Float']>;
  physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: Maybe<Scalars['Float']>;
  suppliersDeficiency?: Maybe<Scalars['Float']>;
  thirdPartyDamageCoverage?: Maybe<Scalars['Float']>;
  unpaidInvoices?: Maybe<Scalars['Float']>;
};

export type PublicLiabilityEcommQuotationDetails = {
  __typename?: 'PublicLiabilityEcommQuotationDetails';
  activityId?: Maybe<Scalars['Int']>;
  allComputerMaterialDamageGuaranteeAmount?: Maybe<Scalars['Float']>;
  allComputerMaterialDamageOption?: Maybe<Scalars['Boolean']>;
  assistanceAndCyberExtortionOption?: Maybe<Scalars['Boolean']>;
  businessInterruptionOption?: Maybe<Scalars['Boolean']>;
  cyberAndTelephoneFraudOption?: Maybe<Scalars['Boolean']>;
  guaranteeAmount?: Maybe<Scalars['Float']>;
  suppliersDeficiencyOption?: Maybe<Scalars['Boolean']>;
  thirdPartyDamageCoverageOption?: Maybe<Scalars['Boolean']>;
};

export type PublicLiabilityEcommQuotationDetailsInput = {
  activityId?: InputMaybe<Scalars['Int']>;
  allComputerMaterialDamageGuaranteeAmount?: InputMaybe<Scalars['Float']>;
  allComputerMaterialDamageOption?: InputMaybe<Scalars['Boolean']>;
  assistanceAndCyberExtortionOption?: InputMaybe<Scalars['Boolean']>;
  businessInterruptionOption?: InputMaybe<Scalars['Boolean']>;
  cyberAndTelephoneFraudOption?: InputMaybe<Scalars['Boolean']>;
  guaranteeAmount?: InputMaybe<Scalars['Float']>;
  suppliersDeficiencyOption?: InputMaybe<Scalars['Boolean']>;
  thirdPartyDamageCoverageOption?: InputMaybe<Scalars['Boolean']>;
};

export type PublicLiabilityEcommQuotationPremium = ProductPricing & {
  __typename?: 'PublicLiabilityEcommQuotationPremium';
  allComputerMaterialDamageOption?: Maybe<Scalars['Float']>;
  applicationFees: ApplicationFeesQuotation;
  assistanceAndCyberExtortionOption?: Maybe<Scalars['Float']>;
  base: Scalars['Float'];
  businessInterruptionOption?: Maybe<Scalars['Float']>;
  cyberAndTelephoneFraudOption?: Maybe<Scalars['Float']>;
  discountedTotal?: Maybe<Scalars['Float']>;
  originalTotal: Scalars['Float'];
  suppliersDeficiencyOption?: Maybe<Scalars['Float']>;
  thirdPartyDamageCoverageOption?: Maybe<Scalars['Float']>;
};

export type PublicLiabilityQuotationCovers = {
  __typename?: 'PublicLiabilityQuotationCovers';
  bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: Maybe<Scalars['Float']>;
  consecutiveMaterialAndImmaterialDamages?: Maybe<Scalars['Float']>;
  consequencesOfTheEmployerInexcusableFault?: Maybe<Scalars['Float']>;
  criminalDefenseRecourse?: Maybe<Scalars['Float']>;
  cyberPublicLiability?: Maybe<Scalars['Float']>;
  damageToEntrustedProperty?: Maybe<Scalars['Float']>;
  damageToReputationAndBrandImage?: Maybe<Scalars['Float']>;
  deductible?: Maybe<Scalars['Float']>;
  hackingOfWebsite?: Maybe<Scalars['Float']>;
  legalProtection?: Maybe<Scalars['Float']>;
  lossOfAkeyPerson?: Maybe<Scalars['Float']>;
  nonConsecutiveImmaterialDamages?: Maybe<Scalars['Float']>;
  operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: Maybe<Scalars['Float']>;
  physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: Maybe<Scalars['Float']>;
  theftByEmployees?: Maybe<Scalars['Float']>;
  unpaidInvoices?: Maybe<Scalars['Float']>;
  violationOfPersonalData?: Maybe<Scalars['Float']>;
  virus?: Maybe<Scalars['Float']>;
};

export type PublicLiabilityQuotationDetails = {
  __typename?: 'PublicLiabilityQuotationDetails';
  activityIds?: Maybe<Array<Scalars['Int']>>;
  guaranteeAmount?: Maybe<Scalars['Float']>;
  legalProtectionOption?: Maybe<Scalars['Boolean']>;
  operatingLiabilityOption?: Maybe<Scalars['Boolean']>;
  worldWideOption?: Maybe<Scalars['Boolean']>;
};

export type PublicLiabilityQuotationDetailsInput = {
  activityIds?: InputMaybe<Array<Scalars['Int']>>;
  guaranteeAmount?: InputMaybe<Scalars['Float']>;
  legalProtectionOption?: InputMaybe<Scalars['Boolean']>;
  operatingLiabilityOption?: InputMaybe<Scalars['Boolean']>;
  worldWideOption?: InputMaybe<Scalars['Boolean']>;
};

export type PublicLiabilityQuotationPremium = ProductPricing & {
  __typename?: 'PublicLiabilityQuotationPremium';
  applicationFees: ApplicationFeesQuotation;
  base: Scalars['Float'];
  discountedTotal?: Maybe<Scalars['Float']>;
  legalProtectionOption?: Maybe<Scalars['Float']>;
  operatingLiabilityOption?: Maybe<Scalars['Float']>;
  originalTotal: Scalars['Float'];
  worldWideOption?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "quotation" */
export type Quotation = {
  __typename?: 'Quotation';
  /** An object relationship */
  contract?: Maybe<Contract>;
  covers?: Maybe<QuotationCovers>;
  createdAt: Scalars['timestamptz'];
  dbDetails: Scalars['jsonb'];
  details: QuotationDetails;
  hubspotDealId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  number: Scalars['String'];
  premium?: Maybe<QuotationPrice>;
  /** An object relationship */
  promoCode?: Maybe<PromoCode>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  status: QuotationStatusEnum;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "quotation" */
export type QuotationDbDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type QuotationAddress = {
  __typename?: 'QuotationAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<CountryEnum>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type QuotationAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryEnum>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "quotation" */
export type QuotationAggregate = {
  __typename?: 'QuotationAggregate';
  aggregate?: Maybe<QuotationAggregateFields>;
  nodes: Array<Quotation>;
};

export type QuotationAggregateBoolExp = {
  count?: InputMaybe<QuotationAggregateBoolExpCount>;
};

/** aggregate fields of "quotation" */
export type QuotationAggregateFields = {
  __typename?: 'QuotationAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<QuotationMaxFields>;
  min?: Maybe<QuotationMinFields>;
};


/** aggregate fields of "quotation" */
export type QuotationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QuotationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quotation" */
export type QuotationAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<QuotationMaxOrderBy>;
  min?: InputMaybe<QuotationMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type QuotationAppendInput = {
  dbDetails?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "quotation" */
export type QuotationArrRelInsertInput = {
  data: Array<QuotationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<QuotationOnConflict>;
};

/** Boolean expression to filter rows from the table "quotation". All fields are combined with a logical 'AND'. */
export type QuotationBoolExp = {
  _and?: InputMaybe<Array<QuotationBoolExp>>;
  _not?: InputMaybe<QuotationBoolExp>;
  _or?: InputMaybe<Array<QuotationBoolExp>>;
  contract?: InputMaybe<ContractBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dbDetails?: InputMaybe<JsonbComparisonExp>;
  hubspotDealId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  number?: InputMaybe<StringComparisonExp>;
  promoCode?: InputMaybe<PromoCodeBoolExp>;
  promoCodeId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<QuotationStatusEnumComparisonExp>;
  stripeCustomerId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UserBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

export type QuotationCompany = {
  __typename?: 'QuotationCompany';
  address?: Maybe<QuotationAddress>;
  foundedAt?: Maybe<Scalars['date']>;
  legalStatus?: Maybe<Scalars['String']>;
  nafCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
};

export type QuotationCompanyInput = {
  address?: InputMaybe<QuotationAddressInput>;
  foundedAt?: InputMaybe<Scalars['date']>;
  legalStatus?: InputMaybe<Scalars['String']>;
  nafCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  siret?: InputMaybe<Scalars['String']>;
};

/** unique or primary key constraints on table "quotation" */
export enum QuotationConstraint {
  /** unique or primary key constraint on columns "hubspot_deal_id" */
  QuotationHubspotDealIdKey = 'quotation_hubspot_deal_id_key',
  /** unique or primary key constraint on columns "number" */
  QuotationNumberKey = 'quotation_number_key',
  /** unique or primary key constraint on columns "id" */
  QuotationPkey = 'quotation_pkey'
}

export type QuotationContact = {
  __typename?: 'QuotationContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  userTypeName?: Maybe<UserTypeEnum>;
};

export type QuotationContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  userTypeName?: InputMaybe<UserTypeEnum>;
};

export type QuotationCovers = {
  __typename?: 'QuotationCovers';
  assistanceDomestique?: Maybe<AssistanceDomestiqueQuotationCovers>;
  assistanceDomestiqueProfessionnel?: Maybe<AssistanceDomestiqueProfessionnelQuotationCovers>;
  mreAcheel?: Maybe<MreAcheelQuotationCovers>;
  multiRisk?: Maybe<MultiRiskQuotationCovers>;
  publicLiability?: Maybe<PublicLiabilityQuotationCovers>;
  publicLiabilityEcomm?: Maybe<PublicLiabilityEcommQuotationCovers>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type QuotationDeleteAtPathInput = {
  dbDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type QuotationDeleteElemInput = {
  dbDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type QuotationDeleteKeyInput = {
  dbDetails?: InputMaybe<Scalars['String']>;
};

export type QuotationDetails = {
  __typename?: 'QuotationDetails';
  activeCampaignDealId?: Maybe<Scalars['Int']>;
  activeCampaignId?: Maybe<Scalars['Int']>;
  assistanceDomestique?: Maybe<AssistanceDomestiqueQuotationDetails>;
  assistanceDomestiqueProfessionnel?: Maybe<AssistanceDomestiqueProfessionnelQuotationDetails>;
  billingAddress?: Maybe<QuotationAddress>;
  company?: Maybe<QuotationCompany>;
  companyTypeName?: Maybe<CompanyTypeEnum>;
  contact?: Maybe<QuotationContact>;
  creation?: Maybe<Scalars['Boolean']>;
  mreAcheel?: Maybe<MreAcheelQuotationDetails>;
  multiRisk?: Maybe<MultiRiskQuotationDetails>;
  paymentFrequency?: Maybe<PaymentFrequency>;
  products?: Maybe<Array<ProductEnum>>;
  publicLiability?: Maybe<PublicLiabilityQuotationDetails>;
  publicLiabilityEcomm?: Maybe<PublicLiabilityEcommQuotationDetails>;
  startDate?: Maybe<Scalars['date']>;
  turnover?: Maybe<Scalars['Int']>;
};

export type QuotationDetailsInput = {
  activeCampaignDealId?: InputMaybe<Scalars['Int']>;
  activeCampaignId?: InputMaybe<Scalars['Int']>;
  assistanceDomestique?: InputMaybe<AssistanceDomestiqueQuotationDetailsInput>;
  assistanceDomestiqueProfessionnel?: InputMaybe<AssistanceDomestiqueProfessionnelQuotationDetailsInput>;
  billingAddress?: InputMaybe<QuotationAddressInput>;
  company?: InputMaybe<QuotationCompanyInput>;
  companyTypeName?: InputMaybe<CompanyTypeEnum>;
  contact?: InputMaybe<QuotationContactInput>;
  creation?: InputMaybe<Scalars['Boolean']>;
  mreAcheel?: InputMaybe<MreAcheelQuotationDetailsInput>;
  multiRisk?: InputMaybe<MultiRiskQuotationDetailsInput>;
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  products?: InputMaybe<Array<ProductEnum>>;
  publicLiability?: InputMaybe<PublicLiabilityQuotationDetailsInput>;
  publicLiabilityEcomm?: InputMaybe<PublicLiabilityEcommQuotationDetailsInput>;
  startDate?: InputMaybe<Scalars['date']>;
  turnover?: InputMaybe<Scalars['Int']>;
};

export enum QuotationDocument {
  Cgu = 'CGU',
  DocumentEntreeRelation = 'DOCUMENT_ENTREE_RELATION',
  FicheProduit = 'FICHE_PRODUIT',
  GeneralTerms = 'GENERAL_TERMS',
  Ipid = 'IPID',
  IpidDab = 'IPID_DAB',
  IpidRc = 'IPID_RC',
  LettreResiliation = 'LETTRE_RESILIATION',
  NoteCouverture = 'NOTE_COUVERTURE',
  PolitiqueConfidentialite = 'POLITIQUE_CONFIDENTIALITE',
  Quotation = 'QUOTATION'
}

export type QuotationId = {
  __typename?: 'QuotationId';
  id: Scalars['ID'];
  quotation?: Maybe<Quotation>;
};

export type QuotationInput = {
  applicationFees?: InputMaybe<Scalars['Int']>;
  base?: InputMaybe<Scalars['Float']>;
  discountedTotal?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  listName: Scalars['String'];
  number: Scalars['String'];
  originalTotal?: InputMaybe<Scalars['Float']>;
  pipelineTitle: Scalars['String'];
  quotation: QuotationDetailsInput;
  status: QuotationStatusEnum;
};

/** input type for inserting data into table "quotation" */
export type QuotationInsertInput = {
  contract?: InputMaybe<ContractObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  hubspotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<PromoCodeObjRelInsertInput>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<QuotationStatusEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UserObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type QuotationMaxFields = {
  __typename?: 'QuotationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hubspotDealId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "quotation" */
export type QuotationMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  hubspotDealId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type QuotationMinFields = {
  __typename?: 'QuotationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  hubspotDealId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  promoCodeId?: Maybe<Scalars['uuid']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "quotation" */
export type QuotationMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  hubspotDealId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "quotation" */
export type QuotationMutationResponse = {
  __typename?: 'QuotationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quotation>;
};

/** input type for inserting object relation for remote table "quotation" */
export type QuotationObjRelInsertInput = {
  data: QuotationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<QuotationOnConflict>;
};

/** on_conflict condition type for table "quotation" */
export type QuotationOnConflict = {
  constraint: QuotationConstraint;
  updateColumns?: Array<QuotationUpdateColumn>;
  where?: InputMaybe<QuotationBoolExp>;
};

/** Ordering options when selecting data from "quotation". */
export type QuotationOrderBy = {
  contract?: InputMaybe<ContractOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbDetails?: InputMaybe<OrderBy>;
  hubspotDealId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  promoCode?: InputMaybe<PromoCodeOrderBy>;
  promoCodeId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  stripeCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UserOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: quotation */
export type QuotationPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type QuotationPrependInput = {
  dbDetails?: InputMaybe<Scalars['jsonb']>;
};

export type QuotationPrice = {
  __typename?: 'QuotationPrice';
  /** The application fees total for the quotation, without discounts applied */
  applicationFeesTotal: Scalars['Float'];
  assistanceDomestique?: Maybe<AssistanceDomestiqueQuotationPremium>;
  assistanceDomestiqueProfessionnel?: Maybe<AssistanceDomestiqueProfessionnelQuotationPremium>;
  /** The total price for the quotation, without discounts applied. Will be null if no promo code is applied */
  discountedTotal?: Maybe<Scalars['Float']>;
  mreAcheel?: Maybe<MreAcheelQuotationPremium>;
  multiRisk?: Maybe<MultiRiskQuotationPremium>;
  /** The total price for the quotation, without discounts applied */
  originalTotal: Scalars['Float'];
  publicLiability?: Maybe<PublicLiabilityQuotationPremium>;
  publicLiabilityEcomm?: Maybe<PublicLiabilityEcommQuotationPremium>;
};

/** select columns of table "quotation" */
export enum QuotationSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbDetails = 'dbDetails',
  /** column name */
  HubspotDealId = 'hubspotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  PromoCodeId = 'promoCodeId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "quotation" */
export type QuotationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  hubspotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<QuotationStatusEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "quotation_status" */
export type QuotationStatus = {
  __typename?: 'QuotationStatus';
  name: Scalars['String'];
};

/** aggregated selection of "quotation_status" */
export type QuotationStatusAggregate = {
  __typename?: 'QuotationStatusAggregate';
  aggregate?: Maybe<QuotationStatusAggregateFields>;
  nodes: Array<QuotationStatus>;
};

/** aggregate fields of "quotation_status" */
export type QuotationStatusAggregateFields = {
  __typename?: 'QuotationStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<QuotationStatusMaxFields>;
  min?: Maybe<QuotationStatusMinFields>;
};


/** aggregate fields of "quotation_status" */
export type QuotationStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QuotationStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "quotation_status". All fields are combined with a logical 'AND'. */
export type QuotationStatusBoolExp = {
  _and?: InputMaybe<Array<QuotationStatusBoolExp>>;
  _not?: InputMaybe<QuotationStatusBoolExp>;
  _or?: InputMaybe<Array<QuotationStatusBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "quotation_status" */
export enum QuotationStatusConstraint {
  /** unique or primary key constraint on columns "name" */
  QuotationStatusPkey = 'quotation_status_pkey'
}

export enum QuotationStatusEnum {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Outdated = 'OUTDATED'
}

/** Boolean expression to compare columns of type "QuotationStatusEnum". All fields are combined with logical 'AND'. */
export type QuotationStatusEnumComparisonExp = {
  _eq?: InputMaybe<QuotationStatusEnum>;
  _in?: InputMaybe<Array<QuotationStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<QuotationStatusEnum>;
  _nin?: InputMaybe<Array<QuotationStatusEnum>>;
};

/** input type for inserting data into table "quotation_status" */
export type QuotationStatusInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type QuotationStatusMaxFields = {
  __typename?: 'QuotationStatusMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type QuotationStatusMinFields = {
  __typename?: 'QuotationStatusMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quotation_status" */
export type QuotationStatusMutationResponse = {
  __typename?: 'QuotationStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QuotationStatus>;
};

/** on_conflict condition type for table "quotation_status" */
export type QuotationStatusOnConflict = {
  constraint: QuotationStatusConstraint;
  updateColumns?: Array<QuotationStatusUpdateColumn>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};

/** Ordering options when selecting data from "quotation_status". */
export type QuotationStatusOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: quotation_status */
export type QuotationStatusPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "quotation_status" */
export enum QuotationStatusSelectColumn {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "quotation_status" */
export type QuotationStatusSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "quotation_status" */
export type QuotationStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QuotationStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QuotationStatusStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "quotation_status" */
export enum QuotationStatusUpdateColumn {
  /** column name */
  Name = 'name'
}

export type QuotationStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuotationStatusSetInput>;
  /** filter the rows which have to be updated */
  where: QuotationStatusBoolExp;
};

/** Streaming cursor of the table "quotation" */
export type QuotationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QuotationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QuotationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dbDetails?: InputMaybe<Scalars['jsonb']>;
  hubspotDealId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  promoCodeId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<QuotationStatusEnum>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "quotation" */
export enum QuotationUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DbDetails = 'dbDetails',
  /** column name */
  HubspotDealId = 'hubspotDealId',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  PromoCodeId = 'promoCodeId',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripeCustomerId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type QuotationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<QuotationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<QuotationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<QuotationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<QuotationDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<QuotationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuotationSetInput>;
  /** filter the rows which have to be updated */
  where: QuotationBoolExp;
};

/** columns and relationships of "retrocession_type" */
export type RetrocessionType = {
  __typename?: 'RetrocessionType';
  comment?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** aggregated selection of "retrocession_type" */
export type RetrocessionTypeAggregate = {
  __typename?: 'RetrocessionTypeAggregate';
  aggregate?: Maybe<RetrocessionTypeAggregateFields>;
  nodes: Array<RetrocessionType>;
};

/** aggregate fields of "retrocession_type" */
export type RetrocessionTypeAggregateFields = {
  __typename?: 'RetrocessionTypeAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RetrocessionTypeMaxFields>;
  min?: Maybe<RetrocessionTypeMinFields>;
};


/** aggregate fields of "retrocession_type" */
export type RetrocessionTypeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RetrocessionTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "retrocession_type". All fields are combined with a logical 'AND'. */
export type RetrocessionTypeBoolExp = {
  _and?: InputMaybe<Array<RetrocessionTypeBoolExp>>;
  _not?: InputMaybe<RetrocessionTypeBoolExp>;
  _or?: InputMaybe<Array<RetrocessionTypeBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "retrocession_type" */
export enum RetrocessionTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  RetrocessionTypePkey = 'retrocession_type_pkey'
}

export enum RetrocessionTypeEnum {
  FirstPeriod = 'FIRST_PERIOD',
  Recurrent = 'RECURRENT'
}

/** Boolean expression to compare columns of type "RetrocessionTypeEnum". All fields are combined with logical 'AND'. */
export type RetrocessionTypeEnumComparisonExp = {
  _eq?: InputMaybe<RetrocessionTypeEnum>;
  _in?: InputMaybe<Array<RetrocessionTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<RetrocessionTypeEnum>;
  _nin?: InputMaybe<Array<RetrocessionTypeEnum>>;
};

/** input type for inserting data into table "retrocession_type" */
export type RetrocessionTypeInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RetrocessionTypeMaxFields = {
  __typename?: 'RetrocessionTypeMaxFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RetrocessionTypeMinFields = {
  __typename?: 'RetrocessionTypeMinFields';
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "retrocession_type" */
export type RetrocessionTypeMutationResponse = {
  __typename?: 'RetrocessionTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RetrocessionType>;
};

/** on_conflict condition type for table "retrocession_type" */
export type RetrocessionTypeOnConflict = {
  constraint: RetrocessionTypeConstraint;
  updateColumns?: Array<RetrocessionTypeUpdateColumn>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};

/** Ordering options when selecting data from "retrocession_type". */
export type RetrocessionTypeOrderBy = {
  comment?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: retrocession_type */
export type RetrocessionTypePkColumnsInput = {
  type: Scalars['String'];
};

/** select columns of table "retrocession_type" */
export enum RetrocessionTypeSelectColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "retrocession_type" */
export type RetrocessionTypeSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "retrocession_type" */
export type RetrocessionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RetrocessionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RetrocessionTypeStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "retrocession_type" */
export enum RetrocessionTypeUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Type = 'type'
}

export type RetrocessionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RetrocessionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: RetrocessionTypeBoolExp;
};

/** columns and relationships of "session" */
export type Session = {
  __typename?: 'Session';
  /** An object relationship */
  account: Account;
  accountId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  refreshTokenCodeHash: Scalars['String'];
  refreshedAt: Scalars['timestamptz'];
};

/** aggregated selection of "session" */
export type SessionAggregate = {
  __typename?: 'SessionAggregate';
  aggregate?: Maybe<SessionAggregateFields>;
  nodes: Array<Session>;
};

export type SessionAggregateBoolExp = {
  count?: InputMaybe<SessionAggregateBoolExpCount>;
};

/** aggregate fields of "session" */
export type SessionAggregateFields = {
  __typename?: 'SessionAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<SessionMaxFields>;
  min?: Maybe<SessionMinFields>;
};


/** aggregate fields of "session" */
export type SessionAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SessionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "session" */
export type SessionAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SessionMaxOrderBy>;
  min?: InputMaybe<SessionMinOrderBy>;
};

/** input type for inserting array relation for remote table "session" */
export type SessionArrRelInsertInput = {
  data: Array<SessionInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SessionOnConflict>;
};

/** Boolean expression to filter rows from the table "session". All fields are combined with a logical 'AND'. */
export type SessionBoolExp = {
  _and?: InputMaybe<Array<SessionBoolExp>>;
  _not?: InputMaybe<SessionBoolExp>;
  _or?: InputMaybe<Array<SessionBoolExp>>;
  account?: InputMaybe<AccountBoolExp>;
  accountId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  refreshTokenCodeHash?: InputMaybe<StringComparisonExp>;
  refreshedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "session" */
export enum SessionConstraint {
  /** unique or primary key constraint on columns "id" */
  SessionPkey = 'session_pkey'
}

/** input type for inserting data into table "session" */
export type SessionInsertInput = {
  account?: InputMaybe<AccountObjRelInsertInput>;
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshTokenCodeHash?: InputMaybe<Scalars['String']>;
  refreshedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SessionMaxFields = {
  __typename?: 'SessionMaxFields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshTokenCodeHash?: Maybe<Scalars['String']>;
  refreshedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "session" */
export type SessionMaxOrderBy = {
  accountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  refreshTokenCodeHash?: InputMaybe<OrderBy>;
  refreshedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SessionMinFields = {
  __typename?: 'SessionMinFields';
  accountId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  refreshTokenCodeHash?: Maybe<Scalars['String']>;
  refreshedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "session" */
export type SessionMinOrderBy = {
  accountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  refreshTokenCodeHash?: InputMaybe<OrderBy>;
  refreshedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "session" */
export type SessionMutationResponse = {
  __typename?: 'SessionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Session>;
};

/** on_conflict condition type for table "session" */
export type SessionOnConflict = {
  constraint: SessionConstraint;
  updateColumns?: Array<SessionUpdateColumn>;
  where?: InputMaybe<SessionBoolExp>;
};

/** Ordering options when selecting data from "session". */
export type SessionOrderBy = {
  account?: InputMaybe<AccountOrderBy>;
  accountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  refreshTokenCodeHash?: InputMaybe<OrderBy>;
  refreshedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: session */
export type SessionPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "session" */
export enum SessionSelectColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshTokenCodeHash = 'refreshTokenCodeHash',
  /** column name */
  RefreshedAt = 'refreshedAt'
}

/** input type for updating data in table "session" */
export type SessionSetInput = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshTokenCodeHash?: InputMaybe<Scalars['String']>;
  refreshedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "session" */
export type SessionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SessionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SessionStreamCursorValueInput = {
  accountId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  refreshTokenCodeHash?: InputMaybe<Scalars['String']>;
  refreshedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "session" */
export enum SessionUpdateColumn {
  /** column name */
  AccountId = 'accountId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshTokenCodeHash = 'refreshTokenCodeHash',
  /** column name */
  RefreshedAt = 'refreshedAt'
}

export type SessionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SessionSetInput>;
  /** filter the rows which have to be updated */
  where: SessionBoolExp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type Tokens = {
  __typename?: 'Tokens';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'User';
  /** An array relationship */
  accounts: Array<Account>;
  /** An aggregate relationship */
  accountsAggregate: AccountAggregate;
  /** An array relationship */
  contracts: Array<Contract>;
  /** An aggregate relationship */
  contractsAggregate: ContractAggregate;
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  hubspotContactId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  idClientSesame?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  marketingOptIn: Scalars['Boolean'];
  phone: Scalars['String'];
  /** An array relationship */
  quotations: Array<Quotation>;
  /** An aggregate relationship */
  quotationsAggregate: QuotationAggregate;
  updatedAt: Scalars['timestamptz'];
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  userTypeName: Scalars['String'];
};


/** columns and relationships of "user" */
export type UserAccountsArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


/** columns and relationships of "user" */
export type UserAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


/** columns and relationships of "user" */
export type UserContractsArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


/** columns and relationships of "user" */
export type UserContractsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


/** columns and relationships of "user" */
export type UserQuotationsArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};


/** columns and relationships of "user" */
export type UserQuotationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};

/** aggregated selection of "user" */
export type UserAggregate = {
  __typename?: 'UserAggregate';
  aggregate?: Maybe<UserAggregateFields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type UserAggregateFields = {
  __typename?: 'UserAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserMaxFields>;
  min?: Maybe<UserMinFields>;
};


/** aggregate fields of "user" */
export type UserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type UserBoolExp = {
  _and?: InputMaybe<Array<UserBoolExp>>;
  _not?: InputMaybe<UserBoolExp>;
  _or?: InputMaybe<Array<UserBoolExp>>;
  accounts?: InputMaybe<AccountBoolExp>;
  accountsAggregate?: InputMaybe<AccountAggregateBoolExp>;
  contracts?: InputMaybe<ContractBoolExp>;
  contractsAggregate?: InputMaybe<ContractAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  hubspotContactId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idClientSesame?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  marketingOptIn?: InputMaybe<BooleanComparisonExp>;
  phone?: InputMaybe<StringComparisonExp>;
  quotations?: InputMaybe<QuotationBoolExp>;
  quotationsAggregate?: InputMaybe<QuotationAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedSesameAt?: InputMaybe<TimestamptzComparisonExp>;
  userTypeName?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user" */
export enum UserConstraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "hubspot_contact_id" */
  UserHubspotContactIdKey = 'user_hubspot_contact_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

export type UserId = {
  __typename?: 'UserId';
  id: Scalars['ID'];
  user?: Maybe<User>;
};

/** input type for inserting data into table "user" */
export type UserInsertInput = {
  accounts?: InputMaybe<AccountArrRelInsertInput>;
  contracts?: InputMaybe<ContractArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hubspotContactId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idClientSesame?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  quotations?: InputMaybe<QuotationArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  userTypeName?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserMaxFields = {
  __typename?: 'UserMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hubspotContactId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idClientSesame?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  userTypeName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserMinFields = {
  __typename?: 'UserMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hubspotContactId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idClientSesame?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedSesameAt?: Maybe<Scalars['timestamptz']>;
  userTypeName?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user" */
export type UserMutationResponse = {
  __typename?: 'UserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type UserObjRelInsertInput = {
  data: UserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserOnConflict>;
};

/** on_conflict condition type for table "user" */
export type UserOnConflict = {
  constraint: UserConstraint;
  updateColumns?: Array<UserUpdateColumn>;
  where?: InputMaybe<UserBoolExp>;
};

/** Ordering options when selecting data from "user". */
export type UserOrderBy = {
  accountsAggregate?: InputMaybe<AccountAggregateOrderBy>;
  contractsAggregate?: InputMaybe<ContractAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  hubspotContactId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idClientSesame?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  marketingOptIn?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  quotationsAggregate?: InputMaybe<QuotationAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedSesameAt?: InputMaybe<OrderBy>;
  userTypeName?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user */
export type UserPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "user" */
export enum UserSelectColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  HubspotContactId = 'hubspotContactId',
  /** column name */
  Id = 'id',
  /** column name */
  IdClientSesame = 'idClientSesame',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MarketingOptIn = 'marketingOptIn',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedSesameAt = 'updatedSesameAt',
  /** column name */
  UserTypeName = 'userTypeName'
}

/** input type for updating data in table "user" */
export type UserSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hubspotContactId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idClientSesame?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  userTypeName?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user" */
export type UserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hubspotContactId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idClientSesame?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedSesameAt?: InputMaybe<Scalars['timestamptz']>;
  userTypeName?: InputMaybe<Scalars['String']>;
};

export enum UserTypeEnum {
  Collectivite = 'COLLECTIVITE',
  Particulier = 'PARTICULIER',
  Professionnel = 'PROFESSIONNEL'
}

/** update columns of table "user" */
export enum UserUpdateColumn {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  HubspotContactId = 'hubspotContactId',
  /** column name */
  Id = 'id',
  /** column name */
  IdClientSesame = 'idClientSesame',
  /** column name */
  LastName = 'lastName',
  /** column name */
  MarketingOptIn = 'marketingOptIn',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedSesameAt = 'updatedSesameAt',
  /** column name */
  UserTypeName = 'userTypeName'
}

export type UserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSetInput>;
  /** filter the rows which have to be updated */
  where: UserBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type AccountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountBoolExp>;
  predicate: IntComparisonExp;
};

export type ActivityAggregateBoolExpBool_And = {
  arguments: ActivitySelectColumnActivityAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActivityBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ActivityAggregateBoolExpBool_Or = {
  arguments: ActivitySelectColumnActivityAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActivityBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ActivityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActivityBoolExp>;
  predicate: IntComparisonExp;
};

export type ActivityCategoryAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActivityCategoryBoolExp>;
  predicate: IntComparisonExp;
};

export type ContractAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContractSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractBoolExp>;
  predicate: IntComparisonExp;
};

export type ContractPeriodAggregateBoolExpBool_And = {
  arguments: ContractPeriodSelectColumnContractPeriodAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractPeriodBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ContractPeriodAggregateBoolExpBool_Or = {
  arguments: ContractPeriodSelectColumnContractPeriodAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractPeriodBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ContractPeriodAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractPeriodBoolExp>;
  predicate: IntComparisonExp;
};

export type ContractPeriodDocumentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContractPeriodDocumentBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  applyQuotationPromoCode: ApplyQuotationPromoCodeResult;
  completeQuotation: Scalars['Boolean'];
  createContractPeriod: ContractPeriodId;
  createContractPeriodDocument: ContractPeriodDocumentId;
  createPartner: PartnerId;
  createPartnerFile: PartnerFileId;
  createQuotation: QuotationId;
  createStripeCustomerPortalSession: Scalars['String'];
  /** delete data from the table: "access_token_signing_key" */
  deleteAccessTokenSigningKey?: Maybe<AccessTokenSigningKeyMutationResponse>;
  /** delete single row from the table: "access_token_signing_key" */
  deleteAccessTokenSigningKeyByPk?: Maybe<AccessTokenSigningKey>;
  /** delete data from the table: "account" */
  deleteAccount?: Maybe<AccountMutationResponse>;
  /** delete single row from the table: "account" */
  deleteAccountByPk?: Maybe<Account>;
  /** delete data from the table: "activity" */
  deleteActivity?: Maybe<ActivityMutationResponse>;
  /** delete single row from the table: "activity" */
  deleteActivityByPk?: Maybe<Activity>;
  /** delete data from the table: "activity_category" */
  deleteActivityCategory?: Maybe<ActivityCategoryMutationResponse>;
  /** delete single row from the table: "activity_category" */
  deleteActivityCategoryByPk?: Maybe<ActivityCategory>;
  /** delete data from the table: "activity_sector" */
  deleteActivitySector?: Maybe<ActivitySectorMutationResponse>;
  /** delete single row from the table: "activity_sector" */
  deleteActivitySectorByPk?: Maybe<ActivitySector>;
  /** delete data from the table: "auth_provider" */
  deleteAuthProvider?: Maybe<AuthProviderMutationResponse>;
  /** delete single row from the table: "auth_provider" */
  deleteAuthProviderByPk?: Maybe<AuthProvider>;
  /** delete data from the table: "broker" */
  deleteBroker?: Maybe<BrokerMutationResponse>;
  /** delete single row from the table: "broker" */
  deleteBrokerByPk?: Maybe<Broker>;
  /** delete data from the table: "contract" */
  deleteContract?: Maybe<ContractMutationResponse>;
  /** delete single row from the table: "contract" */
  deleteContractByPk?: Maybe<Contract>;
  /** delete data from the table: "contract_mode" */
  deleteContractMode?: Maybe<ContractModeMutationResponse>;
  /** delete single row from the table: "contract_mode" */
  deleteContractModeByPk?: Maybe<ContractMode>;
  /** delete data from the table: "contract_period" */
  deleteContractPeriod?: Maybe<ContractPeriodMutationResponse>;
  /** delete single row from the table: "contract_period" */
  deleteContractPeriodByPk?: Maybe<ContractPeriod>;
  /** delete data from the table: "contract_period_document" */
  deleteContractPeriodDocument?: Maybe<ContractPeriodDocumentMutationResponse>;
  /** delete single row from the table: "contract_period_document" */
  deleteContractPeriodDocumentByPk?: Maybe<ContractPeriodDocument>;
  /** delete data from the table: "contract_period_document_status" */
  deleteContractPeriodDocumentStatus?: Maybe<ContractPeriodDocumentStatusMutationResponse>;
  /** delete single row from the table: "contract_period_document_status" */
  deleteContractPeriodDocumentStatusByPk?: Maybe<ContractPeriodDocumentStatus>;
  /** delete data from the table: "contract_period_document_type" */
  deleteContractPeriodDocumentType?: Maybe<ContractPeriodDocumentTypeMutationResponse>;
  /** delete single row from the table: "contract_period_document_type" */
  deleteContractPeriodDocumentTypeByPk?: Maybe<ContractPeriodDocumentType>;
  /** delete data from the table: "contract_period_status" */
  deleteContractPeriodStatus?: Maybe<ContractPeriodStatusMutationResponse>;
  /** delete single row from the table: "contract_period_status" */
  deleteContractPeriodStatusByPk?: Maybe<ContractPeriodStatus>;
  /** delete data from the table: "country" */
  deleteCountry?: Maybe<CountryMutationResponse>;
  /** delete single row from the table: "country" */
  deleteCountryByPk?: Maybe<Country>;
  /** delete data from the table: "db_address" */
  deleteDbAddress?: Maybe<DbAddressMutationResponse>;
  /** delete single row from the table: "db_address" */
  deleteDbAddressByPk?: Maybe<DbAddress>;
  /** delete data from the table: "file" */
  deleteFile?: Maybe<FileMutationResponse>;
  /** delete single row from the table: "file" */
  deleteFileByPk?: Maybe<File>;
  /** delete data from the table: "insurer" */
  deleteInsurer?: Maybe<InsurerMutationResponse>;
  /** delete single row from the table: "insurer" */
  deleteInsurerByPk?: Maybe<Insurer>;
  /** delete data from the table: "otp" */
  deleteOtp?: Maybe<OtpMutationResponse>;
  /** delete single row from the table: "otp" */
  deleteOtpByPk?: Maybe<Otp>;
  /** delete data from the table: "partner" */
  deletePartner?: Maybe<PartnerMutationResponse>;
  /** delete single row from the table: "partner" */
  deletePartnerByPk?: Maybe<Partner>;
  /** delete data from the table: "partner_category" */
  deletePartnerCategory?: Maybe<PartnerCategoryMutationResponse>;
  /** delete single row from the table: "partner_category" */
  deletePartnerCategoryByPk?: Maybe<PartnerCategory>;
  /** delete data from the table: "partner_file" */
  deletePartnerFile?: Maybe<PartnerFileMutationResponse>;
  /** delete single row from the table: "partner_file" */
  deletePartnerFileByPk?: Maybe<PartnerFile>;
  /** delete data from the table: "partner_file_type" */
  deletePartnerFileType?: Maybe<PartnerFileTypeMutationResponse>;
  /** delete single row from the table: "partner_file_type" */
  deletePartnerFileTypeByPk?: Maybe<PartnerFileType>;
  /** delete data from the table: "partner_product" */
  deletePartnerProduct?: Maybe<PartnerProductMutationResponse>;
  /** delete single row from the table: "partner_product" */
  deletePartnerProductByPk?: Maybe<PartnerProduct>;
  /** delete data from the table: "product" */
  deleteProduct?: Maybe<ProductMutationResponse>;
  /** delete single row from the table: "product" */
  deleteProductByPk?: Maybe<Product>;
  /** delete data from the table: "promo_code" */
  deletePromoCode?: Maybe<PromoCodeMutationResponse>;
  /** delete single row from the table: "promo_code" */
  deletePromoCodeByPk?: Maybe<PromoCode>;
  /** delete data from the table: "promo_code_type" */
  deletePromoCodeType?: Maybe<PromoCodeTypeMutationResponse>;
  /** delete single row from the table: "promo_code_type" */
  deletePromoCodeTypeByPk?: Maybe<PromoCodeType>;
  /** delete data from the table: "quotation" */
  deleteQuotation?: Maybe<QuotationMutationResponse>;
  /** delete single row from the table: "quotation" */
  deleteQuotationByPk?: Maybe<Quotation>;
  /** delete data from the table: "quotation_status" */
  deleteQuotationStatus?: Maybe<QuotationStatusMutationResponse>;
  /** delete single row from the table: "quotation_status" */
  deleteQuotationStatusByPk?: Maybe<QuotationStatus>;
  /** delete data from the table: "retrocession_type" */
  deleteRetrocessionType?: Maybe<RetrocessionTypeMutationResponse>;
  /** delete single row from the table: "retrocession_type" */
  deleteRetrocessionTypeByPk?: Maybe<RetrocessionType>;
  /** delete data from the table: "session" */
  deleteSession?: Maybe<SessionMutationResponse>;
  /** delete single row from the table: "session" */
  deleteSessionByPk?: Maybe<Session>;
  /** delete data from the table: "user" */
  deleteUser?: Maybe<UserMutationResponse>;
  /** delete single row from the table: "user" */
  deleteUserByPk?: Maybe<User>;
  fillQuotation: QuotationId;
  /** insert data into the table: "access_token_signing_key" */
  insertAccessTokenSigningKey?: Maybe<AccessTokenSigningKeyMutationResponse>;
  /** insert a single row into the table: "access_token_signing_key" */
  insertAccessTokenSigningKeyOne?: Maybe<AccessTokenSigningKey>;
  /** insert data into the table: "account" */
  insertAccount?: Maybe<AccountMutationResponse>;
  /** insert a single row into the table: "account" */
  insertAccountOne?: Maybe<Account>;
  /** insert data into the table: "activity" */
  insertActivity?: Maybe<ActivityMutationResponse>;
  /** insert data into the table: "activity_category" */
  insertActivityCategory?: Maybe<ActivityCategoryMutationResponse>;
  /** insert a single row into the table: "activity_category" */
  insertActivityCategoryOne?: Maybe<ActivityCategory>;
  /** insert a single row into the table: "activity" */
  insertActivityOne?: Maybe<Activity>;
  /** insert data into the table: "activity_sector" */
  insertActivitySector?: Maybe<ActivitySectorMutationResponse>;
  /** insert a single row into the table: "activity_sector" */
  insertActivitySectorOne?: Maybe<ActivitySector>;
  /** insert data into the table: "auth_provider" */
  insertAuthProvider?: Maybe<AuthProviderMutationResponse>;
  /** insert a single row into the table: "auth_provider" */
  insertAuthProviderOne?: Maybe<AuthProvider>;
  /** insert data into the table: "broker" */
  insertBroker?: Maybe<BrokerMutationResponse>;
  /** insert a single row into the table: "broker" */
  insertBrokerOne?: Maybe<Broker>;
  /** insert data into the table: "contract" */
  insertContract?: Maybe<ContractMutationResponse>;
  /** insert data into the table: "contract_mode" */
  insertContractMode?: Maybe<ContractModeMutationResponse>;
  /** insert a single row into the table: "contract_mode" */
  insertContractModeOne?: Maybe<ContractMode>;
  /** insert a single row into the table: "contract" */
  insertContractOne?: Maybe<Contract>;
  /** insert data into the table: "contract_period" */
  insertContractPeriod?: Maybe<ContractPeriodMutationResponse>;
  /** insert data into the table: "contract_period_document" */
  insertContractPeriodDocument?: Maybe<ContractPeriodDocumentMutationResponse>;
  /** insert a single row into the table: "contract_period_document" */
  insertContractPeriodDocumentOne?: Maybe<ContractPeriodDocument>;
  /** insert data into the table: "contract_period_document_status" */
  insertContractPeriodDocumentStatus?: Maybe<ContractPeriodDocumentStatusMutationResponse>;
  /** insert a single row into the table: "contract_period_document_status" */
  insertContractPeriodDocumentStatusOne?: Maybe<ContractPeriodDocumentStatus>;
  /** insert data into the table: "contract_period_document_type" */
  insertContractPeriodDocumentType?: Maybe<ContractPeriodDocumentTypeMutationResponse>;
  /** insert a single row into the table: "contract_period_document_type" */
  insertContractPeriodDocumentTypeOne?: Maybe<ContractPeriodDocumentType>;
  /** insert a single row into the table: "contract_period" */
  insertContractPeriodOne?: Maybe<ContractPeriod>;
  /** insert data into the table: "contract_period_status" */
  insertContractPeriodStatus?: Maybe<ContractPeriodStatusMutationResponse>;
  /** insert a single row into the table: "contract_period_status" */
  insertContractPeriodStatusOne?: Maybe<ContractPeriodStatus>;
  /** insert data into the table: "country" */
  insertCountry?: Maybe<CountryMutationResponse>;
  /** insert a single row into the table: "country" */
  insertCountryOne?: Maybe<Country>;
  /** insert data into the table: "db_address" */
  insertDbAddress?: Maybe<DbAddressMutationResponse>;
  /** insert a single row into the table: "db_address" */
  insertDbAddressOne?: Maybe<DbAddress>;
  /** insert data into the table: "file" */
  insertFile?: Maybe<FileMutationResponse>;
  /** insert a single row into the table: "file" */
  insertFileOne?: Maybe<File>;
  /** insert data into the table: "insurer" */
  insertInsurer?: Maybe<InsurerMutationResponse>;
  /** insert a single row into the table: "insurer" */
  insertInsurerOne?: Maybe<Insurer>;
  /** insert data into the table: "otp" */
  insertOtp?: Maybe<OtpMutationResponse>;
  /** insert a single row into the table: "otp" */
  insertOtpOne?: Maybe<Otp>;
  /** insert data into the table: "partner" */
  insertPartner?: Maybe<PartnerMutationResponse>;
  /** insert data into the table: "partner_category" */
  insertPartnerCategory?: Maybe<PartnerCategoryMutationResponse>;
  /** insert a single row into the table: "partner_category" */
  insertPartnerCategoryOne?: Maybe<PartnerCategory>;
  /** insert data into the table: "partner_file" */
  insertPartnerFile?: Maybe<PartnerFileMutationResponse>;
  /** insert a single row into the table: "partner_file" */
  insertPartnerFileOne?: Maybe<PartnerFile>;
  /** insert data into the table: "partner_file_type" */
  insertPartnerFileType?: Maybe<PartnerFileTypeMutationResponse>;
  /** insert a single row into the table: "partner_file_type" */
  insertPartnerFileTypeOne?: Maybe<PartnerFileType>;
  /** insert a single row into the table: "partner" */
  insertPartnerOne?: Maybe<Partner>;
  /** insert data into the table: "partner_product" */
  insertPartnerProduct?: Maybe<PartnerProductMutationResponse>;
  /** insert a single row into the table: "partner_product" */
  insertPartnerProductOne?: Maybe<PartnerProduct>;
  /** insert data into the table: "product" */
  insertProduct?: Maybe<ProductMutationResponse>;
  /** insert a single row into the table: "product" */
  insertProductOne?: Maybe<Product>;
  /** insert data into the table: "promo_code" */
  insertPromoCode?: Maybe<PromoCodeMutationResponse>;
  /** insert a single row into the table: "promo_code" */
  insertPromoCodeOne?: Maybe<PromoCode>;
  /** insert data into the table: "promo_code_type" */
  insertPromoCodeType?: Maybe<PromoCodeTypeMutationResponse>;
  /** insert a single row into the table: "promo_code_type" */
  insertPromoCodeTypeOne?: Maybe<PromoCodeType>;
  /** insert data into the table: "quotation" */
  insertQuotation?: Maybe<QuotationMutationResponse>;
  /** insert a single row into the table: "quotation" */
  insertQuotationOne?: Maybe<Quotation>;
  /** insert data into the table: "quotation_status" */
  insertQuotationStatus?: Maybe<QuotationStatusMutationResponse>;
  /** insert a single row into the table: "quotation_status" */
  insertQuotationStatusOne?: Maybe<QuotationStatus>;
  /** insert data into the table: "retrocession_type" */
  insertRetrocessionType?: Maybe<RetrocessionTypeMutationResponse>;
  /** insert a single row into the table: "retrocession_type" */
  insertRetrocessionTypeOne?: Maybe<RetrocessionType>;
  /** insert data into the table: "session" */
  insertSession?: Maybe<SessionMutationResponse>;
  /** insert a single row into the table: "session" */
  insertSessionOne?: Maybe<Session>;
  /** insert data into the table: "user" */
  insertUser?: Maybe<UserMutationResponse>;
  /** insert a single row into the table: "user" */
  insertUserOne?: Maybe<User>;
  refreshAccessToken: Tokens;
  /** Returns a client secret to be used by the frontend to register a payment method with stripe */
  registerPaymentMethod: Scalars['String'];
  removeQuotationPromoCode: QuotationId;
  /** Send an OTP to the user's email, and returns a device ID to be used in the login mutation. */
  sendSignInOTP: Scalars['String'];
  signInWithOTP: Tokens;
  /** Sign up a new user, sending an OTP to the user's email, and returns a device ID to be used in the login mutation. */
  signUp: Scalars['String'];
  /** update data of the table: "access_token_signing_key" */
  updateAccessTokenSigningKey?: Maybe<AccessTokenSigningKeyMutationResponse>;
  /** update single row of the table: "access_token_signing_key" */
  updateAccessTokenSigningKeyByPk?: Maybe<AccessTokenSigningKey>;
  /** update multiples rows of table: "access_token_signing_key" */
  updateAccessTokenSigningKeyMany?: Maybe<Array<Maybe<AccessTokenSigningKeyMutationResponse>>>;
  /** update data of the table: "account" */
  updateAccount?: Maybe<AccountMutationResponse>;
  /** update single row of the table: "account" */
  updateAccountByPk?: Maybe<Account>;
  /** update multiples rows of table: "account" */
  updateAccountMany?: Maybe<Array<Maybe<AccountMutationResponse>>>;
  /** update data of the table: "activity" */
  updateActivity?: Maybe<ActivityMutationResponse>;
  /** update single row of the table: "activity" */
  updateActivityByPk?: Maybe<Activity>;
  /** update data of the table: "activity_category" */
  updateActivityCategory?: Maybe<ActivityCategoryMutationResponse>;
  /** update single row of the table: "activity_category" */
  updateActivityCategoryByPk?: Maybe<ActivityCategory>;
  /** update multiples rows of table: "activity_category" */
  updateActivityCategoryMany?: Maybe<Array<Maybe<ActivityCategoryMutationResponse>>>;
  /** update multiples rows of table: "activity" */
  updateActivityMany?: Maybe<Array<Maybe<ActivityMutationResponse>>>;
  /** update data of the table: "activity_sector" */
  updateActivitySector?: Maybe<ActivitySectorMutationResponse>;
  /** update single row of the table: "activity_sector" */
  updateActivitySectorByPk?: Maybe<ActivitySector>;
  /** update multiples rows of table: "activity_sector" */
  updateActivitySectorMany?: Maybe<Array<Maybe<ActivitySectorMutationResponse>>>;
  /** update data of the table: "auth_provider" */
  updateAuthProvider?: Maybe<AuthProviderMutationResponse>;
  /** update single row of the table: "auth_provider" */
  updateAuthProviderByPk?: Maybe<AuthProvider>;
  /** update multiples rows of table: "auth_provider" */
  updateAuthProviderMany?: Maybe<Array<Maybe<AuthProviderMutationResponse>>>;
  /** update data of the table: "broker" */
  updateBroker?: Maybe<BrokerMutationResponse>;
  /** update single row of the table: "broker" */
  updateBrokerByPk?: Maybe<Broker>;
  /** update multiples rows of table: "broker" */
  updateBrokerMany?: Maybe<Array<Maybe<BrokerMutationResponse>>>;
  /** update data of the table: "contract" */
  updateContract?: Maybe<ContractMutationResponse>;
  /** update single row of the table: "contract" */
  updateContractByPk?: Maybe<Contract>;
  /** update multiples rows of table: "contract" */
  updateContractMany?: Maybe<Array<Maybe<ContractMutationResponse>>>;
  /** update data of the table: "contract_mode" */
  updateContractMode?: Maybe<ContractModeMutationResponse>;
  /** update single row of the table: "contract_mode" */
  updateContractModeByPk?: Maybe<ContractMode>;
  /** update multiples rows of table: "contract_mode" */
  updateContractModeMany?: Maybe<Array<Maybe<ContractModeMutationResponse>>>;
  /** update data of the table: "contract_period" */
  updateContractPeriod?: Maybe<ContractPeriodMutationResponse>;
  /** update single row of the table: "contract_period" */
  updateContractPeriodByPk?: Maybe<ContractPeriod>;
  /** update data of the table: "contract_period_document" */
  updateContractPeriodDocument?: Maybe<ContractPeriodDocumentMutationResponse>;
  /** update single row of the table: "contract_period_document" */
  updateContractPeriodDocumentByPk?: Maybe<ContractPeriodDocument>;
  /** update multiples rows of table: "contract_period_document" */
  updateContractPeriodDocumentMany?: Maybe<Array<Maybe<ContractPeriodDocumentMutationResponse>>>;
  /** update data of the table: "contract_period_document_status" */
  updateContractPeriodDocumentStatus?: Maybe<ContractPeriodDocumentStatusMutationResponse>;
  /** update single row of the table: "contract_period_document_status" */
  updateContractPeriodDocumentStatusByPk?: Maybe<ContractPeriodDocumentStatus>;
  /** update multiples rows of table: "contract_period_document_status" */
  updateContractPeriodDocumentStatusMany?: Maybe<Array<Maybe<ContractPeriodDocumentStatusMutationResponse>>>;
  /** update data of the table: "contract_period_document_type" */
  updateContractPeriodDocumentType?: Maybe<ContractPeriodDocumentTypeMutationResponse>;
  /** update single row of the table: "contract_period_document_type" */
  updateContractPeriodDocumentTypeByPk?: Maybe<ContractPeriodDocumentType>;
  /** update multiples rows of table: "contract_period_document_type" */
  updateContractPeriodDocumentTypeMany?: Maybe<Array<Maybe<ContractPeriodDocumentTypeMutationResponse>>>;
  /** update multiples rows of table: "contract_period" */
  updateContractPeriodMany?: Maybe<Array<Maybe<ContractPeriodMutationResponse>>>;
  /** update data of the table: "contract_period_status" */
  updateContractPeriodStatus?: Maybe<ContractPeriodStatusMutationResponse>;
  /** update single row of the table: "contract_period_status" */
  updateContractPeriodStatusByPk?: Maybe<ContractPeriodStatus>;
  /** update multiples rows of table: "contract_period_status" */
  updateContractPeriodStatusMany?: Maybe<Array<Maybe<ContractPeriodStatusMutationResponse>>>;
  /** update data of the table: "country" */
  updateCountry?: Maybe<CountryMutationResponse>;
  /** update single row of the table: "country" */
  updateCountryByPk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  updateCountryMany?: Maybe<Array<Maybe<CountryMutationResponse>>>;
  /** update data of the table: "db_address" */
  updateDbAddress?: Maybe<DbAddressMutationResponse>;
  /** update single row of the table: "db_address" */
  updateDbAddressByPk?: Maybe<DbAddress>;
  /** update multiples rows of table: "db_address" */
  updateDbAddressMany?: Maybe<Array<Maybe<DbAddressMutationResponse>>>;
  /** update data of the table: "file" */
  updateFile?: Maybe<FileMutationResponse>;
  /** update single row of the table: "file" */
  updateFileByPk?: Maybe<File>;
  /** update multiples rows of table: "file" */
  updateFileMany?: Maybe<Array<Maybe<FileMutationResponse>>>;
  /** update data of the table: "insurer" */
  updateInsurer?: Maybe<InsurerMutationResponse>;
  /** update single row of the table: "insurer" */
  updateInsurerByPk?: Maybe<Insurer>;
  /** update multiples rows of table: "insurer" */
  updateInsurerMany?: Maybe<Array<Maybe<InsurerMutationResponse>>>;
  /** update data of the table: "otp" */
  updateOtp?: Maybe<OtpMutationResponse>;
  /** update single row of the table: "otp" */
  updateOtpByPk?: Maybe<Otp>;
  /** update multiples rows of table: "otp" */
  updateOtpMany?: Maybe<Array<Maybe<OtpMutationResponse>>>;
  /** update data of the table: "partner" */
  updatePartner?: Maybe<PartnerMutationResponse>;
  /** update single row of the table: "partner" */
  updatePartnerByPk?: Maybe<Partner>;
  /** update data of the table: "partner_category" */
  updatePartnerCategory?: Maybe<PartnerCategoryMutationResponse>;
  /** update single row of the table: "partner_category" */
  updatePartnerCategoryByPk?: Maybe<PartnerCategory>;
  /** update multiples rows of table: "partner_category" */
  updatePartnerCategoryMany?: Maybe<Array<Maybe<PartnerCategoryMutationResponse>>>;
  updatePartnerData: PartnerId;
  /** update data of the table: "partner_file" */
  updatePartnerFile?: Maybe<PartnerFileMutationResponse>;
  /** update single row of the table: "partner_file" */
  updatePartnerFileByPk?: Maybe<PartnerFile>;
  /** update multiples rows of table: "partner_file" */
  updatePartnerFileMany?: Maybe<Array<Maybe<PartnerFileMutationResponse>>>;
  /** update data of the table: "partner_file_type" */
  updatePartnerFileType?: Maybe<PartnerFileTypeMutationResponse>;
  /** update single row of the table: "partner_file_type" */
  updatePartnerFileTypeByPk?: Maybe<PartnerFileType>;
  /** update multiples rows of table: "partner_file_type" */
  updatePartnerFileTypeMany?: Maybe<Array<Maybe<PartnerFileTypeMutationResponse>>>;
  /** update multiples rows of table: "partner" */
  updatePartnerMany?: Maybe<Array<Maybe<PartnerMutationResponse>>>;
  /** update data of the table: "partner_product" */
  updatePartnerProduct?: Maybe<PartnerProductMutationResponse>;
  /** update single row of the table: "partner_product" */
  updatePartnerProductByPk?: Maybe<PartnerProduct>;
  /** update multiples rows of table: "partner_product" */
  updatePartnerProductMany?: Maybe<Array<Maybe<PartnerProductMutationResponse>>>;
  /** update data of the table: "product" */
  updateProduct?: Maybe<ProductMutationResponse>;
  /** update single row of the table: "product" */
  updateProductByPk?: Maybe<Product>;
  /** update multiples rows of table: "product" */
  updateProductMany?: Maybe<Array<Maybe<ProductMutationResponse>>>;
  /** update data of the table: "promo_code" */
  updatePromoCode?: Maybe<PromoCodeMutationResponse>;
  /** update single row of the table: "promo_code" */
  updatePromoCodeByPk?: Maybe<PromoCode>;
  /** update multiples rows of table: "promo_code" */
  updatePromoCodeMany?: Maybe<Array<Maybe<PromoCodeMutationResponse>>>;
  /** update data of the table: "promo_code_type" */
  updatePromoCodeType?: Maybe<PromoCodeTypeMutationResponse>;
  /** update single row of the table: "promo_code_type" */
  updatePromoCodeTypeByPk?: Maybe<PromoCodeType>;
  /** update multiples rows of table: "promo_code_type" */
  updatePromoCodeTypeMany?: Maybe<Array<Maybe<PromoCodeTypeMutationResponse>>>;
  /** update data of the table: "quotation" */
  updateQuotation?: Maybe<QuotationMutationResponse>;
  /** update single row of the table: "quotation" */
  updateQuotationByPk?: Maybe<Quotation>;
  /** update multiples rows of table: "quotation" */
  updateQuotationMany?: Maybe<Array<Maybe<QuotationMutationResponse>>>;
  /** update data of the table: "quotation_status" */
  updateQuotationStatus?: Maybe<QuotationStatusMutationResponse>;
  /** update single row of the table: "quotation_status" */
  updateQuotationStatusByPk?: Maybe<QuotationStatus>;
  /** update multiples rows of table: "quotation_status" */
  updateQuotationStatusMany?: Maybe<Array<Maybe<QuotationStatusMutationResponse>>>;
  /** update data of the table: "retrocession_type" */
  updateRetrocessionType?: Maybe<RetrocessionTypeMutationResponse>;
  /** update single row of the table: "retrocession_type" */
  updateRetrocessionTypeByPk?: Maybe<RetrocessionType>;
  /** update multiples rows of table: "retrocession_type" */
  updateRetrocessionTypeMany?: Maybe<Array<Maybe<RetrocessionTypeMutationResponse>>>;
  /** update data of the table: "session" */
  updateSession?: Maybe<SessionMutationResponse>;
  /** update single row of the table: "session" */
  updateSessionByPk?: Maybe<Session>;
  /** update multiples rows of table: "session" */
  updateSessionMany?: Maybe<Array<Maybe<SessionMutationResponse>>>;
  /** update data of the table: "user" */
  updateUser?: Maybe<UserMutationResponse>;
  /** update single row of the table: "user" */
  updateUserByPk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  updateUserMany?: Maybe<Array<Maybe<UserMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootApplyQuotationPromoCodeArgs = {
  id: Scalars['uuid'];
  promoCode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCompleteQuotationArgs = {
  quotationId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootCreateContractPeriodArgs = {
  params: CreateContractPeriod;
};


/** mutation root */
export type Mutation_RootCreateContractPeriodDocumentArgs = {
  params: ContractPeriodDocumentInput;
};


/** mutation root */
export type Mutation_RootCreatePartnerArgs = {
  params: PartnerInput;
};


/** mutation root */
export type Mutation_RootCreatePartnerFileArgs = {
  params: PartnerFileInput;
};


/** mutation root */
export type Mutation_RootCreateQuotationArgs = {
  details?: InputMaybe<QuotationDetailsInput>;
  promoCode?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootCreateStripeCustomerPortalSessionArgs = {
  contractId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccessTokenSigningKeyArgs = {
  where: AccessTokenSigningKeyBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccessTokenSigningKeyByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountArgs = {
  where: AccountBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteActivityArgs = {
  where: ActivityBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteActivityByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteActivityCategoryArgs = {
  where: ActivityCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteActivityCategoryByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteActivitySectorArgs = {
  where: ActivitySectorBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteActivitySectorByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  where: AuthProviderBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderByPkArgs = {
  provider: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBrokerArgs = {
  where: BrokerBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBrokerByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractArgs = {
  where: ContractBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractModeArgs = {
  where: ContractModeBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractModeByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodArgs = {
  where: ContractPeriodBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentArgs = {
  where: ContractPeriodDocumentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentByPkArgs = {
  contractPeriodId: Scalars['uuid'];
  fileId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentStatusArgs = {
  where: ContractPeriodDocumentStatusBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentTypeArgs = {
  where: ContractPeriodDocumentTypeBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodDocumentTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodStatusArgs = {
  where: ContractPeriodStatusBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContractPeriodStatusByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCountryArgs = {
  where: CountryBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCountryByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteDbAddressArgs = {
  where: DbAddressBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDbAddressByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  where: FileBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFileByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInsurerArgs = {
  where: InsurerBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInsurerByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOtpArgs = {
  where: OtpBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOtpByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerArgs = {
  where: PartnerBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerCategoryArgs = {
  where: PartnerCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerCategoryByPkArgs = {
  label: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerFileArgs = {
  where: PartnerFileBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerFileByPkArgs = {
  fileId: Scalars['uuid'];
  partnerId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePartnerFileTypeArgs = {
  where: PartnerFileTypeBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerFileTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePartnerProductArgs = {
  where: PartnerProductBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePartnerProductByPkArgs = {
  partnerId: Scalars['uuid'];
  product: ProductEnum;
};


/** mutation root */
export type Mutation_RootDeleteProductArgs = {
  where: ProductBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteProductByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePromoCodeArgs = {
  where: PromoCodeBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePromoCodeByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePromoCodeTypeArgs = {
  where: PromoCodeTypeBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePromoCodeTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteQuotationArgs = {
  where: QuotationBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteQuotationByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQuotationStatusArgs = {
  where: QuotationStatusBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteQuotationStatusByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteRetrocessionTypeArgs = {
  where: RetrocessionTypeBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRetrocessionTypeByPkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteSessionArgs = {
  where: SessionBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSessionByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  where: UserBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootFillQuotationArgs = {
  details?: InputMaybe<QuotationDetailsInput>;
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsertAccessTokenSigningKeyArgs = {
  objects: Array<AccessTokenSigningKeyInsertInput>;
  onConflict?: InputMaybe<AccessTokenSigningKeyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccessTokenSigningKeyOneArgs = {
  object: AccessTokenSigningKeyInsertInput;
  onConflict?: InputMaybe<AccessTokenSigningKeyOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountArgs = {
  objects: Array<AccountInsertInput>;
  onConflict?: InputMaybe<AccountOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountOneArgs = {
  object: AccountInsertInput;
  onConflict?: InputMaybe<AccountOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityArgs = {
  objects: Array<ActivityInsertInput>;
  onConflict?: InputMaybe<ActivityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityCategoryArgs = {
  objects: Array<ActivityCategoryInsertInput>;
  onConflict?: InputMaybe<ActivityCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityCategoryOneArgs = {
  object: ActivityCategoryInsertInput;
  onConflict?: InputMaybe<ActivityCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityOneArgs = {
  object: ActivityInsertInput;
  onConflict?: InputMaybe<ActivityOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivitySectorArgs = {
  objects: Array<ActivitySectorInsertInput>;
  onConflict?: InputMaybe<ActivitySectorOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivitySectorOneArgs = {
  object: ActivitySectorInsertInput;
  onConflict?: InputMaybe<ActivitySectorOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  objects: Array<AuthProviderInsertInput>;
  onConflict?: InputMaybe<AuthProviderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderOneArgs = {
  object: AuthProviderInsertInput;
  onConflict?: InputMaybe<AuthProviderOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBrokerArgs = {
  objects: Array<BrokerInsertInput>;
  onConflict?: InputMaybe<BrokerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBrokerOneArgs = {
  object: BrokerInsertInput;
  onConflict?: InputMaybe<BrokerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractArgs = {
  objects: Array<ContractInsertInput>;
  onConflict?: InputMaybe<ContractOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractModeArgs = {
  objects: Array<ContractModeInsertInput>;
  onConflict?: InputMaybe<ContractModeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractModeOneArgs = {
  object: ContractModeInsertInput;
  onConflict?: InputMaybe<ContractModeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractOneArgs = {
  object: ContractInsertInput;
  onConflict?: InputMaybe<ContractOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodArgs = {
  objects: Array<ContractPeriodInsertInput>;
  onConflict?: InputMaybe<ContractPeriodOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentArgs = {
  objects: Array<ContractPeriodDocumentInsertInput>;
  onConflict?: InputMaybe<ContractPeriodDocumentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentOneArgs = {
  object: ContractPeriodDocumentInsertInput;
  onConflict?: InputMaybe<ContractPeriodDocumentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentStatusArgs = {
  objects: Array<ContractPeriodDocumentStatusInsertInput>;
  onConflict?: InputMaybe<ContractPeriodDocumentStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentStatusOneArgs = {
  object: ContractPeriodDocumentStatusInsertInput;
  onConflict?: InputMaybe<ContractPeriodDocumentStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentTypeArgs = {
  objects: Array<ContractPeriodDocumentTypeInsertInput>;
  onConflict?: InputMaybe<ContractPeriodDocumentTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodDocumentTypeOneArgs = {
  object: ContractPeriodDocumentTypeInsertInput;
  onConflict?: InputMaybe<ContractPeriodDocumentTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodOneArgs = {
  object: ContractPeriodInsertInput;
  onConflict?: InputMaybe<ContractPeriodOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodStatusArgs = {
  objects: Array<ContractPeriodStatusInsertInput>;
  onConflict?: InputMaybe<ContractPeriodStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContractPeriodStatusOneArgs = {
  object: ContractPeriodStatusInsertInput;
  onConflict?: InputMaybe<ContractPeriodStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountryArgs = {
  objects: Array<CountryInsertInput>;
  onConflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountryOneArgs = {
  object: CountryInsertInput;
  onConflict?: InputMaybe<CountryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbAddressArgs = {
  objects: Array<DbAddressInsertInput>;
  onConflict?: InputMaybe<DbAddressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbAddressOneArgs = {
  object: DbAddressInsertInput;
  onConflict?: InputMaybe<DbAddressOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  objects: Array<FileInsertInput>;
  onConflict?: InputMaybe<FileOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileOneArgs = {
  object: FileInsertInput;
  onConflict?: InputMaybe<FileOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInsurerArgs = {
  objects: Array<InsurerInsertInput>;
  onConflict?: InputMaybe<InsurerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInsurerOneArgs = {
  object: InsurerInsertInput;
  onConflict?: InputMaybe<InsurerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOtpArgs = {
  objects: Array<OtpInsertInput>;
  onConflict?: InputMaybe<OtpOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOtpOneArgs = {
  object: OtpInsertInput;
  onConflict?: InputMaybe<OtpOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerArgs = {
  objects: Array<PartnerInsertInput>;
  onConflict?: InputMaybe<PartnerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerCategoryArgs = {
  objects: Array<PartnerCategoryInsertInput>;
  onConflict?: InputMaybe<PartnerCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerCategoryOneArgs = {
  object: PartnerCategoryInsertInput;
  onConflict?: InputMaybe<PartnerCategoryOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerFileArgs = {
  objects: Array<PartnerFileInsertInput>;
  onConflict?: InputMaybe<PartnerFileOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerFileOneArgs = {
  object: PartnerFileInsertInput;
  onConflict?: InputMaybe<PartnerFileOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerFileTypeArgs = {
  objects: Array<PartnerFileTypeInsertInput>;
  onConflict?: InputMaybe<PartnerFileTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerFileTypeOneArgs = {
  object: PartnerFileTypeInsertInput;
  onConflict?: InputMaybe<PartnerFileTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerOneArgs = {
  object: PartnerInsertInput;
  onConflict?: InputMaybe<PartnerOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerProductArgs = {
  objects: Array<PartnerProductInsertInput>;
  onConflict?: InputMaybe<PartnerProductOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPartnerProductOneArgs = {
  object: PartnerProductInsertInput;
  onConflict?: InputMaybe<PartnerProductOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductArgs = {
  objects: Array<ProductInsertInput>;
  onConflict?: InputMaybe<ProductOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductOneArgs = {
  object: ProductInsertInput;
  onConflict?: InputMaybe<ProductOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPromoCodeArgs = {
  objects: Array<PromoCodeInsertInput>;
  onConflict?: InputMaybe<PromoCodeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPromoCodeOneArgs = {
  object: PromoCodeInsertInput;
  onConflict?: InputMaybe<PromoCodeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPromoCodeTypeArgs = {
  objects: Array<PromoCodeTypeInsertInput>;
  onConflict?: InputMaybe<PromoCodeTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPromoCodeTypeOneArgs = {
  object: PromoCodeTypeInsertInput;
  onConflict?: InputMaybe<PromoCodeTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQuotationArgs = {
  objects: Array<QuotationInsertInput>;
  onConflict?: InputMaybe<QuotationOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQuotationOneArgs = {
  object: QuotationInsertInput;
  onConflict?: InputMaybe<QuotationOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQuotationStatusArgs = {
  objects: Array<QuotationStatusInsertInput>;
  onConflict?: InputMaybe<QuotationStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQuotationStatusOneArgs = {
  object: QuotationStatusInsertInput;
  onConflict?: InputMaybe<QuotationStatusOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRetrocessionTypeArgs = {
  objects: Array<RetrocessionTypeInsertInput>;
  onConflict?: InputMaybe<RetrocessionTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRetrocessionTypeOneArgs = {
  object: RetrocessionTypeInsertInput;
  onConflict?: InputMaybe<RetrocessionTypeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSessionArgs = {
  objects: Array<SessionInsertInput>;
  onConflict?: InputMaybe<SessionOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSessionOneArgs = {
  object: SessionInsertInput;
  onConflict?: InputMaybe<SessionOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  objects: Array<UserInsertInput>;
  onConflict?: InputMaybe<UserOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserOneArgs = {
  object: UserInsertInput;
  onConflict?: InputMaybe<UserOnConflict>;
};


/** mutation root */
export type Mutation_RootRefreshAccessTokenArgs = {
  refreshToken: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRegisterPaymentMethodArgs = {
  quotationId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootRemoveQuotationPromoCodeArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootSendSignInOtpArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSignInWithOtpArgs = {
  deviceId: Scalars['String'];
  email: Scalars['String'];
  otp: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSignUpArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  userTypeName: UserTypeEnum;
};


/** mutation root */
export type Mutation_RootUpdateAccessTokenSigningKeyArgs = {
  _set?: InputMaybe<AccessTokenSigningKeySetInput>;
  where: AccessTokenSigningKeyBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccessTokenSigningKeyByPkArgs = {
  _set?: InputMaybe<AccessTokenSigningKeySetInput>;
  pkColumns: AccessTokenSigningKeyPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccessTokenSigningKeyManyArgs = {
  updates: Array<AccessTokenSigningKeyUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountArgs = {
  _set?: InputMaybe<AccountSetInput>;
  where: AccountBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountByPkArgs = {
  _set?: InputMaybe<AccountSetInput>;
  pkColumns: AccountPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountManyArgs = {
  updates: Array<AccountUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateActivityArgs = {
  _inc?: InputMaybe<ActivityIncInput>;
  _set?: InputMaybe<ActivitySetInput>;
  where: ActivityBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateActivityByPkArgs = {
  _inc?: InputMaybe<ActivityIncInput>;
  _set?: InputMaybe<ActivitySetInput>;
  pkColumns: ActivityPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateActivityCategoryArgs = {
  _inc?: InputMaybe<ActivityCategoryIncInput>;
  _set?: InputMaybe<ActivityCategorySetInput>;
  where: ActivityCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateActivityCategoryByPkArgs = {
  _inc?: InputMaybe<ActivityCategoryIncInput>;
  _set?: InputMaybe<ActivityCategorySetInput>;
  pkColumns: ActivityCategoryPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateActivityCategoryManyArgs = {
  updates: Array<ActivityCategoryUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateActivityManyArgs = {
  updates: Array<ActivityUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateActivitySectorArgs = {
  _inc?: InputMaybe<ActivitySectorIncInput>;
  _set?: InputMaybe<ActivitySectorSetInput>;
  where: ActivitySectorBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateActivitySectorByPkArgs = {
  _inc?: InputMaybe<ActivitySectorIncInput>;
  _set?: InputMaybe<ActivitySectorSetInput>;
  pkColumns: ActivitySectorPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateActivitySectorManyArgs = {
  updates: Array<ActivitySectorUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviderSetInput>;
  where: AuthProviderBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderByPkArgs = {
  _set?: InputMaybe<AuthProviderSetInput>;
  pkColumns: AuthProviderPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderManyArgs = {
  updates: Array<AuthProviderUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBrokerArgs = {
  _set?: InputMaybe<BrokerSetInput>;
  where: BrokerBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBrokerByPkArgs = {
  _set?: InputMaybe<BrokerSetInput>;
  pkColumns: BrokerPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBrokerManyArgs = {
  updates: Array<BrokerUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractArgs = {
  _set?: InputMaybe<ContractSetInput>;
  where: ContractBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractByPkArgs = {
  _set?: InputMaybe<ContractSetInput>;
  pkColumns: ContractPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractManyArgs = {
  updates: Array<ContractUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractModeArgs = {
  _set?: InputMaybe<ContractModeSetInput>;
  where: ContractModeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractModeByPkArgs = {
  _set?: InputMaybe<ContractModeSetInput>;
  pkColumns: ContractModePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractModeManyArgs = {
  updates: Array<ContractModeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodArgs = {
  _append?: InputMaybe<ContractPeriodAppendInput>;
  _deleteAtPath?: InputMaybe<ContractPeriodDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ContractPeriodDeleteElemInput>;
  _deleteKey?: InputMaybe<ContractPeriodDeleteKeyInput>;
  _inc?: InputMaybe<ContractPeriodIncInput>;
  _prepend?: InputMaybe<ContractPeriodPrependInput>;
  _set?: InputMaybe<ContractPeriodSetInput>;
  where: ContractPeriodBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodByPkArgs = {
  _append?: InputMaybe<ContractPeriodAppendInput>;
  _deleteAtPath?: InputMaybe<ContractPeriodDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ContractPeriodDeleteElemInput>;
  _deleteKey?: InputMaybe<ContractPeriodDeleteKeyInput>;
  _inc?: InputMaybe<ContractPeriodIncInput>;
  _prepend?: InputMaybe<ContractPeriodPrependInput>;
  _set?: InputMaybe<ContractPeriodSetInput>;
  pkColumns: ContractPeriodPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentArgs = {
  _set?: InputMaybe<ContractPeriodDocumentSetInput>;
  where: ContractPeriodDocumentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentByPkArgs = {
  _set?: InputMaybe<ContractPeriodDocumentSetInput>;
  pkColumns: ContractPeriodDocumentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentManyArgs = {
  updates: Array<ContractPeriodDocumentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentStatusArgs = {
  _set?: InputMaybe<ContractPeriodDocumentStatusSetInput>;
  where: ContractPeriodDocumentStatusBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentStatusByPkArgs = {
  _set?: InputMaybe<ContractPeriodDocumentStatusSetInput>;
  pkColumns: ContractPeriodDocumentStatusPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentStatusManyArgs = {
  updates: Array<ContractPeriodDocumentStatusUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentTypeArgs = {
  _set?: InputMaybe<ContractPeriodDocumentTypeSetInput>;
  where: ContractPeriodDocumentTypeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentTypeByPkArgs = {
  _set?: InputMaybe<ContractPeriodDocumentTypeSetInput>;
  pkColumns: ContractPeriodDocumentTypePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodDocumentTypeManyArgs = {
  updates: Array<ContractPeriodDocumentTypeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodManyArgs = {
  updates: Array<ContractPeriodUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodStatusArgs = {
  _set?: InputMaybe<ContractPeriodStatusSetInput>;
  where: ContractPeriodStatusBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodStatusByPkArgs = {
  _set?: InputMaybe<ContractPeriodStatusSetInput>;
  pkColumns: ContractPeriodStatusPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContractPeriodStatusManyArgs = {
  updates: Array<ContractPeriodStatusUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCountryArgs = {
  _set?: InputMaybe<CountrySetInput>;
  where: CountryBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCountryByPkArgs = {
  _set?: InputMaybe<CountrySetInput>;
  pkColumns: CountryPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCountryManyArgs = {
  updates: Array<CountryUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDbAddressArgs = {
  _set?: InputMaybe<DbAddressSetInput>;
  where: DbAddressBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDbAddressByPkArgs = {
  _set?: InputMaybe<DbAddressSetInput>;
  pkColumns: DbAddressPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDbAddressManyArgs = {
  updates: Array<DbAddressUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _set?: InputMaybe<FileSetInput>;
  where: FileBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFileByPkArgs = {
  _set?: InputMaybe<FileSetInput>;
  pkColumns: FilePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFileManyArgs = {
  updates: Array<FileUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInsurerArgs = {
  _set?: InputMaybe<InsurerSetInput>;
  where: InsurerBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInsurerByPkArgs = {
  _set?: InputMaybe<InsurerSetInput>;
  pkColumns: InsurerPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInsurerManyArgs = {
  updates: Array<InsurerUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOtpArgs = {
  _inc?: InputMaybe<OtpIncInput>;
  _set?: InputMaybe<OtpSetInput>;
  where: OtpBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOtpByPkArgs = {
  _inc?: InputMaybe<OtpIncInput>;
  _set?: InputMaybe<OtpSetInput>;
  pkColumns: OtpPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOtpManyArgs = {
  updates: Array<OtpUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerArgs = {
  _set?: InputMaybe<PartnerSetInput>;
  where: PartnerBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerByPkArgs = {
  _set?: InputMaybe<PartnerSetInput>;
  pkColumns: PartnerPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerCategoryArgs = {
  _set?: InputMaybe<PartnerCategorySetInput>;
  where: PartnerCategoryBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerCategoryByPkArgs = {
  _set?: InputMaybe<PartnerCategorySetInput>;
  pkColumns: PartnerCategoryPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerCategoryManyArgs = {
  updates: Array<PartnerCategoryUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerDataArgs = {
  id: Scalars['String'];
  params: PartnerInputUpdate;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileArgs = {
  _set?: InputMaybe<PartnerFileSetInput>;
  where: PartnerFileBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileByPkArgs = {
  _set?: InputMaybe<PartnerFileSetInput>;
  pkColumns: PartnerFilePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileManyArgs = {
  updates: Array<PartnerFileUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileTypeArgs = {
  _set?: InputMaybe<PartnerFileTypeSetInput>;
  where: PartnerFileTypeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileTypeByPkArgs = {
  _set?: InputMaybe<PartnerFileTypeSetInput>;
  pkColumns: PartnerFileTypePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerFileTypeManyArgs = {
  updates: Array<PartnerFileTypeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerManyArgs = {
  updates: Array<PartnerUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePartnerProductArgs = {
  _inc?: InputMaybe<PartnerProductIncInput>;
  _set?: InputMaybe<PartnerProductSetInput>;
  where: PartnerProductBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePartnerProductByPkArgs = {
  _inc?: InputMaybe<PartnerProductIncInput>;
  _set?: InputMaybe<PartnerProductSetInput>;
  pkColumns: PartnerProductPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePartnerProductManyArgs = {
  updates: Array<PartnerProductUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateProductArgs = {
  _set?: InputMaybe<ProductSetInput>;
  where: ProductBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateProductByPkArgs = {
  _set?: InputMaybe<ProductSetInput>;
  pkColumns: ProductPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateProductManyArgs = {
  updates: Array<ProductUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeArgs = {
  _inc?: InputMaybe<PromoCodeIncInput>;
  _set?: InputMaybe<PromoCodeSetInput>;
  where: PromoCodeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeByPkArgs = {
  _inc?: InputMaybe<PromoCodeIncInput>;
  _set?: InputMaybe<PromoCodeSetInput>;
  pkColumns: PromoCodePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeManyArgs = {
  updates: Array<PromoCodeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeTypeArgs = {
  _set?: InputMaybe<PromoCodeTypeSetInput>;
  where: PromoCodeTypeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeTypeByPkArgs = {
  _set?: InputMaybe<PromoCodeTypeSetInput>;
  pkColumns: PromoCodeTypePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePromoCodeTypeManyArgs = {
  updates: Array<PromoCodeTypeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateQuotationArgs = {
  _append?: InputMaybe<QuotationAppendInput>;
  _deleteAtPath?: InputMaybe<QuotationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<QuotationDeleteElemInput>;
  _deleteKey?: InputMaybe<QuotationDeleteKeyInput>;
  _prepend?: InputMaybe<QuotationPrependInput>;
  _set?: InputMaybe<QuotationSetInput>;
  where: QuotationBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateQuotationByPkArgs = {
  _append?: InputMaybe<QuotationAppendInput>;
  _deleteAtPath?: InputMaybe<QuotationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<QuotationDeleteElemInput>;
  _deleteKey?: InputMaybe<QuotationDeleteKeyInput>;
  _prepend?: InputMaybe<QuotationPrependInput>;
  _set?: InputMaybe<QuotationSetInput>;
  pkColumns: QuotationPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateQuotationManyArgs = {
  updates: Array<QuotationUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateQuotationStatusArgs = {
  _set?: InputMaybe<QuotationStatusSetInput>;
  where: QuotationStatusBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateQuotationStatusByPkArgs = {
  _set?: InputMaybe<QuotationStatusSetInput>;
  pkColumns: QuotationStatusPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateQuotationStatusManyArgs = {
  updates: Array<QuotationStatusUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRetrocessionTypeArgs = {
  _set?: InputMaybe<RetrocessionTypeSetInput>;
  where: RetrocessionTypeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRetrocessionTypeByPkArgs = {
  _set?: InputMaybe<RetrocessionTypeSetInput>;
  pkColumns: RetrocessionTypePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRetrocessionTypeManyArgs = {
  updates: Array<RetrocessionTypeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSessionArgs = {
  _set?: InputMaybe<SessionSetInput>;
  where: SessionBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSessionByPkArgs = {
  _set?: InputMaybe<SessionSetInput>;
  pkColumns: SessionPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSessionManyArgs = {
  updates: Array<SessionUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _set?: InputMaybe<UserSetInput>;
  where: UserBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserByPkArgs = {
  _set?: InputMaybe<UserSetInput>;
  pkColumns: UserPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserManyArgs = {
  updates: Array<UserUpdates>;
};

export type OtpAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OtpSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OtpBoolExp>;
  predicate: IntComparisonExp;
};

export type PartnerAggregateBoolExpBool_And = {
  arguments: PartnerSelectColumnPartnerAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PartnerAggregateBoolExpBool_Or = {
  arguments: PartnerSelectColumnPartnerAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PartnerAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PartnerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerBoolExp>;
  predicate: IntComparisonExp;
};

export type PartnerFileAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PartnerFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerFileBoolExp>;
  predicate: IntComparisonExp;
};

export type PartnerProductAggregateBoolExpAvg = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpBool_And = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PartnerProductAggregateBoolExpBool_Or = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PartnerProductAggregateBoolExpCorr = {
  arguments: PartnerProductAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpCorrArguments = {
  X: PartnerProductSelectColumnPartnerProductAggregateBoolExpCorrArgumentsColumns;
  Y: PartnerProductSelectColumnPartnerProductAggregateBoolExpCorrArgumentsColumns;
};

export type PartnerProductAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PartnerProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: IntComparisonExp;
};

export type PartnerProductAggregateBoolExpCovar_Samp = {
  arguments: PartnerProductAggregateBoolExpCovar_SampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpCovar_SampArguments = {
  X: PartnerProductSelectColumnPartnerProductAggregateBoolExpCovar_SampArgumentsColumns;
  Y: PartnerProductSelectColumnPartnerProductAggregateBoolExpCovar_SampArgumentsColumns;
};

export type PartnerProductAggregateBoolExpMax = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpMin = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpStddev_Samp = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpStddev_SampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpSum = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PartnerProductAggregateBoolExpVar_Samp = {
  arguments: PartnerProductSelectColumnPartnerProductAggregateBoolExpVar_SampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PartnerProductBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpAvg = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpCorr = {
  arguments: PromoCodeAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpCorrArguments = {
  X: PromoCodeSelectColumnPromoCodeAggregateBoolExpCorrArgumentsColumns;
  Y: PromoCodeSelectColumnPromoCodeAggregateBoolExpCorrArgumentsColumns;
};

export type PromoCodeAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PromoCodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: IntComparisonExp;
};

export type PromoCodeAggregateBoolExpCovar_Samp = {
  arguments: PromoCodeAggregateBoolExpCovar_SampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpCovar_SampArguments = {
  X: PromoCodeSelectColumnPromoCodeAggregateBoolExpCovar_SampArgumentsColumns;
  Y: PromoCodeSelectColumnPromoCodeAggregateBoolExpCovar_SampArgumentsColumns;
};

export type PromoCodeAggregateBoolExpMax = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpMin = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpStddev_Samp = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpStddev_SampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpSum = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type PromoCodeAggregateBoolExpVar_Samp = {
  arguments: PromoCodeSelectColumnPromoCodeAggregateBoolExpVar_SampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PromoCodeBoolExp>;
  predicate: Float8ComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "access_token_signing_key" */
  accessTokenSigningKey: Array<AccessTokenSigningKey>;
  /** fetch aggregated fields from the table: "access_token_signing_key" */
  accessTokenSigningKeyAggregate: AccessTokenSigningKeyAggregate;
  /** fetch data from the table: "access_token_signing_key" using primary key columns */
  accessTokenSigningKeyByPk?: Maybe<AccessTokenSigningKey>;
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  accountAggregate: AccountAggregate;
  /** fetch data from the table: "account" using primary key columns */
  accountByPk?: Maybe<Account>;
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activityAggregate: ActivityAggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activityByPk?: Maybe<Activity>;
  /** fetch data from the table: "activity_category" */
  activityCategory: Array<ActivityCategory>;
  /** fetch aggregated fields from the table: "activity_category" */
  activityCategoryAggregate: ActivityCategoryAggregate;
  /** fetch data from the table: "activity_category" using primary key columns */
  activityCategoryByPk?: Maybe<ActivityCategory>;
  /** fetch data from the table: "activity_sector" */
  activitySector: Array<ActivitySector>;
  /** fetch aggregated fields from the table: "activity_sector" */
  activitySectorAggregate: ActivitySectorAggregate;
  /** fetch data from the table: "activity_sector" using primary key columns */
  activitySectorByPk?: Maybe<ActivitySector>;
  /** fetch data from the table: "auth_provider" */
  authProvider: Array<AuthProvider>;
  /** fetch aggregated fields from the table: "auth_provider" */
  authProviderAggregate: AuthProviderAggregate;
  /** fetch data from the table: "auth_provider" using primary key columns */
  authProviderByPk?: Maybe<AuthProvider>;
  /** fetch data from the table: "broker" */
  broker: Array<Broker>;
  /** fetch aggregated fields from the table: "broker" */
  brokerAggregate: BrokerAggregate;
  /** fetch data from the table: "broker" using primary key columns */
  brokerByPk?: Maybe<Broker>;
  checkIfUserEmailExists: Scalars['Boolean'];
  companyAutocomplete?: Maybe<Array<CompanySuggestion>>;
  /** fetch data from the table: "contract" */
  contract: Array<Contract>;
  /** fetch aggregated fields from the table: "contract" */
  contractAggregate: ContractAggregate;
  /** fetch data from the table: "contract" using primary key columns */
  contractByPk?: Maybe<Contract>;
  contractDetails?: Maybe<ContractDetails>;
  /** fetch data from the table: "contract_mode" */
  contractMode: Array<ContractMode>;
  /** fetch aggregated fields from the table: "contract_mode" */
  contractModeAggregate: ContractModeAggregate;
  /** fetch data from the table: "contract_mode" using primary key columns */
  contractModeByPk?: Maybe<ContractMode>;
  /** fetch data from the table: "contract_period" */
  contractPeriod: Array<ContractPeriod>;
  /** fetch aggregated fields from the table: "contract_period" */
  contractPeriodAggregate: ContractPeriodAggregate;
  /** fetch data from the table: "contract_period" using primary key columns */
  contractPeriodByPk?: Maybe<ContractPeriod>;
  /** fetch data from the table: "contract_period_document" */
  contractPeriodDocument: Array<ContractPeriodDocument>;
  /** fetch aggregated fields from the table: "contract_period_document" */
  contractPeriodDocumentAggregate: ContractPeriodDocumentAggregate;
  /** fetch data from the table: "contract_period_document" using primary key columns */
  contractPeriodDocumentByPk?: Maybe<ContractPeriodDocument>;
  contractPeriodDocumentSignatureLink?: Maybe<Scalars['String']>;
  /** fetch data from the table: "contract_period_document_status" */
  contractPeriodDocumentStatus: Array<ContractPeriodDocumentStatus>;
  /** fetch aggregated fields from the table: "contract_period_document_status" */
  contractPeriodDocumentStatusAggregate: ContractPeriodDocumentStatusAggregate;
  /** fetch data from the table: "contract_period_document_status" using primary key columns */
  contractPeriodDocumentStatusByPk?: Maybe<ContractPeriodDocumentStatus>;
  /** fetch data from the table: "contract_period_document_type" */
  contractPeriodDocumentType: Array<ContractPeriodDocumentType>;
  /** fetch aggregated fields from the table: "contract_period_document_type" */
  contractPeriodDocumentTypeAggregate: ContractPeriodDocumentTypeAggregate;
  /** fetch data from the table: "contract_period_document_type" using primary key columns */
  contractPeriodDocumentTypeByPk?: Maybe<ContractPeriodDocumentType>;
  /** fetch data from the table: "contract_period_status" */
  contractPeriodStatus: Array<ContractPeriodStatus>;
  /** fetch aggregated fields from the table: "contract_period_status" */
  contractPeriodStatusAggregate: ContractPeriodStatusAggregate;
  /** fetch data from the table: "contract_period_status" using primary key columns */
  contractPeriodStatusByPk?: Maybe<ContractPeriodStatus>;
  contractPremium: ContractPremium;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  countryAggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  countryByPk?: Maybe<Country>;
  createDealActiveCampaign?: Maybe<DealCreate>;
  /** fetch data from the table: "db_address" */
  dbAddress: Array<DbAddress>;
  /** fetch aggregated fields from the table: "db_address" */
  dbAddressAggregate: DbAddressAggregate;
  /** fetch data from the table: "db_address" using primary key columns */
  dbAddressByPk?: Maybe<DbAddress>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  fileAggregate: FileAggregate;
  /** fetch data from the table: "file" using primary key columns */
  fileByPk?: Maybe<File>;
  getContractDocument: Scalars['base64'];
  getFileURL: Scalars['String'];
  getQuotationDocument: Scalars['base64'];
  getSignatureLinkForQuotation?: Maybe<Scalars['String']>;
  /** fetch data from the table: "insurer" */
  insurer: Array<Insurer>;
  /** fetch aggregated fields from the table: "insurer" */
  insurerAggregate: InsurerAggregate;
  /** fetch data from the table: "insurer" using primary key columns */
  insurerByPk?: Maybe<Insurer>;
  listQuotations: Array<QuotationId>;
  me?: Maybe<UserId>;
  /** fetch data from the table: "otp" */
  otp: Array<Otp>;
  /** fetch aggregated fields from the table: "otp" */
  otpAggregate: OtpAggregate;
  /** fetch data from the table: "otp" using primary key columns */
  otpByPk?: Maybe<Otp>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch aggregated fields from the table: "partner" */
  partnerAggregate: PartnerAggregate;
  /** fetch data from the table: "partner" using primary key columns */
  partnerByPk?: Maybe<Partner>;
  /** fetch data from the table: "partner_category" */
  partnerCategory: Array<PartnerCategory>;
  /** fetch aggregated fields from the table: "partner_category" */
  partnerCategoryAggregate: PartnerCategoryAggregate;
  /** fetch data from the table: "partner_category" using primary key columns */
  partnerCategoryByPk?: Maybe<PartnerCategory>;
  /** fetch data from the table: "partner_file" */
  partnerFile: Array<PartnerFile>;
  /** fetch aggregated fields from the table: "partner_file" */
  partnerFileAggregate: PartnerFileAggregate;
  /** fetch data from the table: "partner_file" using primary key columns */
  partnerFileByPk?: Maybe<PartnerFile>;
  /** fetch data from the table: "partner_file_type" */
  partnerFileType: Array<PartnerFileType>;
  /** fetch aggregated fields from the table: "partner_file_type" */
  partnerFileTypeAggregate: PartnerFileTypeAggregate;
  /** fetch data from the table: "partner_file_type" using primary key columns */
  partnerFileTypeByPk?: Maybe<PartnerFileType>;
  /** fetch data from the table: "partner_product" */
  partnerProduct: Array<PartnerProduct>;
  /** fetch aggregated fields from the table: "partner_product" */
  partnerProductAggregate: PartnerProductAggregate;
  /** fetch data from the table: "partner_product" using primary key columns */
  partnerProductByPk?: Maybe<PartnerProduct>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  productAggregate: ProductAggregate;
  /** fetch data from the table: "product" using primary key columns */
  productByPk?: Maybe<Product>;
  /** fetch data from the table: "promo_code" */
  promoCode: Array<PromoCode>;
  /** fetch aggregated fields from the table: "promo_code" */
  promoCodeAggregate: PromoCodeAggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promoCodeByPk?: Maybe<PromoCode>;
  /** fetch data from the table: "promo_code_type" */
  promoCodeType: Array<PromoCodeType>;
  /** fetch aggregated fields from the table: "promo_code_type" */
  promoCodeTypeAggregate: PromoCodeTypeAggregate;
  /** fetch data from the table: "promo_code_type" using primary key columns */
  promoCodeTypeByPk?: Maybe<PromoCodeType>;
  /** fetch data from the table: "quotation" */
  quotation: Array<Quotation>;
  /** fetch aggregated fields from the table: "quotation" */
  quotationAggregate: QuotationAggregate;
  /** fetch data from the table: "quotation" using primary key columns */
  quotationByPk?: Maybe<Quotation>;
  quotationCovers?: Maybe<QuotationCovers>;
  quotationDetails: QuotationDetails;
  quotationPremium?: Maybe<QuotationPrice>;
  /** fetch data from the table: "quotation_status" */
  quotationStatus: Array<QuotationStatus>;
  /** fetch aggregated fields from the table: "quotation_status" */
  quotationStatusAggregate: QuotationStatusAggregate;
  /** fetch data from the table: "quotation_status" using primary key columns */
  quotationStatusByPk?: Maybe<QuotationStatus>;
  /** fetch data from the table: "retrocession_type" */
  retrocessionType: Array<RetrocessionType>;
  /** fetch aggregated fields from the table: "retrocession_type" */
  retrocessionTypeAggregate: RetrocessionTypeAggregate;
  /** fetch data from the table: "retrocession_type" using primary key columns */
  retrocessionTypeByPk?: Maybe<RetrocessionType>;
  searchActivities: Array<ActivityResult>;
  /** fetch data from the table: "session" */
  session: Array<Session>;
  /** fetch aggregated fields from the table: "session" */
  sessionAggregate: SessionAggregate;
  /** fetch data from the table: "session" using primary key columns */
  sessionByPk?: Maybe<Session>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  userAggregate: UserAggregate;
  /** fetch data from the table: "user" using primary key columns */
  userByPk?: Maybe<User>;
};


export type Query_RootAccessTokenSigningKeyArgs = {
  distinctOn?: InputMaybe<Array<AccessTokenSigningKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccessTokenSigningKeyOrderBy>>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};


export type Query_RootAccessTokenSigningKeyAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccessTokenSigningKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccessTokenSigningKeyOrderBy>>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};


export type Query_RootAccessTokenSigningKeyByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAccountArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


export type Query_RootAccountAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


export type Query_RootAccountByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootActivityArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};


export type Query_RootActivityAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};


export type Query_RootActivityByPkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActivityCategoryArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


export type Query_RootActivityCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


export type Query_RootActivityCategoryByPkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActivitySectorArgs = {
  distinctOn?: InputMaybe<Array<ActivitySectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivitySectorOrderBy>>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};


export type Query_RootActivitySectorAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitySectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivitySectorOrderBy>>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};


export type Query_RootActivitySectorByPkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuthProviderArgs = {
  distinctOn?: InputMaybe<Array<AuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthProviderOrderBy>>;
  where?: InputMaybe<AuthProviderBoolExp>;
};


export type Query_RootAuthProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<AuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthProviderOrderBy>>;
  where?: InputMaybe<AuthProviderBoolExp>;
};


export type Query_RootAuthProviderByPkArgs = {
  provider: Scalars['String'];
};


export type Query_RootBrokerArgs = {
  distinctOn?: InputMaybe<Array<BrokerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BrokerOrderBy>>;
  where?: InputMaybe<BrokerBoolExp>;
};


export type Query_RootBrokerAggregateArgs = {
  distinctOn?: InputMaybe<Array<BrokerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BrokerOrderBy>>;
  where?: InputMaybe<BrokerBoolExp>;
};


export type Query_RootBrokerByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCheckIfUserEmailExistsArgs = {
  email: Scalars['String'];
};


export type Query_RootCompanyAutocompleteArgs = {
  query: Scalars['String'];
};


export type Query_RootContractArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


export type Query_RootContractAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


export type Query_RootContractByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractDetailsArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractModeArgs = {
  distinctOn?: InputMaybe<Array<ContractModeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractModeOrderBy>>;
  where?: InputMaybe<ContractModeBoolExp>;
};


export type Query_RootContractModeAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractModeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractModeOrderBy>>;
  where?: InputMaybe<ContractModeBoolExp>;
};


export type Query_RootContractModeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootContractPeriodArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


export type Query_RootContractPeriodAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


export type Query_RootContractPeriodByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractPeriodDocumentArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


export type Query_RootContractPeriodDocumentAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


export type Query_RootContractPeriodDocumentByPkArgs = {
  contractPeriodId: Scalars['uuid'];
  fileId: Scalars['uuid'];
};


export type Query_RootContractPeriodDocumentSignatureLinkArgs = {
  yousignSignatureRequestId?: InputMaybe<Scalars['String']>;
};


export type Query_RootContractPeriodDocumentStatusArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};


export type Query_RootContractPeriodDocumentStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};


export type Query_RootContractPeriodDocumentStatusByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootContractPeriodDocumentTypeArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentTypeOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};


export type Query_RootContractPeriodDocumentTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentTypeOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};


export type Query_RootContractPeriodDocumentTypeByPkArgs = {
  type: Scalars['String'];
};


export type Query_RootContractPeriodStatusArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};


export type Query_RootContractPeriodStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};


export type Query_RootContractPeriodStatusByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootContractPremiumArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCountryArgs = {
  distinctOn?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type Query_RootCountryAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type Query_RootCountryByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootCreateDealActiveCampaignArgs = {
  query?: InputMaybe<DealCreateInput>;
};


export type Query_RootDbAddressArgs = {
  distinctOn?: InputMaybe<Array<DbAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DbAddressOrderBy>>;
  where?: InputMaybe<DbAddressBoolExp>;
};


export type Query_RootDbAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DbAddressOrderBy>>;
  where?: InputMaybe<DbAddressBoolExp>;
};


export type Query_RootDbAddressByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFileArgs = {
  distinctOn?: InputMaybe<Array<FileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileOrderBy>>;
  where?: InputMaybe<FileBoolExp>;
};


export type Query_RootFileAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileOrderBy>>;
  where?: InputMaybe<FileBoolExp>;
};


export type Query_RootFileByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGetContractDocumentArgs = {
  contractPeriodId: Scalars['uuid'];
  document: ContractDocument;
};


export type Query_RootGetFileUrlArgs = {
  fileId: Scalars['uuid'];
};


export type Query_RootGetQuotationDocumentArgs = {
  document: QuotationDocument;
  product: ProductEnum;
  quotationId: Scalars['uuid'];
};


export type Query_RootGetSignatureLinkForQuotationArgs = {
  quotationId: Scalars['uuid'];
};


export type Query_RootInsurerArgs = {
  distinctOn?: InputMaybe<Array<InsurerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsurerOrderBy>>;
  where?: InputMaybe<InsurerBoolExp>;
};


export type Query_RootInsurerAggregateArgs = {
  distinctOn?: InputMaybe<Array<InsurerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsurerOrderBy>>;
  where?: InputMaybe<InsurerBoolExp>;
};


export type Query_RootInsurerByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOtpArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


export type Query_RootOtpAggregateArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


export type Query_RootOtpByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};


export type Query_RootPartnerAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};


export type Query_RootPartnerByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerCategoryArgs = {
  distinctOn?: InputMaybe<Array<PartnerCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerCategoryOrderBy>>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};


export type Query_RootPartnerCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerCategoryOrderBy>>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};


export type Query_RootPartnerCategoryByPkArgs = {
  label: Scalars['String'];
};


export type Query_RootPartnerFileArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


export type Query_RootPartnerFileAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


export type Query_RootPartnerFileByPkArgs = {
  fileId: Scalars['uuid'];
  partnerId: Scalars['uuid'];
};


export type Query_RootPartnerFileTypeArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileTypeOrderBy>>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};


export type Query_RootPartnerFileTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileTypeOrderBy>>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};


export type Query_RootPartnerFileTypeByPkArgs = {
  type: Scalars['String'];
};


export type Query_RootPartnerProductArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


export type Query_RootPartnerProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


export type Query_RootPartnerProductByPkArgs = {
  partnerId: Scalars['uuid'];
  product: ProductEnum;
};


export type Query_RootProductArgs = {
  distinctOn?: InputMaybe<Array<ProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductOrderBy>>;
  where?: InputMaybe<ProductBoolExp>;
};


export type Query_RootProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductOrderBy>>;
  where?: InputMaybe<ProductBoolExp>;
};


export type Query_RootProductByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootPromoCodeArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


export type Query_RootPromoCodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


export type Query_RootPromoCodeByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPromoCodeTypeArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeTypeOrderBy>>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};


export type Query_RootPromoCodeTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeTypeOrderBy>>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};


export type Query_RootPromoCodeTypeByPkArgs = {
  type: Scalars['String'];
};


export type Query_RootQuotationArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};


export type Query_RootQuotationAggregateArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};


export type Query_RootQuotationByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuotationCoversArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuotationDetailsArgs = {
  dbDetails: Scalars['jsonb'];
};


export type Query_RootQuotationPremiumArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuotationStatusArgs = {
  distinctOn?: InputMaybe<Array<QuotationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationStatusOrderBy>>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};


export type Query_RootQuotationStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<QuotationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationStatusOrderBy>>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};


export type Query_RootQuotationStatusByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootRetrocessionTypeArgs = {
  distinctOn?: InputMaybe<Array<RetrocessionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RetrocessionTypeOrderBy>>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};


export type Query_RootRetrocessionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RetrocessionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RetrocessionTypeOrderBy>>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};


export type Query_RootRetrocessionTypeByPkArgs = {
  type: Scalars['String'];
};


export type Query_RootSearchActivitiesArgs = {
  product: ProductEnum;
  query: Scalars['String'];
};


export type Query_RootSessionArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};


export type Query_RootSessionAggregateArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};


export type Query_RootSessionByPkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserArgs = {
  distinctOn?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type Query_RootUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type Query_RootUserByPkArgs = {
  id: Scalars['uuid'];
};

export type QuotationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<QuotationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<QuotationBoolExp>;
  predicate: IntComparisonExp;
};

export type RetrocessionInput = {
  displayDuringQuotation: Scalars['Boolean'];
  product: ProductEnum;
  value: Scalars['Float'];
};

export type SessionAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SessionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SessionBoolExp>;
  predicate: IntComparisonExp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "access_token_signing_key" */
  accessTokenSigningKey: Array<AccessTokenSigningKey>;
  /** fetch aggregated fields from the table: "access_token_signing_key" */
  accessTokenSigningKeyAggregate: AccessTokenSigningKeyAggregate;
  /** fetch data from the table: "access_token_signing_key" using primary key columns */
  accessTokenSigningKeyByPk?: Maybe<AccessTokenSigningKey>;
  /** fetch data from the table in a streaming manner: "access_token_signing_key" */
  accessTokenSigningKeyStream: Array<AccessTokenSigningKey>;
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  accountAggregate: AccountAggregate;
  /** fetch data from the table: "account" using primary key columns */
  accountByPk?: Maybe<Account>;
  /** fetch data from the table in a streaming manner: "account" */
  accountStream: Array<Account>;
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activityAggregate: ActivityAggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activityByPk?: Maybe<Activity>;
  /** fetch data from the table: "activity_category" */
  activityCategory: Array<ActivityCategory>;
  /** fetch aggregated fields from the table: "activity_category" */
  activityCategoryAggregate: ActivityCategoryAggregate;
  /** fetch data from the table: "activity_category" using primary key columns */
  activityCategoryByPk?: Maybe<ActivityCategory>;
  /** fetch data from the table in a streaming manner: "activity_category" */
  activityCategoryStream: Array<ActivityCategory>;
  /** fetch data from the table: "activity_sector" */
  activitySector: Array<ActivitySector>;
  /** fetch aggregated fields from the table: "activity_sector" */
  activitySectorAggregate: ActivitySectorAggregate;
  /** fetch data from the table: "activity_sector" using primary key columns */
  activitySectorByPk?: Maybe<ActivitySector>;
  /** fetch data from the table in a streaming manner: "activity_sector" */
  activitySectorStream: Array<ActivitySector>;
  /** fetch data from the table in a streaming manner: "activity" */
  activityStream: Array<Activity>;
  /** fetch data from the table: "auth_provider" */
  authProvider: Array<AuthProvider>;
  /** fetch aggregated fields from the table: "auth_provider" */
  authProviderAggregate: AuthProviderAggregate;
  /** fetch data from the table: "auth_provider" using primary key columns */
  authProviderByPk?: Maybe<AuthProvider>;
  /** fetch data from the table in a streaming manner: "auth_provider" */
  authProviderStream: Array<AuthProvider>;
  /** fetch data from the table: "broker" */
  broker: Array<Broker>;
  /** fetch aggregated fields from the table: "broker" */
  brokerAggregate: BrokerAggregate;
  /** fetch data from the table: "broker" using primary key columns */
  brokerByPk?: Maybe<Broker>;
  /** fetch data from the table in a streaming manner: "broker" */
  brokerStream: Array<Broker>;
  /** fetch data from the table: "contract" */
  contract: Array<Contract>;
  /** fetch aggregated fields from the table: "contract" */
  contractAggregate: ContractAggregate;
  /** fetch data from the table: "contract" using primary key columns */
  contractByPk?: Maybe<Contract>;
  /** fetch data from the table: "contract_mode" */
  contractMode: Array<ContractMode>;
  /** fetch aggregated fields from the table: "contract_mode" */
  contractModeAggregate: ContractModeAggregate;
  /** fetch data from the table: "contract_mode" using primary key columns */
  contractModeByPk?: Maybe<ContractMode>;
  /** fetch data from the table in a streaming manner: "contract_mode" */
  contractModeStream: Array<ContractMode>;
  /** fetch data from the table: "contract_period" */
  contractPeriod: Array<ContractPeriod>;
  /** fetch aggregated fields from the table: "contract_period" */
  contractPeriodAggregate: ContractPeriodAggregate;
  /** fetch data from the table: "contract_period" using primary key columns */
  contractPeriodByPk?: Maybe<ContractPeriod>;
  /** fetch data from the table: "contract_period_document" */
  contractPeriodDocument: Array<ContractPeriodDocument>;
  /** fetch aggregated fields from the table: "contract_period_document" */
  contractPeriodDocumentAggregate: ContractPeriodDocumentAggregate;
  /** fetch data from the table: "contract_period_document" using primary key columns */
  contractPeriodDocumentByPk?: Maybe<ContractPeriodDocument>;
  /** fetch data from the table: "contract_period_document_status" */
  contractPeriodDocumentStatus: Array<ContractPeriodDocumentStatus>;
  /** fetch aggregated fields from the table: "contract_period_document_status" */
  contractPeriodDocumentStatusAggregate: ContractPeriodDocumentStatusAggregate;
  /** fetch data from the table: "contract_period_document_status" using primary key columns */
  contractPeriodDocumentStatusByPk?: Maybe<ContractPeriodDocumentStatus>;
  /** fetch data from the table in a streaming manner: "contract_period_document_status" */
  contractPeriodDocumentStatusStream: Array<ContractPeriodDocumentStatus>;
  /** fetch data from the table in a streaming manner: "contract_period_document" */
  contractPeriodDocumentStream: Array<ContractPeriodDocument>;
  /** fetch data from the table: "contract_period_document_type" */
  contractPeriodDocumentType: Array<ContractPeriodDocumentType>;
  /** fetch aggregated fields from the table: "contract_period_document_type" */
  contractPeriodDocumentTypeAggregate: ContractPeriodDocumentTypeAggregate;
  /** fetch data from the table: "contract_period_document_type" using primary key columns */
  contractPeriodDocumentTypeByPk?: Maybe<ContractPeriodDocumentType>;
  /** fetch data from the table in a streaming manner: "contract_period_document_type" */
  contractPeriodDocumentTypeStream: Array<ContractPeriodDocumentType>;
  /** fetch data from the table: "contract_period_status" */
  contractPeriodStatus: Array<ContractPeriodStatus>;
  /** fetch aggregated fields from the table: "contract_period_status" */
  contractPeriodStatusAggregate: ContractPeriodStatusAggregate;
  /** fetch data from the table: "contract_period_status" using primary key columns */
  contractPeriodStatusByPk?: Maybe<ContractPeriodStatus>;
  /** fetch data from the table in a streaming manner: "contract_period_status" */
  contractPeriodStatusStream: Array<ContractPeriodStatus>;
  /** fetch data from the table in a streaming manner: "contract_period" */
  contractPeriodStream: Array<ContractPeriod>;
  /** fetch data from the table in a streaming manner: "contract" */
  contractStream: Array<Contract>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  countryAggregate: CountryAggregate;
  /** fetch data from the table: "country" using primary key columns */
  countryByPk?: Maybe<Country>;
  /** fetch data from the table in a streaming manner: "country" */
  countryStream: Array<Country>;
  /** fetch data from the table: "db_address" */
  dbAddress: Array<DbAddress>;
  /** fetch aggregated fields from the table: "db_address" */
  dbAddressAggregate: DbAddressAggregate;
  /** fetch data from the table: "db_address" using primary key columns */
  dbAddressByPk?: Maybe<DbAddress>;
  /** fetch data from the table in a streaming manner: "db_address" */
  dbAddressStream: Array<DbAddress>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  fileAggregate: FileAggregate;
  /** fetch data from the table: "file" using primary key columns */
  fileByPk?: Maybe<File>;
  /** fetch data from the table in a streaming manner: "file" */
  fileStream: Array<File>;
  /** fetch data from the table: "insurer" */
  insurer: Array<Insurer>;
  /** fetch aggregated fields from the table: "insurer" */
  insurerAggregate: InsurerAggregate;
  /** fetch data from the table: "insurer" using primary key columns */
  insurerByPk?: Maybe<Insurer>;
  /** fetch data from the table in a streaming manner: "insurer" */
  insurerStream: Array<Insurer>;
  /** fetch data from the table: "otp" */
  otp: Array<Otp>;
  /** fetch aggregated fields from the table: "otp" */
  otpAggregate: OtpAggregate;
  /** fetch data from the table: "otp" using primary key columns */
  otpByPk?: Maybe<Otp>;
  /** fetch data from the table in a streaming manner: "otp" */
  otpStream: Array<Otp>;
  /** fetch data from the table: "partner" */
  partner: Array<Partner>;
  /** fetch aggregated fields from the table: "partner" */
  partnerAggregate: PartnerAggregate;
  /** fetch data from the table: "partner" using primary key columns */
  partnerByPk?: Maybe<Partner>;
  /** fetch data from the table: "partner_category" */
  partnerCategory: Array<PartnerCategory>;
  /** fetch aggregated fields from the table: "partner_category" */
  partnerCategoryAggregate: PartnerCategoryAggregate;
  /** fetch data from the table: "partner_category" using primary key columns */
  partnerCategoryByPk?: Maybe<PartnerCategory>;
  /** fetch data from the table in a streaming manner: "partner_category" */
  partnerCategoryStream: Array<PartnerCategory>;
  /** fetch data from the table: "partner_file" */
  partnerFile: Array<PartnerFile>;
  /** fetch aggregated fields from the table: "partner_file" */
  partnerFileAggregate: PartnerFileAggregate;
  /** fetch data from the table: "partner_file" using primary key columns */
  partnerFileByPk?: Maybe<PartnerFile>;
  /** fetch data from the table in a streaming manner: "partner_file" */
  partnerFileStream: Array<PartnerFile>;
  /** fetch data from the table: "partner_file_type" */
  partnerFileType: Array<PartnerFileType>;
  /** fetch aggregated fields from the table: "partner_file_type" */
  partnerFileTypeAggregate: PartnerFileTypeAggregate;
  /** fetch data from the table: "partner_file_type" using primary key columns */
  partnerFileTypeByPk?: Maybe<PartnerFileType>;
  /** fetch data from the table in a streaming manner: "partner_file_type" */
  partnerFileTypeStream: Array<PartnerFileType>;
  /** fetch data from the table: "partner_product" */
  partnerProduct: Array<PartnerProduct>;
  /** fetch aggregated fields from the table: "partner_product" */
  partnerProductAggregate: PartnerProductAggregate;
  /** fetch data from the table: "partner_product" using primary key columns */
  partnerProductByPk?: Maybe<PartnerProduct>;
  /** fetch data from the table in a streaming manner: "partner_product" */
  partnerProductStream: Array<PartnerProduct>;
  /** fetch data from the table in a streaming manner: "partner" */
  partnerStream: Array<Partner>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  productAggregate: ProductAggregate;
  /** fetch data from the table: "product" using primary key columns */
  productByPk?: Maybe<Product>;
  /** fetch data from the table in a streaming manner: "product" */
  productStream: Array<Product>;
  /** fetch data from the table: "promo_code" */
  promoCode: Array<PromoCode>;
  /** fetch aggregated fields from the table: "promo_code" */
  promoCodeAggregate: PromoCodeAggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promoCodeByPk?: Maybe<PromoCode>;
  /** fetch data from the table in a streaming manner: "promo_code" */
  promoCodeStream: Array<PromoCode>;
  /** fetch data from the table: "promo_code_type" */
  promoCodeType: Array<PromoCodeType>;
  /** fetch aggregated fields from the table: "promo_code_type" */
  promoCodeTypeAggregate: PromoCodeTypeAggregate;
  /** fetch data from the table: "promo_code_type" using primary key columns */
  promoCodeTypeByPk?: Maybe<PromoCodeType>;
  /** fetch data from the table in a streaming manner: "promo_code_type" */
  promoCodeTypeStream: Array<PromoCodeType>;
  /** fetch data from the table: "quotation" */
  quotation: Array<Quotation>;
  /** fetch aggregated fields from the table: "quotation" */
  quotationAggregate: QuotationAggregate;
  /** fetch data from the table: "quotation" using primary key columns */
  quotationByPk?: Maybe<Quotation>;
  /** fetch data from the table: "quotation_status" */
  quotationStatus: Array<QuotationStatus>;
  /** fetch aggregated fields from the table: "quotation_status" */
  quotationStatusAggregate: QuotationStatusAggregate;
  /** fetch data from the table: "quotation_status" using primary key columns */
  quotationStatusByPk?: Maybe<QuotationStatus>;
  /** fetch data from the table in a streaming manner: "quotation_status" */
  quotationStatusStream: Array<QuotationStatus>;
  /** fetch data from the table in a streaming manner: "quotation" */
  quotationStream: Array<Quotation>;
  /** fetch data from the table: "retrocession_type" */
  retrocessionType: Array<RetrocessionType>;
  /** fetch aggregated fields from the table: "retrocession_type" */
  retrocessionTypeAggregate: RetrocessionTypeAggregate;
  /** fetch data from the table: "retrocession_type" using primary key columns */
  retrocessionTypeByPk?: Maybe<RetrocessionType>;
  /** fetch data from the table in a streaming manner: "retrocession_type" */
  retrocessionTypeStream: Array<RetrocessionType>;
  /** fetch data from the table: "session" */
  session: Array<Session>;
  /** fetch aggregated fields from the table: "session" */
  sessionAggregate: SessionAggregate;
  /** fetch data from the table: "session" using primary key columns */
  sessionByPk?: Maybe<Session>;
  /** fetch data from the table in a streaming manner: "session" */
  sessionStream: Array<Session>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  userAggregate: UserAggregate;
  /** fetch data from the table: "user" using primary key columns */
  userByPk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  userStream: Array<User>;
};


export type Subscription_RootAccessTokenSigningKeyArgs = {
  distinctOn?: InputMaybe<Array<AccessTokenSigningKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccessTokenSigningKeyOrderBy>>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};


export type Subscription_RootAccessTokenSigningKeyAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccessTokenSigningKeySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccessTokenSigningKeyOrderBy>>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};


export type Subscription_RootAccessTokenSigningKeyByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAccessTokenSigningKeyStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccessTokenSigningKeyStreamCursorInput>>;
  where?: InputMaybe<AccessTokenSigningKeyBoolExp>;
};


export type Subscription_RootAccountArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


export type Subscription_RootAccountAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountOrderBy>>;
  where?: InputMaybe<AccountBoolExp>;
};


export type Subscription_RootAccountByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAccountStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountStreamCursorInput>>;
  where?: InputMaybe<AccountBoolExp>;
};


export type Subscription_RootActivityArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};


export type Subscription_RootActivityAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityOrderBy>>;
  where?: InputMaybe<ActivityBoolExp>;
};


export type Subscription_RootActivityByPkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActivityCategoryArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


export type Subscription_RootActivityCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityCategoryOrderBy>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


export type Subscription_RootActivityCategoryByPkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActivityCategoryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ActivityCategoryStreamCursorInput>>;
  where?: InputMaybe<ActivityCategoryBoolExp>;
};


export type Subscription_RootActivitySectorArgs = {
  distinctOn?: InputMaybe<Array<ActivitySectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivitySectorOrderBy>>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};


export type Subscription_RootActivitySectorAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitySectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivitySectorOrderBy>>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};


export type Subscription_RootActivitySectorByPkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActivitySectorStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ActivitySectorStreamCursorInput>>;
  where?: InputMaybe<ActivitySectorBoolExp>;
};


export type Subscription_RootActivityStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ActivityStreamCursorInput>>;
  where?: InputMaybe<ActivityBoolExp>;
};


export type Subscription_RootAuthProviderArgs = {
  distinctOn?: InputMaybe<Array<AuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthProviderOrderBy>>;
  where?: InputMaybe<AuthProviderBoolExp>;
};


export type Subscription_RootAuthProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<AuthProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AuthProviderOrderBy>>;
  where?: InputMaybe<AuthProviderBoolExp>;
};


export type Subscription_RootAuthProviderByPkArgs = {
  provider: Scalars['String'];
};


export type Subscription_RootAuthProviderStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AuthProviderStreamCursorInput>>;
  where?: InputMaybe<AuthProviderBoolExp>;
};


export type Subscription_RootBrokerArgs = {
  distinctOn?: InputMaybe<Array<BrokerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BrokerOrderBy>>;
  where?: InputMaybe<BrokerBoolExp>;
};


export type Subscription_RootBrokerAggregateArgs = {
  distinctOn?: InputMaybe<Array<BrokerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BrokerOrderBy>>;
  where?: InputMaybe<BrokerBoolExp>;
};


export type Subscription_RootBrokerByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBrokerStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BrokerStreamCursorInput>>;
  where?: InputMaybe<BrokerBoolExp>;
};


export type Subscription_RootContractArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


export type Subscription_RootContractAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractOrderBy>>;
  where?: InputMaybe<ContractBoolExp>;
};


export type Subscription_RootContractByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractModeArgs = {
  distinctOn?: InputMaybe<Array<ContractModeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractModeOrderBy>>;
  where?: InputMaybe<ContractModeBoolExp>;
};


export type Subscription_RootContractModeAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractModeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractModeOrderBy>>;
  where?: InputMaybe<ContractModeBoolExp>;
};


export type Subscription_RootContractModeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootContractModeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractModeStreamCursorInput>>;
  where?: InputMaybe<ContractModeBoolExp>;
};


export type Subscription_RootContractPeriodArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


export type Subscription_RootContractPeriodAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodOrderBy>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


export type Subscription_RootContractPeriodByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractPeriodDocumentArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


export type Subscription_RootContractPeriodDocumentAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


export type Subscription_RootContractPeriodDocumentByPkArgs = {
  contractPeriodId: Scalars['uuid'];
  fileId: Scalars['uuid'];
};


export type Subscription_RootContractPeriodDocumentStatusArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};


export type Subscription_RootContractPeriodDocumentStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};


export type Subscription_RootContractPeriodDocumentStatusByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootContractPeriodDocumentStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractPeriodDocumentStatusStreamCursorInput>>;
  where?: InputMaybe<ContractPeriodDocumentStatusBoolExp>;
};


export type Subscription_RootContractPeriodDocumentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractPeriodDocumentStreamCursorInput>>;
  where?: InputMaybe<ContractPeriodDocumentBoolExp>;
};


export type Subscription_RootContractPeriodDocumentTypeArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentTypeOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};


export type Subscription_RootContractPeriodDocumentTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodDocumentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodDocumentTypeOrderBy>>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};


export type Subscription_RootContractPeriodDocumentTypeByPkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootContractPeriodDocumentTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractPeriodDocumentTypeStreamCursorInput>>;
  where?: InputMaybe<ContractPeriodDocumentTypeBoolExp>;
};


export type Subscription_RootContractPeriodStatusArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};


export type Subscription_RootContractPeriodStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContractPeriodStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContractPeriodStatusOrderBy>>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};


export type Subscription_RootContractPeriodStatusByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootContractPeriodStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractPeriodStatusStreamCursorInput>>;
  where?: InputMaybe<ContractPeriodStatusBoolExp>;
};


export type Subscription_RootContractPeriodStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractPeriodStreamCursorInput>>;
  where?: InputMaybe<ContractPeriodBoolExp>;
};


export type Subscription_RootContractStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContractStreamCursorInput>>;
  where?: InputMaybe<ContractBoolExp>;
};


export type Subscription_RootCountryArgs = {
  distinctOn?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type Subscription_RootCountryAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CountryOrderBy>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type Subscription_RootCountryByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCountryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CountryStreamCursorInput>>;
  where?: InputMaybe<CountryBoolExp>;
};


export type Subscription_RootDbAddressArgs = {
  distinctOn?: InputMaybe<Array<DbAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DbAddressOrderBy>>;
  where?: InputMaybe<DbAddressBoolExp>;
};


export type Subscription_RootDbAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DbAddressOrderBy>>;
  where?: InputMaybe<DbAddressBoolExp>;
};


export type Subscription_RootDbAddressByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDbAddressStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DbAddressStreamCursorInput>>;
  where?: InputMaybe<DbAddressBoolExp>;
};


export type Subscription_RootFileArgs = {
  distinctOn?: InputMaybe<Array<FileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileOrderBy>>;
  where?: InputMaybe<FileBoolExp>;
};


export type Subscription_RootFileAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileOrderBy>>;
  where?: InputMaybe<FileBoolExp>;
};


export type Subscription_RootFileByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFileStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileStreamCursorInput>>;
  where?: InputMaybe<FileBoolExp>;
};


export type Subscription_RootInsurerArgs = {
  distinctOn?: InputMaybe<Array<InsurerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsurerOrderBy>>;
  where?: InputMaybe<InsurerBoolExp>;
};


export type Subscription_RootInsurerAggregateArgs = {
  distinctOn?: InputMaybe<Array<InsurerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InsurerOrderBy>>;
  where?: InputMaybe<InsurerBoolExp>;
};


export type Subscription_RootInsurerByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInsurerStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InsurerStreamCursorInput>>;
  where?: InputMaybe<InsurerBoolExp>;
};


export type Subscription_RootOtpArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


export type Subscription_RootOtpAggregateArgs = {
  distinctOn?: InputMaybe<Array<OtpSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OtpOrderBy>>;
  where?: InputMaybe<OtpBoolExp>;
};


export type Subscription_RootOtpByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOtpStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OtpStreamCursorInput>>;
  where?: InputMaybe<OtpBoolExp>;
};


export type Subscription_RootPartnerArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};


export type Subscription_RootPartnerAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerOrderBy>>;
  where?: InputMaybe<PartnerBoolExp>;
};


export type Subscription_RootPartnerByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerCategoryArgs = {
  distinctOn?: InputMaybe<Array<PartnerCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerCategoryOrderBy>>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};


export type Subscription_RootPartnerCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerCategoryOrderBy>>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};


export type Subscription_RootPartnerCategoryByPkArgs = {
  label: Scalars['String'];
};


export type Subscription_RootPartnerCategoryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerCategoryStreamCursorInput>>;
  where?: InputMaybe<PartnerCategoryBoolExp>;
};


export type Subscription_RootPartnerFileArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


export type Subscription_RootPartnerFileAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileOrderBy>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


export type Subscription_RootPartnerFileByPkArgs = {
  fileId: Scalars['uuid'];
  partnerId: Scalars['uuid'];
};


export type Subscription_RootPartnerFileStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerFileStreamCursorInput>>;
  where?: InputMaybe<PartnerFileBoolExp>;
};


export type Subscription_RootPartnerFileTypeArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileTypeOrderBy>>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};


export type Subscription_RootPartnerFileTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerFileTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerFileTypeOrderBy>>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};


export type Subscription_RootPartnerFileTypeByPkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootPartnerFileTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerFileTypeStreamCursorInput>>;
  where?: InputMaybe<PartnerFileTypeBoolExp>;
};


export type Subscription_RootPartnerProductArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


export type Subscription_RootPartnerProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<PartnerProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PartnerProductOrderBy>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


export type Subscription_RootPartnerProductByPkArgs = {
  partnerId: Scalars['uuid'];
  product: ProductEnum;
};


export type Subscription_RootPartnerProductStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerProductStreamCursorInput>>;
  where?: InputMaybe<PartnerProductBoolExp>;
};


export type Subscription_RootPartnerStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PartnerStreamCursorInput>>;
  where?: InputMaybe<PartnerBoolExp>;
};


export type Subscription_RootProductArgs = {
  distinctOn?: InputMaybe<Array<ProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductOrderBy>>;
  where?: InputMaybe<ProductBoolExp>;
};


export type Subscription_RootProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductOrderBy>>;
  where?: InputMaybe<ProductBoolExp>;
};


export type Subscription_RootProductByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootProductStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ProductStreamCursorInput>>;
  where?: InputMaybe<ProductBoolExp>;
};


export type Subscription_RootPromoCodeArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


export type Subscription_RootPromoCodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeOrderBy>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


export type Subscription_RootPromoCodeByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPromoCodeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PromoCodeStreamCursorInput>>;
  where?: InputMaybe<PromoCodeBoolExp>;
};


export type Subscription_RootPromoCodeTypeArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeTypeOrderBy>>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};


export type Subscription_RootPromoCodeTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromoCodeTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PromoCodeTypeOrderBy>>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};


export type Subscription_RootPromoCodeTypeByPkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootPromoCodeTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PromoCodeTypeStreamCursorInput>>;
  where?: InputMaybe<PromoCodeTypeBoolExp>;
};


export type Subscription_RootQuotationArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};


export type Subscription_RootQuotationAggregateArgs = {
  distinctOn?: InputMaybe<Array<QuotationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationOrderBy>>;
  where?: InputMaybe<QuotationBoolExp>;
};


export type Subscription_RootQuotationByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQuotationStatusArgs = {
  distinctOn?: InputMaybe<Array<QuotationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationStatusOrderBy>>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};


export type Subscription_RootQuotationStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<QuotationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuotationStatusOrderBy>>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};


export type Subscription_RootQuotationStatusByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootQuotationStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QuotationStatusStreamCursorInput>>;
  where?: InputMaybe<QuotationStatusBoolExp>;
};


export type Subscription_RootQuotationStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QuotationStreamCursorInput>>;
  where?: InputMaybe<QuotationBoolExp>;
};


export type Subscription_RootRetrocessionTypeArgs = {
  distinctOn?: InputMaybe<Array<RetrocessionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RetrocessionTypeOrderBy>>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};


export type Subscription_RootRetrocessionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RetrocessionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RetrocessionTypeOrderBy>>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};


export type Subscription_RootRetrocessionTypeByPkArgs = {
  type: Scalars['String'];
};


export type Subscription_RootRetrocessionTypeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RetrocessionTypeStreamCursorInput>>;
  where?: InputMaybe<RetrocessionTypeBoolExp>;
};


export type Subscription_RootSessionArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};


export type Subscription_RootSessionAggregateArgs = {
  distinctOn?: InputMaybe<Array<SessionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SessionOrderBy>>;
  where?: InputMaybe<SessionBoolExp>;
};


export type Subscription_RootSessionByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSessionStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<SessionStreamCursorInput>>;
  where?: InputMaybe<SessionBoolExp>;
};


export type Subscription_RootUserArgs = {
  distinctOn?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type Subscription_RootUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  where?: InputMaybe<UserBoolExp>;
};


export type Subscription_RootUserByPkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserStreamCursorInput>>;
  where?: InputMaybe<UserBoolExp>;
};

export type CreateDealActiveCampaignQueryVariables = Exact<{
  query?: InputMaybe<DealCreateInput>;
}>;


export type CreateDealActiveCampaignQuery = { __typename?: 'query_root', createDealActiveCampaign?: { __typename?: 'DealCreate', number: string, activeCampaignDealId: number, activeCampaignId: number } | null };

export type ActivityFragmentFragment = { __typename?: 'Activity', id: number, label: string, category: { __typename?: 'ActivityCategory', id: number, label: string, sector: { __typename?: 'ActivitySector', id: number, label: string } } };

export type GetActivityQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetActivityQuery = { __typename?: 'query_root', activity?: { __typename?: 'Activity', id: number, label: string, category: { __typename?: 'ActivityCategory', id: number, label: string, sector: { __typename?: 'ActivitySector', id: number, label: string } } } | null };

export type GetActivitySectorsQueryVariables = Exact<{
  filter: ActivityBoolExp;
}>;


export type GetActivitySectorsQuery = { __typename?: 'query_root', sectors: Array<{ __typename?: 'ActivitySector', id: number, label: string }> };

export type GetActivityCategoriesQueryVariables = Exact<{
  sectorId: Scalars['Int'];
  filter: ActivityBoolExp;
}>;


export type GetActivityCategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'ActivityCategory', id: number, label: string }> };

export type GetActivitiesQueryVariables = Exact<{
  categoryId: Scalars['Int'];
  filter: ActivityBoolExp;
}>;


export type GetActivitiesQuery = { __typename?: 'query_root', activities: Array<{ __typename?: 'Activity', id: number, label: string }> };

export type GetActivitiesSuggestionQueryVariables = Exact<{
  query: Scalars['String'];
  product: ProductEnum;
}>;


export type GetActivitiesSuggestionQuery = { __typename?: 'query_root', activities: Array<{ __typename?: 'ActivityResult', id: number, label: string, categoryId: number, categoryLabel: string, sectorId: number, sectorLabel: string }> };

export type RegisterPaymentMethodMutationVariables = Exact<{
  quotationId: Scalars['uuid'];
}>;


export type RegisterPaymentMethodMutation = { __typename?: 'mutation_root', clientSecret: string };

export type CompleteQuotationMutationVariables = Exact<{
  quotationId: Scalars['uuid'];
}>;


export type CompleteQuotationMutation = { __typename?: 'mutation_root', completeQuotation: boolean };

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  contractId: Scalars['uuid'];
}>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'mutation_root', url: string };

export type CompanyAutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type CompanyAutocompleteQuery = { __typename?: 'query_root', suggestions?: Array<{ __typename?: 'CompanySuggestion', siret: string, name: string, activityCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'CompanySuggestionAddress', line1?: string | null, line2?: string | null, city?: string | null, postalCode?: string | null, country?: CountryEnum | null } | null }> | null };

export type MyContractFragment = { __typename?: 'Contract', id: string, number: string, product: ProductEnum, mode: ContractModeEnum, updatedAt: Date, createdAt: Date, companyFoundedAt?: string | null, companyLegalStatus?: string | null, companyNafCode?: string | null, companyName?: string | null, companySiret?: string | null, companyAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null, billingAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null };

export type MyContractPeriodFragment = { __typename?: 'ContractPeriod', id: string, startDate: string, endDate?: string | null, renewalDate?: string | null, status: ContractPeriodStatusEnum, terminateAskedAt?: string | null, terminateAtPeriodEnd: boolean, insurer: { __typename?: 'Insurer', name: string }, broker?: { __typename?: 'Broker', name: string } | null };

export type ContractPeriodDetailsFragment = { __typename?: 'ContractPeriod', details?: { __typename: 'AssistanceDomestiqueContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AssistanceDomestiqueProfessionnelContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AutoContractDetails', activityId: number, brand: string, deductibleAmount: number, guaranteeAmount: number, model: string, package: string, plateNumber: string } | { __typename: 'CyberSecurityContractDetails', activityId: number, deductibleAmount: number, guaranteeAmount: number } | { __typename: 'MreAcheelContractDetails', activityId: number, historicalMonument?: boolean | null, deductibleAmount: number, surfaceArea: number, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'MultiRiskContractDetails', activityId: number, historicalMonument?: boolean | null, contentValue: number, deductibleAmount: number, occupancyType: OccupancyType, surfaceArea: number, packageOption?: MultiRiskPackage | null, operatingLiabilityOption?: boolean | null, legalProtectionOption?: boolean | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossDeductibleAmount?: number | null, financialLossCompensationPeriod?: number | null, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'PublicLiabilityContractDetails', activityIds: Array<number>, deductibleAmount: number, guaranteeAmount: number, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | { __typename: 'PublicLiabilityEcommContractDetails' } | null };

export type ContractPeriodPremiumFragment = { __typename?: 'ContractPeriod', premium: { __typename: 'AssistanceDomestiqueContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AssistanceDomestiqueProfessionnelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoMissionContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'CyberSecurityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DAndOContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DecennialContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'HealthContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'KeyPersonContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LegalContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LifeContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MreAcheelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MultiRiskContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'OtherContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityEcommContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } };

export type ContractPeriodDocumentsFragment = { __typename?: 'ContractPeriod', documents: Array<{ __typename?: 'ContractPeriodDocument', type: ContractPeriodDocumentTypeEnum, status?: ContractPeriodDocumentStatusEnum | null, signatureLink?: string | null, createdAt: Date, updatedAt: Date, file: { __typename?: 'File', id: string, name?: string | null, url: string } }> };

export type FullContractPeriodFragment = { __typename?: 'ContractPeriod', id: string, startDate: string, endDate?: string | null, renewalDate?: string | null, status: ContractPeriodStatusEnum, terminateAskedAt?: string | null, terminateAtPeriodEnd: boolean, insurer: { __typename?: 'Insurer', name: string }, broker?: { __typename?: 'Broker', name: string } | null, premium: { __typename: 'AssistanceDomestiqueContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AssistanceDomestiqueProfessionnelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoMissionContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'CyberSecurityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DAndOContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DecennialContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'HealthContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'KeyPersonContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LegalContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LifeContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MreAcheelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MultiRiskContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'OtherContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityEcommContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } }, details?: { __typename: 'AssistanceDomestiqueContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AssistanceDomestiqueProfessionnelContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AutoContractDetails', activityId: number, brand: string, deductibleAmount: number, guaranteeAmount: number, model: string, package: string, plateNumber: string } | { __typename: 'CyberSecurityContractDetails', activityId: number, deductibleAmount: number, guaranteeAmount: number } | { __typename: 'MreAcheelContractDetails', activityId: number, historicalMonument?: boolean | null, deductibleAmount: number, surfaceArea: number, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'MultiRiskContractDetails', activityId: number, historicalMonument?: boolean | null, contentValue: number, deductibleAmount: number, occupancyType: OccupancyType, surfaceArea: number, packageOption?: MultiRiskPackage | null, operatingLiabilityOption?: boolean | null, legalProtectionOption?: boolean | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossDeductibleAmount?: number | null, financialLossCompensationPeriod?: number | null, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'PublicLiabilityContractDetails', activityIds: Array<number>, deductibleAmount: number, guaranteeAmount: number, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | { __typename: 'PublicLiabilityEcommContractDetails' } | null, documents: Array<{ __typename?: 'ContractPeriodDocument', type: ContractPeriodDocumentTypeEnum, status?: ContractPeriodDocumentStatusEnum | null, signatureLink?: string | null, createdAt: Date, updatedAt: Date, file: { __typename?: 'File', id: string, name?: string | null, url: string } }> };

export type ListContractsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ListContractsQuery = { __typename?: 'query_root', contracts: Array<{ __typename?: 'Contract', id: string, number: string, product: ProductEnum, mode: ContractModeEnum, updatedAt: Date, createdAt: Date, companyFoundedAt?: string | null, companyLegalStatus?: string | null, companyNafCode?: string | null, companyName?: string | null, companySiret?: string | null, contractPeriods: Array<{ __typename?: 'ContractPeriod', id: string, startDate: string, endDate?: string | null, renewalDate?: string | null, status: ContractPeriodStatusEnum, terminateAskedAt?: string | null, terminateAtPeriodEnd: boolean, insurer: { __typename?: 'Insurer', name: string }, broker?: { __typename?: 'Broker', name: string } | null, premium: { __typename: 'AssistanceDomestiqueContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AssistanceDomestiqueProfessionnelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoMissionContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'CyberSecurityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DAndOContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DecennialContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'HealthContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'KeyPersonContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LegalContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LifeContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MreAcheelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MultiRiskContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'OtherContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityEcommContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } }>, companyAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null, billingAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null }> };

export type GetContractCountByUserQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetContractCountByUserQuery = { __typename?: 'query_root', contractAggregate: { __typename?: 'ContractAggregate', aggregate?: { __typename?: 'ContractAggregateFields', totalCount: number } | null } };

export type GetContractQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetContractQuery = { __typename?: 'query_root', contract?: { __typename?: 'Contract', id: string, number: string, product: ProductEnum, mode: ContractModeEnum, updatedAt: Date, createdAt: Date, companyFoundedAt?: string | null, companyLegalStatus?: string | null, companyNafCode?: string | null, companyName?: string | null, companySiret?: string | null, contractPeriods: Array<{ __typename?: 'ContractPeriod', id: string, startDate: string, endDate?: string | null, renewalDate?: string | null, status: ContractPeriodStatusEnum, terminateAskedAt?: string | null, terminateAtPeriodEnd: boolean, insurer: { __typename?: 'Insurer', name: string }, broker?: { __typename?: 'Broker', name: string } | null, premium: { __typename: 'AssistanceDomestiqueContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AssistanceDomestiqueProfessionnelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'AutoMissionContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'CyberSecurityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DAndOContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'DecennialContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'HealthContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'KeyPersonContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LegalContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'LifeContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MreAcheelContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'MultiRiskContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'OtherContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } } | { __typename: 'PublicLiabilityEcommContractPremium', paymentFrequency: PaymentFrequency, totalAfterDiscount?: number | null, applicationFees: { __typename?: 'ApplicationFees', instalmentFees: number, total: number }, base?: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } | null, total: { __typename?: 'MoneyBag', taxExcluded: number, taxIncluded: number, currency: Currency } }, details?: { __typename: 'AssistanceDomestiqueContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AssistanceDomestiqueProfessionnelContractDetails', guaranteeAmount: number, packageOptionAssistance?: AssistanceDomestiquePackage | null } | { __typename: 'AutoContractDetails', activityId: number, brand: string, deductibleAmount: number, guaranteeAmount: number, model: string, package: string, plateNumber: string } | { __typename: 'CyberSecurityContractDetails', activityId: number, deductibleAmount: number, guaranteeAmount: number } | { __typename: 'MreAcheelContractDetails', activityId: number, historicalMonument?: boolean | null, deductibleAmount: number, surfaceArea: number, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'MultiRiskContractDetails', activityId: number, historicalMonument?: boolean | null, contentValue: number, deductibleAmount: number, occupancyType: OccupancyType, surfaceArea: number, packageOption?: MultiRiskPackage | null, operatingLiabilityOption?: boolean | null, legalProtectionOption?: boolean | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossDeductibleAmount?: number | null, financialLossCompensationPeriod?: number | null, address: { __typename?: 'Address', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } } | { __typename: 'PublicLiabilityContractDetails', activityIds: Array<number>, deductibleAmount: number, guaranteeAmount: number, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | { __typename: 'PublicLiabilityEcommContractDetails' } | null, documents: Array<{ __typename?: 'ContractPeriodDocument', type: ContractPeriodDocumentTypeEnum, status?: ContractPeriodDocumentStatusEnum | null, signatureLink?: string | null, createdAt: Date, updatedAt: Date, file: { __typename?: 'File', id: string, name?: string | null, url: string } }> }>, companyAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null, billingAddress?: { __typename?: 'DbAddress', line1: string, line2?: string | null, city: string, postalCode: string, country: CountryEnum } | null } | null };

export type GenerateCertificateQueryVariables = Exact<{
  contractPeriodId: Scalars['uuid'];
}>;


export type GenerateCertificateQuery = { __typename?: 'query_root', getContractDocument: any };

export type GetAllDocumentsWithMissingSignatureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDocumentsWithMissingSignatureQuery = { __typename?: 'query_root', documents: Array<{ __typename?: 'ContractPeriodDocument', fileId: string, contractPeriodId: string, signatureLink?: string | null, contractPeriod: { __typename?: 'ContractPeriod', contract: { __typename?: 'Contract', id: string, number: string, product: ProductEnum } } }> };

export type GetPartnerFromPromoCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetPartnerFromPromoCodeQuery = { __typename?: 'query_root', partners: Array<{ __typename?: 'Partner', id: string, name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null, products: Array<{ __typename?: 'PartnerProduct', product: ProductEnum, displayDuringQuotation: boolean }> }> };

export type GetAllPartnersForCockpitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPartnersForCockpitQuery = { __typename?: 'query_root', partners: Array<{ __typename?: 'Partner', id: string, name: string, category?: string | null, description?: string | null, advantages?: Array<string> | null, displayLogo: boolean, displayCockpit: boolean, affiliateUrl?: string | null, logo?: { __typename?: 'File', url: string, name?: string | null } | null }> };

export type MyQuotationDetailsFragment = { __typename?: 'Quotation', details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null } };

export type MyQuotationPremiumFragment = { __typename?: 'Quotation', premium?: { __typename?: 'QuotationPrice', originalTotal: number, discountedTotal?: number | null, applicationFeesTotal: number, publicLiability?: { __typename?: 'PublicLiabilityQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, worldWideOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, multiRisk?: { __typename?: 'MultiRiskQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, financialLossStandardOption?: number | null, financialLossAdvantageOption?: number | null, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, assistanceOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, allComputerMaterialDamageOption?: number | null, assistanceAndCyberExtortionOption?: number | null, businessInterruptionOption?: number | null, thirdPartyDamageCoverageOption?: number | null, suppliersDeficiencyOption?: number | null, cyberAndTelephoneFraudOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null } | null };

export type MyQuotationCoversFragment = { __typename?: 'Quotation', covers?: { __typename?: 'QuotationCovers', publicLiability?: { __typename?: 'PublicLiabilityQuotationCovers', physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, cyberPublicLiability?: number | null, hackingOfWebsite?: number | null, violationOfPersonalData?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, consequencesOfTheEmployerInexcusableFault?: number | null, consecutiveMaterialAndImmaterialDamages?: number | null, nonConsecutiveImmaterialDamages?: number | null, damageToEntrustedProperty?: number | null, bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: number | null, theftByEmployees?: number | null, virus?: number | null, criminalDefenseRecourse?: number | null, legalProtection?: number | null, deductible?: number | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationCovers', theftProperty?: number | null, vandalismExcludingBuildings?: number | null, fire?: number | null, naturalDisasters?: number | null, glassBreakage?: number | null, machineryBreakdown?: number | null, allComputerRisks?: number | null, waterDamage?: number | null, rentalLiability?: number | null, ownerLiability?: number | null, recourseFromNeighborsAndThirdParties?: number | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationCovers', theftProperty?: string | null, vandalismExcludingBuildings?: string | null, fire?: string | null, naturalDisasters?: string | null, glassBreakage?: string | null, machineryBreakdown?: string | null, allComputerRisks?: string | null, waterDamage?: string | null, rcAvLivraison?: string | null, rcApLivraison?: string | null, Lci?: string | null, chambreFroide?: boolean | null, chocVehiculesTer?: boolean | null, marchandises?: string | null, fraisExploitation?: string | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationCovers', deductible?: number | null, physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: number | null, operatingLiabilityNonConsecutiveImmaterialDamages?: number | null, operatingLiabilityFoodPoisoning?: number | null, operatingLiabilityTheftByEmployees?: number | null, legalProtection?: number | null, allComputerMaterialDamage?: number | null, assistanceAndCyberExtortion?: number | null, businessInterruption?: number | null, thirdPartyDamageCoverage?: number | null, suppliersDeficiency?: number | null, cyberAndTelephoneFraud?: number | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null } | null };

export type MyQuotationFragment = { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null };

export type CreateQuotationMutationVariables = Exact<{
  details?: InputMaybe<QuotationDetailsInput>;
  promoCode?: InputMaybe<Scalars['String']>;
}>;


export type CreateQuotationMutation = { __typename?: 'mutation_root', createQuotation: { __typename?: 'QuotationId', id: string, quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null } } | null } };

export type FillQuotationMutationVariables = Exact<{
  id: Scalars['uuid'];
  details?: InputMaybe<QuotationDetailsInput>;
}>;


export type FillQuotationMutation = { __typename?: 'mutation_root', fillQuotation: { __typename?: 'QuotationId', id: string, quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null }, premium?: { __typename?: 'QuotationPrice', originalTotal: number, discountedTotal?: number | null, applicationFeesTotal: number, publicLiability?: { __typename?: 'PublicLiabilityQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, worldWideOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, multiRisk?: { __typename?: 'MultiRiskQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, financialLossStandardOption?: number | null, financialLossAdvantageOption?: number | null, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, assistanceOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, allComputerMaterialDamageOption?: number | null, assistanceAndCyberExtortionOption?: number | null, businessInterruptionOption?: number | null, thirdPartyDamageCoverageOption?: number | null, suppliersDeficiencyOption?: number | null, cyberAndTelephoneFraudOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null } | null, covers?: { __typename?: 'QuotationCovers', publicLiability?: { __typename?: 'PublicLiabilityQuotationCovers', physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, cyberPublicLiability?: number | null, hackingOfWebsite?: number | null, violationOfPersonalData?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, consequencesOfTheEmployerInexcusableFault?: number | null, consecutiveMaterialAndImmaterialDamages?: number | null, nonConsecutiveImmaterialDamages?: number | null, damageToEntrustedProperty?: number | null, bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: number | null, theftByEmployees?: number | null, virus?: number | null, criminalDefenseRecourse?: number | null, legalProtection?: number | null, deductible?: number | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationCovers', theftProperty?: number | null, vandalismExcludingBuildings?: number | null, fire?: number | null, naturalDisasters?: number | null, glassBreakage?: number | null, machineryBreakdown?: number | null, allComputerRisks?: number | null, waterDamage?: number | null, rentalLiability?: number | null, ownerLiability?: number | null, recourseFromNeighborsAndThirdParties?: number | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationCovers', theftProperty?: string | null, vandalismExcludingBuildings?: string | null, fire?: string | null, naturalDisasters?: string | null, glassBreakage?: string | null, machineryBreakdown?: string | null, allComputerRisks?: string | null, waterDamage?: string | null, rcAvLivraison?: string | null, rcApLivraison?: string | null, Lci?: string | null, chambreFroide?: boolean | null, chocVehiculesTer?: boolean | null, marchandises?: string | null, fraisExploitation?: string | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationCovers', deductible?: number | null, physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: number | null, operatingLiabilityNonConsecutiveImmaterialDamages?: number | null, operatingLiabilityFoodPoisoning?: number | null, operatingLiabilityTheftByEmployees?: number | null, legalProtection?: number | null, allComputerMaterialDamage?: number | null, assistanceAndCyberExtortion?: number | null, businessInterruption?: number | null, thirdPartyDamageCoverage?: number | null, suppliersDeficiency?: number | null, cyberAndTelephoneFraud?: number | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null } | null } | null } };

export type ApplyQuotationPromoCodeMutationVariables = Exact<{
  id: Scalars['uuid'];
  promoCode: Scalars['String'];
}>;


export type ApplyQuotationPromoCodeMutation = { __typename?: 'mutation_root', applyQuotationPromoCode: { __typename: 'ApplyQuotationPromoCodeFailure', error: PromoCodeError } | { __typename: 'QuotationId', id: string, quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null }, premium?: { __typename?: 'QuotationPrice', originalTotal: number, discountedTotal?: number | null, applicationFeesTotal: number, publicLiability?: { __typename?: 'PublicLiabilityQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, worldWideOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, multiRisk?: { __typename?: 'MultiRiskQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, financialLossStandardOption?: number | null, financialLossAdvantageOption?: number | null, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, assistanceOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, allComputerMaterialDamageOption?: number | null, assistanceAndCyberExtortionOption?: number | null, businessInterruptionOption?: number | null, thirdPartyDamageCoverageOption?: number | null, suppliersDeficiencyOption?: number | null, cyberAndTelephoneFraudOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null } | null, covers?: { __typename?: 'QuotationCovers', publicLiability?: { __typename?: 'PublicLiabilityQuotationCovers', physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, cyberPublicLiability?: number | null, hackingOfWebsite?: number | null, violationOfPersonalData?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, consequencesOfTheEmployerInexcusableFault?: number | null, consecutiveMaterialAndImmaterialDamages?: number | null, nonConsecutiveImmaterialDamages?: number | null, damageToEntrustedProperty?: number | null, bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: number | null, theftByEmployees?: number | null, virus?: number | null, criminalDefenseRecourse?: number | null, legalProtection?: number | null, deductible?: number | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationCovers', theftProperty?: number | null, vandalismExcludingBuildings?: number | null, fire?: number | null, naturalDisasters?: number | null, glassBreakage?: number | null, machineryBreakdown?: number | null, allComputerRisks?: number | null, waterDamage?: number | null, rentalLiability?: number | null, ownerLiability?: number | null, recourseFromNeighborsAndThirdParties?: number | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationCovers', theftProperty?: string | null, vandalismExcludingBuildings?: string | null, fire?: string | null, naturalDisasters?: string | null, glassBreakage?: string | null, machineryBreakdown?: string | null, allComputerRisks?: string | null, waterDamage?: string | null, rcAvLivraison?: string | null, rcApLivraison?: string | null, Lci?: string | null, chambreFroide?: boolean | null, chocVehiculesTer?: boolean | null, marchandises?: string | null, fraisExploitation?: string | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationCovers', deductible?: number | null, physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: number | null, operatingLiabilityNonConsecutiveImmaterialDamages?: number | null, operatingLiabilityFoodPoisoning?: number | null, operatingLiabilityTheftByEmployees?: number | null, legalProtection?: number | null, allComputerMaterialDamage?: number | null, assistanceAndCyberExtortion?: number | null, businessInterruption?: number | null, thirdPartyDamageCoverage?: number | null, suppliersDeficiency?: number | null, cyberAndTelephoneFraud?: number | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null } | null } | null } };

export type RemoveQuotationPromoCodeMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type RemoveQuotationPromoCodeMutation = { __typename?: 'mutation_root', removeQuotationPromoCode: { __typename?: 'QuotationId', quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null }, premium?: { __typename?: 'QuotationPrice', originalTotal: number, discountedTotal?: number | null, applicationFeesTotal: number, publicLiability?: { __typename?: 'PublicLiabilityQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, worldWideOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, multiRisk?: { __typename?: 'MultiRiskQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, financialLossStandardOption?: number | null, financialLossAdvantageOption?: number | null, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, assistanceOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, allComputerMaterialDamageOption?: number | null, assistanceAndCyberExtortionOption?: number | null, businessInterruptionOption?: number | null, thirdPartyDamageCoverageOption?: number | null, suppliersDeficiencyOption?: number | null, cyberAndTelephoneFraudOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null } | null, covers?: { __typename?: 'QuotationCovers', publicLiability?: { __typename?: 'PublicLiabilityQuotationCovers', physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, cyberPublicLiability?: number | null, hackingOfWebsite?: number | null, violationOfPersonalData?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, consequencesOfTheEmployerInexcusableFault?: number | null, consecutiveMaterialAndImmaterialDamages?: number | null, nonConsecutiveImmaterialDamages?: number | null, damageToEntrustedProperty?: number | null, bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: number | null, theftByEmployees?: number | null, virus?: number | null, criminalDefenseRecourse?: number | null, legalProtection?: number | null, deductible?: number | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationCovers', theftProperty?: number | null, vandalismExcludingBuildings?: number | null, fire?: number | null, naturalDisasters?: number | null, glassBreakage?: number | null, machineryBreakdown?: number | null, allComputerRisks?: number | null, waterDamage?: number | null, rentalLiability?: number | null, ownerLiability?: number | null, recourseFromNeighborsAndThirdParties?: number | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationCovers', theftProperty?: string | null, vandalismExcludingBuildings?: string | null, fire?: string | null, naturalDisasters?: string | null, glassBreakage?: string | null, machineryBreakdown?: string | null, allComputerRisks?: string | null, waterDamage?: string | null, rcAvLivraison?: string | null, rcApLivraison?: string | null, Lci?: string | null, chambreFroide?: boolean | null, chocVehiculesTer?: boolean | null, marchandises?: string | null, fraisExploitation?: string | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationCovers', deductible?: number | null, physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: number | null, operatingLiabilityNonConsecutiveImmaterialDamages?: number | null, operatingLiabilityFoodPoisoning?: number | null, operatingLiabilityTheftByEmployees?: number | null, legalProtection?: number | null, allComputerMaterialDamage?: number | null, assistanceAndCyberExtortion?: number | null, businessInterruption?: number | null, thirdPartyDamageCoverage?: number | null, suppliersDeficiency?: number | null, cyberAndTelephoneFraud?: number | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null } | null } | null } };

export type GetQuotationQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetQuotationQuery = { __typename?: 'query_root', quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null }, premium?: { __typename?: 'QuotationPrice', originalTotal: number, discountedTotal?: number | null, applicationFeesTotal: number, publicLiability?: { __typename?: 'PublicLiabilityQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, worldWideOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, multiRisk?: { __typename?: 'MultiRiskQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, financialLossStandardOption?: number | null, financialLossAdvantageOption?: number | null, legalProtectionOption?: number | null, operatingLiabilityOption?: number | null, assistanceOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, allComputerMaterialDamageOption?: number | null, assistanceAndCyberExtortionOption?: number | null, businessInterruptionOption?: number | null, thirdPartyDamageCoverageOption?: number | null, suppliersDeficiencyOption?: number | null, cyberAndTelephoneFraudOption?: number | null, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationPremium', originalTotal: number, discountedTotal?: number | null, base: number, applicationFees: { __typename?: 'ApplicationFeesQuotation', instalmentFees: number } } | null } | null, covers?: { __typename?: 'QuotationCovers', publicLiability?: { __typename?: 'PublicLiabilityQuotationCovers', physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, cyberPublicLiability?: number | null, hackingOfWebsite?: number | null, violationOfPersonalData?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, consequencesOfTheEmployerInexcusableFault?: number | null, consecutiveMaterialAndImmaterialDamages?: number | null, nonConsecutiveImmaterialDamages?: number | null, damageToEntrustedProperty?: number | null, bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment?: number | null, theftByEmployees?: number | null, virus?: number | null, criminalDefenseRecourse?: number | null, legalProtection?: number | null, deductible?: number | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationCovers', theftProperty?: number | null, vandalismExcludingBuildings?: number | null, fire?: number | null, naturalDisasters?: number | null, glassBreakage?: number | null, machineryBreakdown?: number | null, allComputerRisks?: number | null, waterDamage?: number | null, rentalLiability?: number | null, ownerLiability?: number | null, recourseFromNeighborsAndThirdParties?: number | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationCovers', theftProperty?: string | null, vandalismExcludingBuildings?: string | null, fire?: string | null, naturalDisasters?: string | null, glassBreakage?: string | null, machineryBreakdown?: string | null, allComputerRisks?: string | null, waterDamage?: string | null, rcAvLivraison?: string | null, rcApLivraison?: string | null, Lci?: string | null, chambreFroide?: boolean | null, chocVehiculesTer?: boolean | null, marchandises?: string | null, fraisExploitation?: string | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationCovers', deductible?: number | null, physicalMaterialAndImmaterialDamagesConsecutiveOrNot?: number | null, unpaidInvoices?: number | null, lossOfAkeyPerson?: number | null, damageToReputationAndBrandImage?: number | null, operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive?: number | null, operatingLiabilityNonConsecutiveImmaterialDamages?: number | null, operatingLiabilityFoodPoisoning?: number | null, operatingLiabilityTheftByEmployees?: number | null, legalProtection?: number | null, allComputerMaterialDamage?: number | null, assistanceAndCyberExtortion?: number | null, businessInterruption?: number | null, thirdPartyDamageCoverage?: number | null, suppliersDeficiency?: number | null, cyberAndTelephoneFraud?: number | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationCovers', electricite?: number | null, serrurieVitrerie?: number | null, plomberie?: number | null, chauffage?: number | null } | null } | null } | null };

export type GetQuotationCrmDealIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetQuotationCrmDealIdQuery = { __typename?: 'query_root', quotation?: { __typename?: 'Quotation', hubspotDealId?: string | null } | null };

export type ListQuotationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListQuotationsQuery = { __typename?: 'query_root', quotations: Array<{ __typename?: 'QuotationId', id: string, quotation?: { __typename?: 'Quotation', id: string, number: string, userId?: string | null, createdAt: Date, updatedAt: Date, hubspotDealId?: string | null, status: QuotationStatusEnum, promoCode?: { __typename?: 'PromoCode', code: string, type: PromoCodeTypeEnum, value: number, partner?: { __typename?: 'Partner', name: string, displayLogo: boolean, logo?: { __typename?: 'File', url: string } | null } | null } | null, details: { __typename?: 'QuotationDetails', products?: Array<ProductEnum> | null, activeCampaignId?: number | null, activeCampaignDealId?: number | null, creation?: boolean | null, paymentFrequency?: PaymentFrequency | null, startDate?: string | null, turnover?: number | null, companyTypeName?: CompanyTypeEnum | null, company?: { __typename?: 'QuotationCompany', name?: string | null, siret?: string | null, nafCode?: string | null, legalStatus?: string | null, foundedAt?: string | null, address?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null } | null, contact?: { __typename?: 'QuotationContact', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, marketingOptIn?: boolean | null, userTypeName?: UserTypeEnum | null } | null, billingAddress?: { __typename?: 'QuotationAddress', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: CountryEnum | null } | null, publicLiability?: { __typename?: 'PublicLiabilityQuotationDetails', activityIds?: Array<number> | null, guaranteeAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, worldWideOption?: boolean | null } | null, multiRisk?: { __typename?: 'MultiRiskQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, contentValue?: number | null, deductibleAmount?: number | null, occupancyType?: OccupancyType | null, surfaceArea?: number | null, packageOption?: MultiRiskPackage | null, assistanceOption?: boolean | null, financialLossStandardOption?: boolean | null, financialLossAdvantageOption?: boolean | null, financialLossCompensationPeriod?: number | null, financialLossDeductibleAmount?: number | null, legalProtectionOption?: boolean | null, operatingLiabilityOption?: boolean | null, address?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, mreAcheel?: { __typename?: 'MreAcheelQuotationDetails', activityId?: number | null, historicalMonument?: boolean | null, deductibleAmount?: number | null, surfaceArea?: number | null, packageOptionMAcheel?: MreAcheelPackage | null, procedureCollective?: boolean | null, resilieNonPaiement?: boolean | null, installElectriqueVerif?: boolean | null, extincteursLocaux?: boolean | null, nbSinistres?: number | null, addressMAcheel?: { __typename?: 'QuotationAddress', city?: string | null, country?: CountryEnum | null, line1?: string | null, line2?: string | null, postalCode?: string | null } | null } | null, publicLiabilityEcomm?: { __typename?: 'PublicLiabilityEcommQuotationDetails', activityId?: number | null, guaranteeAmount?: number | null, allComputerMaterialDamageOption?: boolean | null, allComputerMaterialDamageGuaranteeAmount?: number | null, assistanceAndCyberExtortionOption?: boolean | null, businessInterruptionOption?: boolean | null, thirdPartyDamageCoverageOption?: boolean | null, suppliersDeficiencyOption?: boolean | null, cyberAndTelephoneFraudOption?: boolean | null } | null, assistanceDomestique?: { __typename?: 'AssistanceDomestiqueQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null, assistanceDomestiqueProfessionnel?: { __typename?: 'AssistanceDomestiqueProfessionnelQuotationDetails', guaranteeAmount?: number | null, packageOptionAssistance?: AssistanceDomestiquePackage | null } | null } } | null }> };

export type GetQuotationDocumentQueryVariables = Exact<{
  document: QuotationDocument;
  product: ProductEnum;
  quotationId: Scalars['uuid'];
}>;


export type GetQuotationDocumentQuery = { __typename?: 'query_root', getQuotationDocument: any };

export type GetSignatureLinkForQuotationQueryVariables = Exact<{
  quotationId: Scalars['uuid'];
}>;


export type GetSignatureLinkForQuotationQuery = { __typename?: 'query_root', getSignatureLinkForQuotation?: string | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'query_root', me?: { __typename?: 'UserId', id: string, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, marketingOptIn: boolean, createdAt: Date, updatedAt: Date, userTypeName: string } | null } | null };

export type CheckIfUserEmailExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckIfUserEmailExistsQuery = { __typename?: 'query_root', checkIfUserEmailExists: boolean };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']>;
  userTypeName: Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', updateUserByPk?: { __typename?: 'User', id: string } | null };

export const ActivityFragmentFragmentDoc = `
    fragment ActivityFragment on Activity {
  id
  label
  category {
    id
    label
    sector {
      id
      label
    }
  }
}
    `;
export const MyContractFragmentDoc = `
    fragment MyContract on Contract {
  id
  number
  product
  mode
  updatedAt
  createdAt
  companyAddress {
    line1
    line2
    city
    postalCode
    country
  }
  billingAddress {
    line1
    line2
    city
    postalCode
    country
  }
  companyFoundedAt
  companyLegalStatus
  companyNafCode
  companyName
  companySiret
}
    `;
export const MyContractPeriodFragmentDoc = `
    fragment MyContractPeriod on ContractPeriod {
  id
  startDate
  endDate
  renewalDate
  status
  terminateAskedAt
  terminateAtPeriodEnd
  insurer {
    name
  }
  broker {
    name
  }
}
    `;
export const ContractPeriodPremiumFragmentDoc = `
    fragment ContractPeriodPremium on ContractPeriod {
  premium {
    __typename
    paymentFrequency
    applicationFees {
      instalmentFees
      total
    }
    base {
      taxExcluded
      taxIncluded
      currency
    }
    total {
      taxExcluded
      taxIncluded
      currency
    }
    totalAfterDiscount
  }
}
    `;
export const ContractPeriodDetailsFragmentDoc = `
    fragment ContractPeriodDetails on ContractPeriod {
  details {
    __typename
    ... on AutoContractDetails {
      activityId
      brand
      deductibleAmount
      guaranteeAmount
      model
      package
      plateNumber
    }
    ... on AssistanceDomestiqueContractDetails {
      guaranteeAmount
      packageOptionAssistance
    }
    ... on AssistanceDomestiqueProfessionnelContractDetails {
      guaranteeAmount
      packageOptionAssistance
    }
    ... on CyberSecurityContractDetails {
      activityId
      deductibleAmount
      guaranteeAmount
    }
    ... on MultiRiskContractDetails {
      activityId
      historicalMonument
      contentValue
      deductibleAmount
      occupancyType
      surfaceArea
      address {
        line1
        line2
        city
        postalCode
        country
      }
      packageOption
      operatingLiabilityOption
      legalProtectionOption
      assistanceOption
      financialLossStandardOption
      financialLossAdvantageOption
      financialLossDeductibleAmount
      financialLossCompensationPeriod
    }
    ... on MreAcheelContractDetails {
      activityId
      historicalMonument
      deductibleAmount
      surfaceArea
      addressMAcheel {
        line1
        line2
        city
        postalCode
        country
      }
      packageOptionMAcheel
      procedureCollective
      resilieNonPaiement
      installElectriqueVerif
      extincteursLocaux
      nbSinistres
    }
    ... on PublicLiabilityContractDetails {
      activityIds
      deductibleAmount
      guaranteeAmount
      legalProtectionOption
      operatingLiabilityOption
      worldWideOption
    }
  }
}
    `;
export const ContractPeriodDocumentsFragmentDoc = `
    fragment ContractPeriodDocuments on ContractPeriod {
  documents {
    type
    status
    file {
      id
      name
      url
    }
    signatureLink
    createdAt
    updatedAt
  }
}
    `;
export const FullContractPeriodFragmentDoc = `
    fragment FullContractPeriod on ContractPeriod {
  ...MyContractPeriod
  ...ContractPeriodPremium
  ...ContractPeriodDetails
  ...ContractPeriodDocuments
}
    ${MyContractPeriodFragmentDoc}
${ContractPeriodPremiumFragmentDoc}
${ContractPeriodDetailsFragmentDoc}
${ContractPeriodDocumentsFragmentDoc}`;
export const MyQuotationDetailsFragmentDoc = `
    fragment MyQuotationDetails on Quotation {
  details {
    products
    activeCampaignId
    activeCampaignDealId
    creation
    paymentFrequency
    company {
      address {
        line1
        line2
        postalCode
        city
        country
      }
      name
      siret
      nafCode
      legalStatus
      foundedAt
    }
    contact {
      email
      firstName
      lastName
      phone
      marketingOptIn
      userTypeName
    }
    startDate
    turnover
    companyTypeName
    billingAddress {
      line1
      line2
      postalCode
      city
      country
    }
    publicLiability {
      activityIds
      guaranteeAmount
      legalProtectionOption
      operatingLiabilityOption
      worldWideOption
    }
    multiRisk {
      activityId
      address {
        city
        country
        line1
        line2
        postalCode
        country
      }
      historicalMonument
      contentValue
      deductibleAmount
      occupancyType
      surfaceArea
      packageOption
      assistanceOption
      financialLossStandardOption
      financialLossAdvantageOption
      financialLossCompensationPeriod
      financialLossDeductibleAmount
      legalProtectionOption
      operatingLiabilityOption
    }
    mreAcheel {
      activityId
      addressMAcheel {
        city
        country
        line1
        line2
        postalCode
        country
      }
      historicalMonument
      deductibleAmount
      surfaceArea
      packageOptionMAcheel
      procedureCollective
      resilieNonPaiement
      installElectriqueVerif
      extincteursLocaux
      nbSinistres
    }
    publicLiabilityEcomm {
      activityId
      guaranteeAmount
      allComputerMaterialDamageOption
      allComputerMaterialDamageGuaranteeAmount
      assistanceAndCyberExtortionOption
      businessInterruptionOption
      thirdPartyDamageCoverageOption
      suppliersDeficiencyOption
      cyberAndTelephoneFraudOption
    }
    assistanceDomestique {
      guaranteeAmount
      packageOptionAssistance
    }
    assistanceDomestiqueProfessionnel {
      guaranteeAmount
      packageOptionAssistance
    }
  }
}
    `;
export const MyQuotationPremiumFragmentDoc = `
    fragment MyQuotationPremium on Quotation {
  premium {
    originalTotal
    discountedTotal
    applicationFeesTotal
    publicLiability {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
      legalProtectionOption
      operatingLiabilityOption
      worldWideOption
    }
    multiRisk {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
      financialLossStandardOption
      financialLossAdvantageOption
      legalProtectionOption
      operatingLiabilityOption
      assistanceOption
    }
    mreAcheel {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
    }
    publicLiabilityEcomm {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
      allComputerMaterialDamageOption
      assistanceAndCyberExtortionOption
      businessInterruptionOption
      thirdPartyDamageCoverageOption
      suppliersDeficiencyOption
      cyberAndTelephoneFraudOption
    }
    assistanceDomestique {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
    }
    assistanceDomestiqueProfessionnel {
      originalTotal
      discountedTotal
      base
      applicationFees {
        instalmentFees
      }
    }
  }
}
    `;
export const MyQuotationCoversFragmentDoc = `
    fragment MyQuotationCovers on Quotation {
  covers {
    publicLiability {
      physicalMaterialAndImmaterialDamagesConsecutiveOrNot
      unpaidInvoices
      lossOfAkeyPerson
      damageToReputationAndBrandImage
      cyberPublicLiability
      hackingOfWebsite
      violationOfPersonalData
      operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutiveOrNot
      consequencesOfTheEmployerInexcusableFault
      consecutiveMaterialAndImmaterialDamages
      nonConsecutiveImmaterialDamages
      damageToEntrustedProperty
      bodilyInjuryMaterialAndConsequentialDamagesResultingFromASuddenAndAccidentalDamageToTheEnvironment
      theftByEmployees
      virus
      criminalDefenseRecourse
      legalProtection
      deductible
    }
    multiRisk {
      theftProperty
      vandalismExcludingBuildings
      fire
      naturalDisasters
      glassBreakage
      machineryBreakdown
      allComputerRisks
      waterDamage
      rentalLiability
      ownerLiability
      recourseFromNeighborsAndThirdParties
    }
    mreAcheel {
      theftProperty
      vandalismExcludingBuildings
      fire
      naturalDisasters
      glassBreakage
      machineryBreakdown
      allComputerRisks
      waterDamage
      rcAvLivraison
      rcApLivraison
      Lci
      chambreFroide
      chocVehiculesTer
      marchandises
      fraisExploitation
    }
    publicLiabilityEcomm {
      deductible
      physicalMaterialAndImmaterialDamagesConsecutiveOrNot
      unpaidInvoices
      lossOfAkeyPerson
      damageToReputationAndBrandImage
      operatingLiabilityPhysicalMaterialAndImmaterialDamagesConsecutive
      operatingLiabilityNonConsecutiveImmaterialDamages
      operatingLiabilityFoodPoisoning
      operatingLiabilityTheftByEmployees
      legalProtection
      allComputerMaterialDamage
      assistanceAndCyberExtortion
      businessInterruption
      thirdPartyDamageCoverage
      suppliersDeficiency
      cyberAndTelephoneFraud
    }
    assistanceDomestique {
      electricite
      serrurieVitrerie
      plomberie
      chauffage
    }
    assistanceDomestiqueProfessionnel {
      electricite
      serrurieVitrerie
      plomberie
      chauffage
    }
  }
}
    `;
export const MyQuotationFragmentDoc = `
    fragment MyQuotation on Quotation {
  id
  number
  userId
  createdAt
  updatedAt
  userId
  hubspotDealId
  status
  promoCode {
    code
    type
    value
    partner {
      name
      logo {
        url
      }
      displayLogo
    }
  }
}
    `;
export const CreateDealActiveCampaignDocument = `
    query createDealActiveCampaign($query: DealCreateInput) {
  createDealActiveCampaign(query: $query) {
    number
    activeCampaignDealId
    activeCampaignId
  }
}
    `;
export const useCreateDealActiveCampaignQuery = <
      TData = CreateDealActiveCampaignQuery,
      TError = unknown
    >(
      variables?: CreateDealActiveCampaignQueryVariables,
      options?: UseQueryOptions<CreateDealActiveCampaignQuery, TError, TData>
    ) =>
    useQuery<CreateDealActiveCampaignQuery, TError, TData>(
      variables === undefined ? ['createDealActiveCampaign'] : ['createDealActiveCampaign', variables],
      fetchData<CreateDealActiveCampaignQuery, CreateDealActiveCampaignQueryVariables>(CreateDealActiveCampaignDocument, variables),
      options
    );

useCreateDealActiveCampaignQuery.getKey = (variables?: CreateDealActiveCampaignQueryVariables) => variables === undefined ? ['createDealActiveCampaign'] : ['createDealActiveCampaign', variables];
;

export const useInfiniteCreateDealActiveCampaignQuery = <
      TData = CreateDealActiveCampaignQuery,
      TError = unknown
    >(
      pageParamKey: keyof CreateDealActiveCampaignQueryVariables,
      variables?: CreateDealActiveCampaignQueryVariables,
      options?: UseInfiniteQueryOptions<CreateDealActiveCampaignQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CreateDealActiveCampaignQuery, TError, TData>(
      variables === undefined ? ['createDealActiveCampaign.infinite'] : ['createDealActiveCampaign.infinite', variables],
      (metaData) => fetchData<CreateDealActiveCampaignQuery, CreateDealActiveCampaignQueryVariables>(CreateDealActiveCampaignDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCreateDealActiveCampaignQuery.getKey = (variables?: CreateDealActiveCampaignQueryVariables) => variables === undefined ? ['createDealActiveCampaign.infinite'] : ['createDealActiveCampaign.infinite', variables];
;

export const GetActivityDocument = `
    query GetActivity($id: Int!) {
  activity: activityByPk(id: $id) {
    ...ActivityFragment
  }
}
    ${ActivityFragmentFragmentDoc}`;
export const useGetActivityQuery = <
      TData = GetActivityQuery,
      TError = unknown
    >(
      variables: GetActivityQueryVariables,
      options?: UseQueryOptions<GetActivityQuery, TError, TData>
    ) =>
    useQuery<GetActivityQuery, TError, TData>(
      ['GetActivity', variables],
      fetchData<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, variables),
      options
    );

useGetActivityQuery.getKey = (variables: GetActivityQueryVariables) => ['GetActivity', variables];
;

export const useInfiniteGetActivityQuery = <
      TData = GetActivityQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetActivityQueryVariables,
      variables: GetActivityQueryVariables,
      options?: UseInfiniteQueryOptions<GetActivityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetActivityQuery, TError, TData>(
      ['GetActivity.infinite', variables],
      (metaData) => fetchData<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetActivityQuery.getKey = (variables: GetActivityQueryVariables) => ['GetActivity.infinite', variables];
;

export const GetActivitySectorsDocument = `
    query GetActivitySectors($filter: ActivityBoolExp!) {
  sectors: activitySector(
    orderBy: {label: ASC}
    where: {categories: {activitiesAggregate: {count: {filter: $filter, predicate: {_gt: 0}}}}}
  ) {
    id
    label
  }
}
    `;
export const useGetActivitySectorsQuery = <
      TData = GetActivitySectorsQuery,
      TError = unknown
    >(
      variables: GetActivitySectorsQueryVariables,
      options?: UseQueryOptions<GetActivitySectorsQuery, TError, TData>
    ) =>
    useQuery<GetActivitySectorsQuery, TError, TData>(
      ['GetActivitySectors', variables],
      fetchData<GetActivitySectorsQuery, GetActivitySectorsQueryVariables>(GetActivitySectorsDocument, variables),
      options
    );

useGetActivitySectorsQuery.getKey = (variables: GetActivitySectorsQueryVariables) => ['GetActivitySectors', variables];
;

export const useInfiniteGetActivitySectorsQuery = <
      TData = GetActivitySectorsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetActivitySectorsQueryVariables,
      variables: GetActivitySectorsQueryVariables,
      options?: UseInfiniteQueryOptions<GetActivitySectorsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetActivitySectorsQuery, TError, TData>(
      ['GetActivitySectors.infinite', variables],
      (metaData) => fetchData<GetActivitySectorsQuery, GetActivitySectorsQueryVariables>(GetActivitySectorsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetActivitySectorsQuery.getKey = (variables: GetActivitySectorsQueryVariables) => ['GetActivitySectors.infinite', variables];
;

export const GetActivityCategoriesDocument = `
    query GetActivityCategories($sectorId: Int!, $filter: ActivityBoolExp!) {
  categories: activityCategory(
    orderBy: {label: ASC}
    where: {sectorId: {_eq: $sectorId}, activitiesAggregate: {count: {filter: $filter, predicate: {_gt: 0}}}}
  ) {
    id
    label
  }
}
    `;
export const useGetActivityCategoriesQuery = <
      TData = GetActivityCategoriesQuery,
      TError = unknown
    >(
      variables: GetActivityCategoriesQueryVariables,
      options?: UseQueryOptions<GetActivityCategoriesQuery, TError, TData>
    ) =>
    useQuery<GetActivityCategoriesQuery, TError, TData>(
      ['GetActivityCategories', variables],
      fetchData<GetActivityCategoriesQuery, GetActivityCategoriesQueryVariables>(GetActivityCategoriesDocument, variables),
      options
    );

useGetActivityCategoriesQuery.getKey = (variables: GetActivityCategoriesQueryVariables) => ['GetActivityCategories', variables];
;

export const useInfiniteGetActivityCategoriesQuery = <
      TData = GetActivityCategoriesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetActivityCategoriesQueryVariables,
      variables: GetActivityCategoriesQueryVariables,
      options?: UseInfiniteQueryOptions<GetActivityCategoriesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetActivityCategoriesQuery, TError, TData>(
      ['GetActivityCategories.infinite', variables],
      (metaData) => fetchData<GetActivityCategoriesQuery, GetActivityCategoriesQueryVariables>(GetActivityCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetActivityCategoriesQuery.getKey = (variables: GetActivityCategoriesQueryVariables) => ['GetActivityCategories.infinite', variables];
;

export const GetActivitiesDocument = `
    query GetActivities($categoryId: Int!, $filter: ActivityBoolExp!) {
  activities: activity(
    orderBy: {label: ASC}
    where: {_and: [{categoryId: {_eq: $categoryId}}, $filter]}
  ) {
    id
    label
  }
}
    `;
export const useGetActivitiesQuery = <
      TData = GetActivitiesQuery,
      TError = unknown
    >(
      variables: GetActivitiesQueryVariables,
      options?: UseQueryOptions<GetActivitiesQuery, TError, TData>
    ) =>
    useQuery<GetActivitiesQuery, TError, TData>(
      ['GetActivities', variables],
      fetchData<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, variables),
      options
    );

useGetActivitiesQuery.getKey = (variables: GetActivitiesQueryVariables) => ['GetActivities', variables];
;

export const useInfiniteGetActivitiesQuery = <
      TData = GetActivitiesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetActivitiesQueryVariables,
      variables: GetActivitiesQueryVariables,
      options?: UseInfiniteQueryOptions<GetActivitiesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetActivitiesQuery, TError, TData>(
      ['GetActivities.infinite', variables],
      (metaData) => fetchData<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetActivitiesQuery.getKey = (variables: GetActivitiesQueryVariables) => ['GetActivities.infinite', variables];
;

export const GetActivitiesSuggestionDocument = `
    query GetActivitiesSuggestion($query: String!, $product: ProductEnum!) {
  activities: searchActivities(query: $query, product: $product) {
    id
    label
    categoryId
    categoryLabel
    sectorId
    sectorLabel
  }
}
    `;
export const useGetActivitiesSuggestionQuery = <
      TData = GetActivitiesSuggestionQuery,
      TError = unknown
    >(
      variables: GetActivitiesSuggestionQueryVariables,
      options?: UseQueryOptions<GetActivitiesSuggestionQuery, TError, TData>
    ) =>
    useQuery<GetActivitiesSuggestionQuery, TError, TData>(
      ['GetActivitiesSuggestion', variables],
      fetchData<GetActivitiesSuggestionQuery, GetActivitiesSuggestionQueryVariables>(GetActivitiesSuggestionDocument, variables),
      options
    );

useGetActivitiesSuggestionQuery.getKey = (variables: GetActivitiesSuggestionQueryVariables) => ['GetActivitiesSuggestion', variables];
;

export const useInfiniteGetActivitiesSuggestionQuery = <
      TData = GetActivitiesSuggestionQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetActivitiesSuggestionQueryVariables,
      variables: GetActivitiesSuggestionQueryVariables,
      options?: UseInfiniteQueryOptions<GetActivitiesSuggestionQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetActivitiesSuggestionQuery, TError, TData>(
      ['GetActivitiesSuggestion.infinite', variables],
      (metaData) => fetchData<GetActivitiesSuggestionQuery, GetActivitiesSuggestionQueryVariables>(GetActivitiesSuggestionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetActivitiesSuggestionQuery.getKey = (variables: GetActivitiesSuggestionQueryVariables) => ['GetActivitiesSuggestion.infinite', variables];
;

export const RegisterPaymentMethodDocument = `
    mutation registerPaymentMethod($quotationId: uuid!) {
  clientSecret: registerPaymentMethod(quotationId: $quotationId)
}
    `;
export const useRegisterPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegisterPaymentMethodMutation, TError, RegisterPaymentMethodMutationVariables, TContext>) =>
    useMutation<RegisterPaymentMethodMutation, TError, RegisterPaymentMethodMutationVariables, TContext>(
      ['registerPaymentMethod'],
      (variables?: RegisterPaymentMethodMutationVariables) => fetchData<RegisterPaymentMethodMutation, RegisterPaymentMethodMutationVariables>(RegisterPaymentMethodDocument, variables)(),
      options
    );
export const CompleteQuotationDocument = `
    mutation completeQuotation($quotationId: uuid!) {
  completeQuotation(quotationId: $quotationId)
}
    `;
export const useCompleteQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteQuotationMutation, TError, CompleteQuotationMutationVariables, TContext>) =>
    useMutation<CompleteQuotationMutation, TError, CompleteQuotationMutationVariables, TContext>(
      ['completeQuotation'],
      (variables?: CompleteQuotationMutationVariables) => fetchData<CompleteQuotationMutation, CompleteQuotationMutationVariables>(CompleteQuotationDocument, variables)(),
      options
    );
export const CreateCustomerPortalSessionDocument = `
    mutation createCustomerPortalSession($contractId: uuid!) {
  url: createStripeCustomerPortalSession(contractId: $contractId)
}
    `;
export const useCreateCustomerPortalSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerPortalSessionMutation, TError, CreateCustomerPortalSessionMutationVariables, TContext>) =>
    useMutation<CreateCustomerPortalSessionMutation, TError, CreateCustomerPortalSessionMutationVariables, TContext>(
      ['createCustomerPortalSession'],
      (variables?: CreateCustomerPortalSessionMutationVariables) => fetchData<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>(CreateCustomerPortalSessionDocument, variables)(),
      options
    );
export const CompanyAutocompleteDocument = `
    query companyAutocomplete($query: String!) {
  suggestions: companyAutocomplete(query: $query) {
    siret
    name
    activityCode
    legalStatus
    foundedAt
    address {
      line1
      line2
      city
      postalCode
      country
    }
  }
}
    `;
export const useCompanyAutocompleteQuery = <
      TData = CompanyAutocompleteQuery,
      TError = unknown
    >(
      variables: CompanyAutocompleteQueryVariables,
      options?: UseQueryOptions<CompanyAutocompleteQuery, TError, TData>
    ) =>
    useQuery<CompanyAutocompleteQuery, TError, TData>(
      ['companyAutocomplete', variables],
      fetchData<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, variables),
      options
    );

useCompanyAutocompleteQuery.getKey = (variables: CompanyAutocompleteQueryVariables) => ['companyAutocomplete', variables];
;

export const useInfiniteCompanyAutocompleteQuery = <
      TData = CompanyAutocompleteQuery,
      TError = unknown
    >(
      pageParamKey: keyof CompanyAutocompleteQueryVariables,
      variables: CompanyAutocompleteQueryVariables,
      options?: UseInfiniteQueryOptions<CompanyAutocompleteQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CompanyAutocompleteQuery, TError, TData>(
      ['companyAutocomplete.infinite', variables],
      (metaData) => fetchData<CompanyAutocompleteQuery, CompanyAutocompleteQueryVariables>(CompanyAutocompleteDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCompanyAutocompleteQuery.getKey = (variables: CompanyAutocompleteQueryVariables) => ['companyAutocomplete.infinite', variables];
;

export const ListContractsDocument = `
    query listContracts($userId: uuid!, $limit: Int, $offset: Int) {
  contracts: contract(
    where: {userId: {_eq: $userId}}
    orderBy: {createdAt: DESC}
    limit: $limit
    offset: $offset
  ) {
    contractPeriods(orderBy: {startDate: DESC}, limit: 10) {
      ...MyContractPeriod
      ...ContractPeriodPremium
    }
    ...MyContract
  }
}
    ${MyContractPeriodFragmentDoc}
${ContractPeriodPremiumFragmentDoc}
${MyContractFragmentDoc}`;
export const useListContractsQuery = <
      TData = ListContractsQuery,
      TError = unknown
    >(
      variables: ListContractsQueryVariables,
      options?: UseQueryOptions<ListContractsQuery, TError, TData>
    ) =>
    useQuery<ListContractsQuery, TError, TData>(
      ['listContracts', variables],
      fetchData<ListContractsQuery, ListContractsQueryVariables>(ListContractsDocument, variables),
      options
    );

useListContractsQuery.getKey = (variables: ListContractsQueryVariables) => ['listContracts', variables];
;

export const useInfiniteListContractsQuery = <
      TData = ListContractsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListContractsQueryVariables,
      variables: ListContractsQueryVariables,
      options?: UseInfiniteQueryOptions<ListContractsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListContractsQuery, TError, TData>(
      ['listContracts.infinite', variables],
      (metaData) => fetchData<ListContractsQuery, ListContractsQueryVariables>(ListContractsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteListContractsQuery.getKey = (variables: ListContractsQueryVariables) => ['listContracts.infinite', variables];
;

export const GetContractCountByUserDocument = `
    query getContractCountByUser($userId: uuid!) {
  contractAggregate(where: {user: {id: {_eq: $userId}}}) {
    aggregate {
      totalCount: count
    }
  }
}
    `;
export const useGetContractCountByUserQuery = <
      TData = GetContractCountByUserQuery,
      TError = unknown
    >(
      variables: GetContractCountByUserQueryVariables,
      options?: UseQueryOptions<GetContractCountByUserQuery, TError, TData>
    ) =>
    useQuery<GetContractCountByUserQuery, TError, TData>(
      ['getContractCountByUser', variables],
      fetchData<GetContractCountByUserQuery, GetContractCountByUserQueryVariables>(GetContractCountByUserDocument, variables),
      options
    );

useGetContractCountByUserQuery.getKey = (variables: GetContractCountByUserQueryVariables) => ['getContractCountByUser', variables];
;

export const useInfiniteGetContractCountByUserQuery = <
      TData = GetContractCountByUserQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetContractCountByUserQueryVariables,
      variables: GetContractCountByUserQueryVariables,
      options?: UseInfiniteQueryOptions<GetContractCountByUserQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetContractCountByUserQuery, TError, TData>(
      ['getContractCountByUser.infinite', variables],
      (metaData) => fetchData<GetContractCountByUserQuery, GetContractCountByUserQueryVariables>(GetContractCountByUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetContractCountByUserQuery.getKey = (variables: GetContractCountByUserQueryVariables) => ['getContractCountByUser.infinite', variables];
;

export const GetContractDocument = `
    query getContract($id: uuid!) {
  contract: contractByPk(id: $id) {
    ...MyContract
    contractPeriods(orderBy: {startDate: DESC}) {
      ...FullContractPeriod
    }
  }
}
    ${MyContractFragmentDoc}
${FullContractPeriodFragmentDoc}`;
export const useGetContractQuery = <
      TData = GetContractQuery,
      TError = unknown
    >(
      variables: GetContractQueryVariables,
      options?: UseQueryOptions<GetContractQuery, TError, TData>
    ) =>
    useQuery<GetContractQuery, TError, TData>(
      ['getContract', variables],
      fetchData<GetContractQuery, GetContractQueryVariables>(GetContractDocument, variables),
      options
    );

useGetContractQuery.getKey = (variables: GetContractQueryVariables) => ['getContract', variables];
;

export const useInfiniteGetContractQuery = <
      TData = GetContractQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetContractQueryVariables,
      variables: GetContractQueryVariables,
      options?: UseInfiniteQueryOptions<GetContractQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetContractQuery, TError, TData>(
      ['getContract.infinite', variables],
      (metaData) => fetchData<GetContractQuery, GetContractQueryVariables>(GetContractDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetContractQuery.getKey = (variables: GetContractQueryVariables) => ['getContract.infinite', variables];
;

export const GenerateCertificateDocument = `
    query generateCertificate($contractPeriodId: uuid!) {
  getContractDocument(document: CERTIFICATE, contractPeriodId: $contractPeriodId)
}
    `;
export const useGenerateCertificateQuery = <
      TData = GenerateCertificateQuery,
      TError = unknown
    >(
      variables: GenerateCertificateQueryVariables,
      options?: UseQueryOptions<GenerateCertificateQuery, TError, TData>
    ) =>
    useQuery<GenerateCertificateQuery, TError, TData>(
      ['generateCertificate', variables],
      fetchData<GenerateCertificateQuery, GenerateCertificateQueryVariables>(GenerateCertificateDocument, variables),
      options
    );

useGenerateCertificateQuery.getKey = (variables: GenerateCertificateQueryVariables) => ['generateCertificate', variables];
;

export const useInfiniteGenerateCertificateQuery = <
      TData = GenerateCertificateQuery,
      TError = unknown
    >(
      pageParamKey: keyof GenerateCertificateQueryVariables,
      variables: GenerateCertificateQueryVariables,
      options?: UseInfiniteQueryOptions<GenerateCertificateQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GenerateCertificateQuery, TError, TData>(
      ['generateCertificate.infinite', variables],
      (metaData) => fetchData<GenerateCertificateQuery, GenerateCertificateQueryVariables>(GenerateCertificateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGenerateCertificateQuery.getKey = (variables: GenerateCertificateQueryVariables) => ['generateCertificate.infinite', variables];
;

export const GetAllDocumentsWithMissingSignatureDocument = `
    query getAllDocumentsWithMissingSignature {
  documents: contractPeriodDocument(
    where: {yousignSignatureRequestId: {_isNull: false}, status: {_eq: UNSIGNED}}
  ) {
    fileId
    contractPeriodId
    signatureLink
    contractPeriod {
      contract {
        id
        number
        product
      }
    }
  }
}
    `;
export const useGetAllDocumentsWithMissingSignatureQuery = <
      TData = GetAllDocumentsWithMissingSignatureQuery,
      TError = unknown
    >(
      variables?: GetAllDocumentsWithMissingSignatureQueryVariables,
      options?: UseQueryOptions<GetAllDocumentsWithMissingSignatureQuery, TError, TData>
    ) =>
    useQuery<GetAllDocumentsWithMissingSignatureQuery, TError, TData>(
      variables === undefined ? ['getAllDocumentsWithMissingSignature'] : ['getAllDocumentsWithMissingSignature', variables],
      fetchData<GetAllDocumentsWithMissingSignatureQuery, GetAllDocumentsWithMissingSignatureQueryVariables>(GetAllDocumentsWithMissingSignatureDocument, variables),
      options
    );

useGetAllDocumentsWithMissingSignatureQuery.getKey = (variables?: GetAllDocumentsWithMissingSignatureQueryVariables) => variables === undefined ? ['getAllDocumentsWithMissingSignature'] : ['getAllDocumentsWithMissingSignature', variables];
;

export const useInfiniteGetAllDocumentsWithMissingSignatureQuery = <
      TData = GetAllDocumentsWithMissingSignatureQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAllDocumentsWithMissingSignatureQueryVariables,
      variables?: GetAllDocumentsWithMissingSignatureQueryVariables,
      options?: UseInfiniteQueryOptions<GetAllDocumentsWithMissingSignatureQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAllDocumentsWithMissingSignatureQuery, TError, TData>(
      variables === undefined ? ['getAllDocumentsWithMissingSignature.infinite'] : ['getAllDocumentsWithMissingSignature.infinite', variables],
      (metaData) => fetchData<GetAllDocumentsWithMissingSignatureQuery, GetAllDocumentsWithMissingSignatureQueryVariables>(GetAllDocumentsWithMissingSignatureDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetAllDocumentsWithMissingSignatureQuery.getKey = (variables?: GetAllDocumentsWithMissingSignatureQueryVariables) => variables === undefined ? ['getAllDocumentsWithMissingSignature.infinite'] : ['getAllDocumentsWithMissingSignature.infinite', variables];
;

export const GetPartnerFromPromoCodeDocument = `
    query GetPartnerFromPromoCode($code: String!) {
  partners: partner(where: {promoCodes: {code: {_eq: $code}}}) {
    id
    name
    logo {
      url
    }
    products {
      product
      displayDuringQuotation
    }
    displayLogo
  }
}
    `;
export const useGetPartnerFromPromoCodeQuery = <
      TData = GetPartnerFromPromoCodeQuery,
      TError = unknown
    >(
      variables: GetPartnerFromPromoCodeQueryVariables,
      options?: UseQueryOptions<GetPartnerFromPromoCodeQuery, TError, TData>
    ) =>
    useQuery<GetPartnerFromPromoCodeQuery, TError, TData>(
      ['GetPartnerFromPromoCode', variables],
      fetchData<GetPartnerFromPromoCodeQuery, GetPartnerFromPromoCodeQueryVariables>(GetPartnerFromPromoCodeDocument, variables),
      options
    );

useGetPartnerFromPromoCodeQuery.getKey = (variables: GetPartnerFromPromoCodeQueryVariables) => ['GetPartnerFromPromoCode', variables];
;

export const useInfiniteGetPartnerFromPromoCodeQuery = <
      TData = GetPartnerFromPromoCodeQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPartnerFromPromoCodeQueryVariables,
      variables: GetPartnerFromPromoCodeQueryVariables,
      options?: UseInfiniteQueryOptions<GetPartnerFromPromoCodeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPartnerFromPromoCodeQuery, TError, TData>(
      ['GetPartnerFromPromoCode.infinite', variables],
      (metaData) => fetchData<GetPartnerFromPromoCodeQuery, GetPartnerFromPromoCodeQueryVariables>(GetPartnerFromPromoCodeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetPartnerFromPromoCodeQuery.getKey = (variables: GetPartnerFromPromoCodeQueryVariables) => ['GetPartnerFromPromoCode.infinite', variables];
;

export const GetAllPartnersForCockpitDocument = `
    query getAllPartnersForCockpit {
  partners: partner(where: {displayCockpit: {_eq: true}}) {
    id
    name
    logo {
      url
      name
    }
    category
    description
    advantages
    displayLogo
    displayCockpit
    affiliateUrl
  }
}
    `;
export const useGetAllPartnersForCockpitQuery = <
      TData = GetAllPartnersForCockpitQuery,
      TError = unknown
    >(
      variables?: GetAllPartnersForCockpitQueryVariables,
      options?: UseQueryOptions<GetAllPartnersForCockpitQuery, TError, TData>
    ) =>
    useQuery<GetAllPartnersForCockpitQuery, TError, TData>(
      variables === undefined ? ['getAllPartnersForCockpit'] : ['getAllPartnersForCockpit', variables],
      fetchData<GetAllPartnersForCockpitQuery, GetAllPartnersForCockpitQueryVariables>(GetAllPartnersForCockpitDocument, variables),
      options
    );

useGetAllPartnersForCockpitQuery.getKey = (variables?: GetAllPartnersForCockpitQueryVariables) => variables === undefined ? ['getAllPartnersForCockpit'] : ['getAllPartnersForCockpit', variables];
;

export const useInfiniteGetAllPartnersForCockpitQuery = <
      TData = GetAllPartnersForCockpitQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAllPartnersForCockpitQueryVariables,
      variables?: GetAllPartnersForCockpitQueryVariables,
      options?: UseInfiniteQueryOptions<GetAllPartnersForCockpitQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAllPartnersForCockpitQuery, TError, TData>(
      variables === undefined ? ['getAllPartnersForCockpit.infinite'] : ['getAllPartnersForCockpit.infinite', variables],
      (metaData) => fetchData<GetAllPartnersForCockpitQuery, GetAllPartnersForCockpitQueryVariables>(GetAllPartnersForCockpitDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetAllPartnersForCockpitQuery.getKey = (variables?: GetAllPartnersForCockpitQueryVariables) => variables === undefined ? ['getAllPartnersForCockpit.infinite'] : ['getAllPartnersForCockpit.infinite', variables];
;

export const CreateQuotationDocument = `
    mutation CreateQuotation($details: QuotationDetailsInput, $promoCode: String) {
  createQuotation(details: $details, promoCode: $promoCode) {
    id
    quotation {
      ...MyQuotation
      ...MyQuotationDetails
    }
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}`;
export const useCreateQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateQuotationMutation, TError, CreateQuotationMutationVariables, TContext>) =>
    useMutation<CreateQuotationMutation, TError, CreateQuotationMutationVariables, TContext>(
      ['CreateQuotation'],
      (variables?: CreateQuotationMutationVariables) => fetchData<CreateQuotationMutation, CreateQuotationMutationVariables>(CreateQuotationDocument, variables)(),
      options
    );
export const FillQuotationDocument = `
    mutation fillQuotation($id: uuid!, $details: QuotationDetailsInput) {
  fillQuotation(id: $id, details: $details) {
    id
    quotation {
      ...MyQuotation
      ...MyQuotationDetails
      ...MyQuotationPremium
      ...MyQuotationCovers
    }
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}
${MyQuotationPremiumFragmentDoc}
${MyQuotationCoversFragmentDoc}`;
export const useFillQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillQuotationMutation, TError, FillQuotationMutationVariables, TContext>) =>
    useMutation<FillQuotationMutation, TError, FillQuotationMutationVariables, TContext>(
      ['fillQuotation'],
      (variables?: FillQuotationMutationVariables) => fetchData<FillQuotationMutation, FillQuotationMutationVariables>(FillQuotationDocument, variables)(),
      options
    );
export const ApplyQuotationPromoCodeDocument = `
    mutation applyQuotationPromoCode($id: uuid!, $promoCode: String!) {
  applyQuotationPromoCode(id: $id, promoCode: $promoCode) {
    __typename
    ... on QuotationId {
      id
      quotation {
        ...MyQuotation
        ...MyQuotationDetails
        ...MyQuotationPremium
        ...MyQuotationCovers
      }
    }
    ... on ApplyQuotationPromoCodeFailure {
      error
    }
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}
${MyQuotationPremiumFragmentDoc}
${MyQuotationCoversFragmentDoc}`;
export const useApplyQuotationPromoCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApplyQuotationPromoCodeMutation, TError, ApplyQuotationPromoCodeMutationVariables, TContext>) =>
    useMutation<ApplyQuotationPromoCodeMutation, TError, ApplyQuotationPromoCodeMutationVariables, TContext>(
      ['applyQuotationPromoCode'],
      (variables?: ApplyQuotationPromoCodeMutationVariables) => fetchData<ApplyQuotationPromoCodeMutation, ApplyQuotationPromoCodeMutationVariables>(ApplyQuotationPromoCodeDocument, variables)(),
      options
    );
export const RemoveQuotationPromoCodeDocument = `
    mutation removeQuotationPromoCode($id: uuid!) {
  removeQuotationPromoCode(id: $id) {
    quotation {
      ...MyQuotation
      ...MyQuotationDetails
      ...MyQuotationPremium
      ...MyQuotationCovers
    }
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}
${MyQuotationPremiumFragmentDoc}
${MyQuotationCoversFragmentDoc}`;
export const useRemoveQuotationPromoCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveQuotationPromoCodeMutation, TError, RemoveQuotationPromoCodeMutationVariables, TContext>) =>
    useMutation<RemoveQuotationPromoCodeMutation, TError, RemoveQuotationPromoCodeMutationVariables, TContext>(
      ['removeQuotationPromoCode'],
      (variables?: RemoveQuotationPromoCodeMutationVariables) => fetchData<RemoveQuotationPromoCodeMutation, RemoveQuotationPromoCodeMutationVariables>(RemoveQuotationPromoCodeDocument, variables)(),
      options
    );
export const GetQuotationDocument = `
    query getQuotation($id: uuid!) {
  quotation: quotationByPk(id: $id) {
    ...MyQuotation
    ...MyQuotationDetails
    ...MyQuotationPremium
    ...MyQuotationCovers
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}
${MyQuotationPremiumFragmentDoc}
${MyQuotationCoversFragmentDoc}`;
export const useGetQuotationQuery = <
      TData = GetQuotationQuery,
      TError = unknown
    >(
      variables: GetQuotationQueryVariables,
      options?: UseQueryOptions<GetQuotationQuery, TError, TData>
    ) =>
    useQuery<GetQuotationQuery, TError, TData>(
      ['getQuotation', variables],
      fetchData<GetQuotationQuery, GetQuotationQueryVariables>(GetQuotationDocument, variables),
      options
    );

useGetQuotationQuery.getKey = (variables: GetQuotationQueryVariables) => ['getQuotation', variables];
;

export const useInfiniteGetQuotationQuery = <
      TData = GetQuotationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetQuotationQueryVariables,
      variables: GetQuotationQueryVariables,
      options?: UseInfiniteQueryOptions<GetQuotationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetQuotationQuery, TError, TData>(
      ['getQuotation.infinite', variables],
      (metaData) => fetchData<GetQuotationQuery, GetQuotationQueryVariables>(GetQuotationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetQuotationQuery.getKey = (variables: GetQuotationQueryVariables) => ['getQuotation.infinite', variables];
;

export const GetQuotationCrmDealIdDocument = `
    query getQuotationCrmDealId($id: uuid!) {
  quotation: quotationByPk(id: $id) {
    hubspotDealId
  }
}
    `;
export const useGetQuotationCrmDealIdQuery = <
      TData = GetQuotationCrmDealIdQuery,
      TError = unknown
    >(
      variables: GetQuotationCrmDealIdQueryVariables,
      options?: UseQueryOptions<GetQuotationCrmDealIdQuery, TError, TData>
    ) =>
    useQuery<GetQuotationCrmDealIdQuery, TError, TData>(
      ['getQuotationCrmDealId', variables],
      fetchData<GetQuotationCrmDealIdQuery, GetQuotationCrmDealIdQueryVariables>(GetQuotationCrmDealIdDocument, variables),
      options
    );

useGetQuotationCrmDealIdQuery.getKey = (variables: GetQuotationCrmDealIdQueryVariables) => ['getQuotationCrmDealId', variables];
;

export const useInfiniteGetQuotationCrmDealIdQuery = <
      TData = GetQuotationCrmDealIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetQuotationCrmDealIdQueryVariables,
      variables: GetQuotationCrmDealIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetQuotationCrmDealIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetQuotationCrmDealIdQuery, TError, TData>(
      ['getQuotationCrmDealId.infinite', variables],
      (metaData) => fetchData<GetQuotationCrmDealIdQuery, GetQuotationCrmDealIdQueryVariables>(GetQuotationCrmDealIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetQuotationCrmDealIdQuery.getKey = (variables: GetQuotationCrmDealIdQueryVariables) => ['getQuotationCrmDealId.infinite', variables];
;

export const ListQuotationsDocument = `
    query listQuotations {
  quotations: listQuotations {
    id
    quotation {
      ...MyQuotation
      ...MyQuotationDetails
    }
  }
}
    ${MyQuotationFragmentDoc}
${MyQuotationDetailsFragmentDoc}`;
export const useListQuotationsQuery = <
      TData = ListQuotationsQuery,
      TError = unknown
    >(
      variables?: ListQuotationsQueryVariables,
      options?: UseQueryOptions<ListQuotationsQuery, TError, TData>
    ) =>
    useQuery<ListQuotationsQuery, TError, TData>(
      variables === undefined ? ['listQuotations'] : ['listQuotations', variables],
      fetchData<ListQuotationsQuery, ListQuotationsQueryVariables>(ListQuotationsDocument, variables),
      options
    );

useListQuotationsQuery.getKey = (variables?: ListQuotationsQueryVariables) => variables === undefined ? ['listQuotations'] : ['listQuotations', variables];
;

export const useInfiniteListQuotationsQuery = <
      TData = ListQuotationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListQuotationsQueryVariables,
      variables?: ListQuotationsQueryVariables,
      options?: UseInfiniteQueryOptions<ListQuotationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListQuotationsQuery, TError, TData>(
      variables === undefined ? ['listQuotations.infinite'] : ['listQuotations.infinite', variables],
      (metaData) => fetchData<ListQuotationsQuery, ListQuotationsQueryVariables>(ListQuotationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteListQuotationsQuery.getKey = (variables?: ListQuotationsQueryVariables) => variables === undefined ? ['listQuotations.infinite'] : ['listQuotations.infinite', variables];
;

export const GetQuotationDocumentDocument = `
    query getQuotationDocument($document: QuotationDocument!, $product: ProductEnum!, $quotationId: uuid!) {
  getQuotationDocument(
    document: $document
    product: $product
    quotationId: $quotationId
  )
}
    `;
export const useGetQuotationDocumentQuery = <
      TData = GetQuotationDocumentQuery,
      TError = unknown
    >(
      variables: GetQuotationDocumentQueryVariables,
      options?: UseQueryOptions<GetQuotationDocumentQuery, TError, TData>
    ) =>
    useQuery<GetQuotationDocumentQuery, TError, TData>(
      ['getQuotationDocument', variables],
      fetchData<GetQuotationDocumentQuery, GetQuotationDocumentQueryVariables>(GetQuotationDocumentDocument, variables),
      options
    );

useGetQuotationDocumentQuery.getKey = (variables: GetQuotationDocumentQueryVariables) => ['getQuotationDocument', variables];
;

export const useInfiniteGetQuotationDocumentQuery = <
      TData = GetQuotationDocumentQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetQuotationDocumentQueryVariables,
      variables: GetQuotationDocumentQueryVariables,
      options?: UseInfiniteQueryOptions<GetQuotationDocumentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetQuotationDocumentQuery, TError, TData>(
      ['getQuotationDocument.infinite', variables],
      (metaData) => fetchData<GetQuotationDocumentQuery, GetQuotationDocumentQueryVariables>(GetQuotationDocumentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetQuotationDocumentQuery.getKey = (variables: GetQuotationDocumentQueryVariables) => ['getQuotationDocument.infinite', variables];
;

export const GetSignatureLinkForQuotationDocument = `
    query getSignatureLinkForQuotation($quotationId: uuid!) {
  getSignatureLinkForQuotation(quotationId: $quotationId)
}
    `;
export const useGetSignatureLinkForQuotationQuery = <
      TData = GetSignatureLinkForQuotationQuery,
      TError = unknown
    >(
      variables: GetSignatureLinkForQuotationQueryVariables,
      options?: UseQueryOptions<GetSignatureLinkForQuotationQuery, TError, TData>
    ) =>
    useQuery<GetSignatureLinkForQuotationQuery, TError, TData>(
      ['getSignatureLinkForQuotation', variables],
      fetchData<GetSignatureLinkForQuotationQuery, GetSignatureLinkForQuotationQueryVariables>(GetSignatureLinkForQuotationDocument, variables),
      options
    );

useGetSignatureLinkForQuotationQuery.getKey = (variables: GetSignatureLinkForQuotationQueryVariables) => ['getSignatureLinkForQuotation', variables];
;

export const useInfiniteGetSignatureLinkForQuotationQuery = <
      TData = GetSignatureLinkForQuotationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSignatureLinkForQuotationQueryVariables,
      variables: GetSignatureLinkForQuotationQueryVariables,
      options?: UseInfiniteQueryOptions<GetSignatureLinkForQuotationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetSignatureLinkForQuotationQuery, TError, TData>(
      ['getSignatureLinkForQuotation.infinite', variables],
      (metaData) => fetchData<GetSignatureLinkForQuotationQuery, GetSignatureLinkForQuotationQueryVariables>(GetSignatureLinkForQuotationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetSignatureLinkForQuotationQuery.getKey = (variables: GetSignatureLinkForQuotationQueryVariables) => ['getSignatureLinkForQuotation.infinite', variables];
;

export const MeDocument = `
    query me {
  me {
    id
    user {
      id
      firstName
      lastName
      email
      phone
      marketingOptIn
      createdAt
      updatedAt
      userTypeName
    }
  }
}
    `;
export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: UseQueryOptions<MeQuery, TError, TData>
    ) =>
    useQuery<MeQuery, TError, TData>(
      variables === undefined ? ['me'] : ['me', variables],
      fetchData<MeQuery, MeQueryVariables>(MeDocument, variables),
      options
    );

useMeQuery.getKey = (variables?: MeQueryVariables) => variables === undefined ? ['me'] : ['me', variables];
;

export const useInfiniteMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      pageParamKey: keyof MeQueryVariables,
      variables?: MeQueryVariables,
      options?: UseInfiniteQueryOptions<MeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MeQuery, TError, TData>(
      variables === undefined ? ['me.infinite'] : ['me.infinite', variables],
      (metaData) => fetchData<MeQuery, MeQueryVariables>(MeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteMeQuery.getKey = (variables?: MeQueryVariables) => variables === undefined ? ['me.infinite'] : ['me.infinite', variables];
;

export const CheckIfUserEmailExistsDocument = `
    query checkIfUserEmailExists($email: String!) {
  checkIfUserEmailExists(email: $email)
}
    `;
export const useCheckIfUserEmailExistsQuery = <
      TData = CheckIfUserEmailExistsQuery,
      TError = unknown
    >(
      variables: CheckIfUserEmailExistsQueryVariables,
      options?: UseQueryOptions<CheckIfUserEmailExistsQuery, TError, TData>
    ) =>
    useQuery<CheckIfUserEmailExistsQuery, TError, TData>(
      ['checkIfUserEmailExists', variables],
      fetchData<CheckIfUserEmailExistsQuery, CheckIfUserEmailExistsQueryVariables>(CheckIfUserEmailExistsDocument, variables),
      options
    );

useCheckIfUserEmailExistsQuery.getKey = (variables: CheckIfUserEmailExistsQueryVariables) => ['checkIfUserEmailExists', variables];
;

export const useInfiniteCheckIfUserEmailExistsQuery = <
      TData = CheckIfUserEmailExistsQuery,
      TError = unknown
    >(
      pageParamKey: keyof CheckIfUserEmailExistsQueryVariables,
      variables: CheckIfUserEmailExistsQueryVariables,
      options?: UseInfiniteQueryOptions<CheckIfUserEmailExistsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckIfUserEmailExistsQuery, TError, TData>(
      ['checkIfUserEmailExists.infinite', variables],
      (metaData) => fetchData<CheckIfUserEmailExistsQuery, CheckIfUserEmailExistsQueryVariables>(CheckIfUserEmailExistsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCheckIfUserEmailExistsQuery.getKey = (variables: CheckIfUserEmailExistsQueryVariables) => ['checkIfUserEmailExists.infinite', variables];
;

export const UpdateUserDocument = `
    mutation updateUser($id: uuid!, $firstName: String!, $lastName: String!, $phone: String, $marketingOptIn: Boolean, $userTypeName: String!) {
  updateUserByPk(
    pkColumns: {id: $id}
    _set: {firstName: $firstName, lastName: $lastName, phone: $phone, marketingOptIn: $marketingOptIn, userTypeName: $userTypeName}
  ) {
    id
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['updateUser'],
      (variables?: UpdateUserMutationVariables) => fetchData<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables)(),
      options
    );